/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never };
import type { TypedDocumentNode as DocumentNode } from "@graphql-typed-document-node/core";
export type AddLabelIngredientInput = {
  name: string;
  parentId?: string | number | null | undefined;
  percentage?: string | number | null | undefined;
  placement?: LabelIngredientPlacement | null | undefined;
  targetId?: string | number | null | undefined;
};

export type AddRecipeIngredientInput = {
  ingredientId?: string | number | null | undefined;
  ingredientType: IngredientType;
  quantity: string | number;
  subRecipeId?: string | number | null | undefined;
  unitId: string | number;
};

export const AllergenType = {
  Celery: "CELERY",
  Crustaceans: "CRUSTACEANS",
  Eggs: "EGGS",
  Fish: "FISH",
  Gluten: "GLUTEN",
  Lupin: "LUPIN",
  Milk: "MILK",
  Molluscs: "MOLLUSCS",
  Mustard: "MUSTARD",
  Peanuts: "PEANUTS",
  Sesame: "SESAME",
  Soybeans: "SOYBEANS",
  Sulphites: "SULPHITES",
  TreeNuts: "TREE_NUTS",
} as const;

export type AllergenType = (typeof AllergenType)[keyof typeof AllergenType];
export type ChangeMemberRoleInput = {
  role: TeamRole;
  userId: string | number;
};

export type CompleteEmailLinkInput = {
  name?: string | null | undefined;
  token: string;
};

export type CreateIngredientInput = {
  brand?: string | null | undefined;
  description?: string | null | undefined;
  genericIngredientId?: string | number | null | undefined;
  language?: string | null | undefined;
  name: string;
  nameForLabel?: string | null | undefined;
  recognizeLabel?: boolean | null | undefined;
  stagingFileIds?: Array<string | number> | null | undefined;
};

export type CreateProducerInput = {
  address?: string | null | undefined;
  companyName: string;
  email?: string | null | undefined;
  phone?: string | null | undefined;
  website?: string | null | undefined;
};

export type CreateRecipeInput = {
  description?: string | null | undefined;
  name: string;
  nameForLabel?: string | null | undefined;
};

export type DuplicateRecipeInput = {
  name: string;
};

export const EmailLinkMode = {
  Login: "LOGIN",
  Signup: "SIGNUP",
} as const;

export type EmailLinkMode = (typeof EmailLinkMode)[keyof typeof EmailLinkMode];
export type IngredientPaginationInput = {
  limit: number;
  offset: number;
  sortDirection?: SortDirection | null | undefined;
  sortField?: IngredientSortField | null | undefined;
};

export const IngredientSortField = {
  CreatedAt: "CREATED_AT",
  Name: "NAME",
  UpdatedAt: "UPDATED_AT",
} as const;

export type IngredientSortField = (typeof IngredientSortField)[keyof typeof IngredientSortField];
export const IngredientSource = {
  Cnf: "CNF",
  Cofid: "COFID",
  Manual: "MANUAL",
  Usda: "USDA",
} as const;

export type IngredientSource = (typeof IngredientSource)[keyof typeof IngredientSource];
export const IngredientType = {
  Ingredient: "INGREDIENT",
  Recipe: "RECIPE",
} as const;

export type IngredientType = (typeof IngredientType)[keyof typeof IngredientType];
export type InviteMemberInput = {
  email: string;
};

export const LabelIngredientAction = {
  IndentIn: "INDENT_IN",
  IndentOut: "INDENT_OUT",
  MoveDown: "MOVE_DOWN",
  MoveUp: "MOVE_UP",
} as const;

export type LabelIngredientAction = (typeof LabelIngredientAction)[keyof typeof LabelIngredientAction];
export const LabelIngredientPlacement = {
  After: "AFTER",
  Before: "BEFORE",
  Inside: "INSIDE",
} as const;

export type LabelIngredientPlacement = (typeof LabelIngredientPlacement)[keyof typeof LabelIngredientPlacement];
export type MoveLabelIngredientInput = {
  action: LabelIngredientAction;
};

export const PlanType = {
  Annual: "ANNUAL",
  Monthly: "MONTHLY",
} as const;

export type PlanType = (typeof PlanType)[keyof typeof PlanType];
export type ProducerPaginationInput = {
  limit: number;
  offset: number;
  sortDirection?: SortDirection | null | undefined;
  sortField?: ProducerSortField | null | undefined;
};

export const ProducerSortField = {
  CreatedAt: "CREATED_AT",
  Name: "NAME",
  UpdatedAt: "UPDATED_AT",
} as const;

export type ProducerSortField = (typeof ProducerSortField)[keyof typeof ProducerSortField];
export type RecipePaginationInput = {
  limit: number;
  offset: number;
  sortDirection?: SortDirection | null | undefined;
  sortField?: RecipeSortField | null | undefined;
};

export const RecipeSortField = {
  CreatedAt: "CREATED_AT",
  Name: "NAME",
  UpdatedAt: "UPDATED_AT",
} as const;

export type RecipeSortField = (typeof RecipeSortField)[keyof typeof RecipeSortField];
export type ReplaceRecipeIngredientInput = {
  ingredientId?: string | number | null | undefined;
  ingredientType: IngredientType;
  subRecipeId?: string | number | null | undefined;
};

export type RequestEmailLinkInput = {
  email: string;
  locale: string;
};

export type SetIngredientReferencePriceInput = {
  includesVat: boolean;
  price: string | number;
  quantity: string | number;
  unitId: string | number;
  vatRate?: string | number | null | undefined;
};

export const SortDirection = {
  Asc: "ASC",
  Desc: "DESC",
} as const;

export type SortDirection = (typeof SortDirection)[keyof typeof SortDirection];
export const SubscriptionStatus = {
  Active: "ACTIVE",
  Canceled: "CANCELED",
  Incomplete: "INCOMPLETE",
  IncompleteExpired: "INCOMPLETE_EXPIRED",
  PastDue: "PAST_DUE",
  Paused: "PAUSED",
  Trialing: "TRIALING",
  Unpaid: "UNPAID",
} as const;

export type SubscriptionStatus = (typeof SubscriptionStatus)[keyof typeof SubscriptionStatus];
export const TaxBehavior = {
  Exclusive: "EXCLUSIVE",
  Inclusive: "INCLUSIVE",
  Unspecified: "UNSPECIFIED",
} as const;

export type TaxBehavior = (typeof TaxBehavior)[keyof typeof TaxBehavior];
export const TeamRole = {
  Admin: "ADMIN",
  Member: "MEMBER",
} as const;

export type TeamRole = (typeof TeamRole)[keyof typeof TeamRole];
export const UnitType = {
  Volume: "VOLUME",
  Weight: "WEIGHT",
} as const;

export type UnitType = (typeof UnitType)[keyof typeof UnitType];
export type UpdateIngredientInput = {
  alcohol?: string | number | null | undefined;
  allergens?: Array<AllergenType> | null | undefined;
  brand?: string | null | undefined;
  carbohydrate?: string | number | null | undefined;
  description?: string | null | undefined;
  fat?: string | number | null | undefined;
  fibre?: string | number | null | undefined;
  genericIngredientId?: string | number | null | undefined;
  name?: string | null | undefined;
  nameForLabel?: string | null | undefined;
  nutritionReferenceQuantity?: string | number | null | undefined;
  nutritionReferenceUnitId?: string | number | null | undefined;
  protein?: string | number | null | undefined;
  salt?: string | number | null | undefined;
  saturatedFat?: string | number | null | undefined;
  sugars?: string | number | null | undefined;
};

export type UpdateLabelIngredientInput = {
  allergens?: Array<AllergenType> | null | undefined;
  name?: string | null | undefined;
  percentage?: string | number | null | undefined;
};

export type UpdateProducerInput = {
  address?: string | null | undefined;
  companyName: string;
  email?: string | null | undefined;
  phone?: string | null | undefined;
  website?: string | null | undefined;
};

export type UpdateRecipeIngredientInput = {
  quantity?: string | number | null | undefined;
  showQuantity?: boolean | null | undefined;
  unitId?: string | number | null | undefined;
};

export type UpdateRecipeInput = {
  allergens?: Array<AllergenType> | null | undefined;
  description?: string | null | undefined;
  name?: string | null | undefined;
  nameForLabel?: string | null | undefined;
  netWeightQuantity?: string | number | null | undefined;
  netWeightUnitId?: string | number | null | undefined;
  producerId?: string | number | null | undefined;
  servingSizeQuantity?: string | number | null | undefined;
  servingSizeUnitId?: string | number | null | undefined;
  servingsPerPackage?: string | number | null | undefined;
  storageRequirements?: string | null | undefined;
  weightAfterCookingQuantity?: string | number | null | undefined;
  weightAfterCookingUnitId?: string | number | null | undefined;
};

export type UpdateTeamSettingsInput = {
  country: string;
  currency: string;
};

export type UpdateUserInput = {
  locale?: string | null | undefined;
  name?: string | null | undefined;
};

export const VariantKind = {
  FullSize: "FULL_SIZE",
  Original: "ORIGINAL",
  Thumbnail: "THUMBNAIL",
} as const;

export type VariantKind = (typeof VariantKind)[keyof typeof VariantKind];
export const VersionStatus = {
  Archived: "ARCHIVED",
  Draft: "DRAFT",
  Published: "PUBLISHED",
} as const;

export type VersionStatus = (typeof VersionStatus)[keyof typeof VersionStatus];
export type FileVariantFragment = {
  __typename: "FileVariantInfo";
  kind: VariantKind;
  url: string;
  contentType: string;
  sizeBytes: string;
  width: number | null;
  height: number | null;
};

export type CollectionFileFragment = {
  __typename: "CollectionFile";
  id: string;
  originalFilename: string | null;
  variants: Array<{ __typename: "FileVariantInfo" } & FileVariantFragment>;
};

export type StagingFileItemFragment = {
  __typename: "StagingFileItem";
  id: string;
  fileId: string;
  originalFilename: string | null;
  createdAt: string;
  variants: Array<{ __typename: "FileVariantInfo" } & FileVariantFragment>;
};

export type UserFragment = {
  __typename: "User";
  id: string;
  name: string;
  email: string;
  locale: string;
  createdAt: string;
  updatedAt: string;
  membership: { __typename: "TeamMember"; role: TeamRole };
};

export type UserBasicFragment = { __typename: "User"; id: string; name: string; email: string };

export type TeamFragment = {
  __typename: "Team";
  id: string;
  createdAt: string;
  updatedAt: string;
  freeAccessUntil: string;
  subscriptionStatus: SubscriptionStatus | null;
  currentPeriodEnd: string | null;
  cancelAt: string | null;
  endedAt: string | null;
  hasFullAccess: boolean;
  currency: string;
  country: string;
};

export type TeamMemberFragment = {
  __typename: "TeamMember";
  id: string;
  teamId: string;
  userId: string;
  role: TeamRole;
  joinedAt: string;
  user: { __typename: "User" } & UserBasicFragment;
};

export type TeamInvitationFragment = {
  __typename: "TeamInvitation";
  id: string;
  teamId: string;
  email: string;
  token: string;
  inviteUrl: string;
  createdAt: string;
  expiresAt: string;
  invitedBy: ({ __typename: "User" } & UserBasicFragment) | null;
};

export type GetCurrentTeamQueryVariables = Exact<{ [key: string]: never }>;

export type GetCurrentTeamQuery = { currentTeam: { __typename: "Team" } & TeamFragment };

export type GetTeamMembersQueryVariables = Exact<{ [key: string]: never }>;

export type GetTeamMembersQuery = { teamMembers: Array<{ __typename: "TeamMember" } & TeamMemberFragment> };

export type UpdateTeamSettingsMutationVariables = Exact<{
  input: UpdateTeamSettingsInput;
}>;

export type UpdateTeamSettingsMutation = { updateTeamSettings: { __typename: "Team" } & TeamFragment };

export type VatRatePresetFragment = { __typename: "VatRatePreset"; id: string; rate: number };

export type GetVatRatePresetsQueryVariables = Exact<{ [key: string]: never }>;

export type GetVatRatePresetsQuery = { vatRatePresets: Array<{ __typename: "VatRatePreset" } & VatRatePresetFragment> };

export type GetPendingTeamInvitationsQueryVariables = Exact<{ [key: string]: never }>;

export type GetPendingTeamInvitationsQuery = {
  pendingTeamInvitations: Array<{ __typename: "TeamInvitation" } & TeamInvitationFragment>;
};

export type GetEmailLinkPreviewQueryVariables = Exact<{
  token: string;
}>;

export type GetEmailLinkPreviewQuery = {
  emailLinkPreview: {
    __typename: "EmailLinkPreview";
    email: string;
    locale: string;
    mode: EmailLinkMode;
    invitation: {
      __typename: "InvitationContext";
      teamId: string;
      inviterName: string | null;
      inviterEmail: string | null;
    } | null;
  } | null;
};

export type RequestEmailLinkMutationVariables = Exact<{
  input: RequestEmailLinkInput;
}>;

export type RequestEmailLinkMutation = { requestEmailLink: boolean };

export type CompleteEmailLinkMutationVariables = Exact<{
  input: CompleteEmailLinkInput;
}>;

export type CompleteEmailLinkMutation = { completeEmailLink: { __typename: "User" } & UserFragment };

export type InviteTeamMemberMutationVariables = Exact<{
  input: InviteMemberInput;
}>;

export type InviteTeamMemberMutation = { inviteMember: { __typename: "TeamInvitation" } & TeamInvitationFragment };

export type CancelTeamInvitationMutationVariables = Exact<{
  invitationId: string | number;
}>;

export type CancelTeamInvitationMutation = { cancelTeamInvitation: boolean };

export type ChangeTeamMemberRoleMutationVariables = Exact<{
  input: ChangeMemberRoleInput;
}>;

export type ChangeTeamMemberRoleMutation = { changeMemberRole: boolean };

export type RemoveTeamMemberMutationVariables = Exact<{
  userId: string | number;
}>;

export type RemoveTeamMemberMutation = { removeTeamMember: boolean };

export type GetCurrentLoggedUserQueryVariables = Exact<{ [key: string]: never }>;

export type GetCurrentLoggedUserQuery = { getCurrentLoggedUser: ({ __typename: "User" } & UserFragment) | null };

export type UpdateUserMutationVariables = Exact<{
  input: UpdateUserInput;
}>;

export type UpdateUserMutation = { updateUser: { __typename: "User" } & UserFragment };

export type LogoutMutationVariables = Exact<{ [key: string]: never }>;

export type LogoutMutation = { logoutUser: boolean };

export type ProducerFragment = {
  __typename: "Producer";
  id: string;
  companyName: string;
  address: string | null;
  email: string | null;
  phone: string | null;
  website: string | null;
  deleted: boolean;
  createdAt: string;
  updatedAt: string;
  createdBy: { __typename: "User" } & UserBasicFragment;
  usedInRecipes: Array<{ __typename: "Recipe"; id: string; name: string }>;
};

export type ListProducersQueryVariables = Exact<{
  search?: string | null | undefined;
  pagination: ProducerPaginationInput;
}>;

export type ListProducersQuery = {
  producers: {
    __typename: "ProducerPageResult";
    total: number;
    producers: Array<{ __typename: "Producer" } & ProducerFragment>;
  };
};

export type GetProducerByIdQueryVariables = Exact<{
  id: string | number;
}>;

export type GetProducerByIdQuery = { producerById: ({ __typename: "Producer" } & ProducerFragment) | null };

export type CreateProducerMutationVariables = Exact<{
  input: CreateProducerInput;
}>;

export type CreateProducerMutation = { createProducer: { __typename: "Producer" } & ProducerFragment };

export type UpdateProducerByIdMutationVariables = Exact<{
  id: string | number;
  input: UpdateProducerInput;
}>;

export type UpdateProducerByIdMutation = { updateProducer: { __typename: "Producer" } & ProducerFragment };

export type DeleteProducerMutationVariables = Exact<{
  id: string | number;
}>;

export type DeleteProducerMutation = { deleteProducer: boolean };

export type RestoreProducerMutationVariables = Exact<{
  id: string | number;
}>;

export type RestoreProducerMutation = { restoreProducer: boolean };

export type NutritionProfileFragment = {
  __typename: "NutritionProfile";
  energyKj: number | null;
  energyKcal: number | null;
  fat: number | null;
  saturatedFat: number | null;
  carbohydrate: number | null;
  sugars: number | null;
  fibre: number | null;
  protein: number | null;
  salt: number | null;
  alcohol: number | null;
};

export type RecipeListFragment = {
  __typename: "Recipe";
  id: string;
  versionStatus: VersionStatus;
  name: string;
  description: string | null;
  hasDraft: boolean;
  hasPublishedVersion: boolean;
  deleted: boolean;
  createdAt: string;
  updatedAt: string;
};

export type RecipeFragment = {
  __typename: "Recipe";
  id: string;
  versionId: string;
  versionNumber: number;
  versionStatus: VersionStatus;
  versionNotes: string | null;
  name: string;
  nameForLabel: string | null;
  description: string | null;
  weightAfterCooking: number | null;
  weightAfterCookingQuantity: number | null;
  weightAfterCookingUnitId: string;
  servingSize: number | null;
  servingSizeQuantity: number | null;
  servingSizeUnitId: string;
  servingsPerPackage: number | null;
  netWeight: number | null;
  netWeightQuantity: number | null;
  netWeightUnitId: string;
  storageRequirements: string | null;
  labelExportUrl: string;
  producerId: string | null;
  allergens: Array<AllergenType>;
  photoCollectionId: string;
  hasDraft: boolean;
  hasPublishedVersion: boolean;
  deleted: boolean;
  createdAt: string;
  updatedAt: string;
  nutritionProfile: ({ __typename: "NutritionProfile" } & NutritionProfileFragment) | null;
  nutritionPerServing: ({ __typename: "NutritionProfile" } & NutritionProfileFragment) | null;
  nutritionPerPackage: ({ __typename: "NutritionProfile" } & NutritionProfileFragment) | null;
};

export type RecipeDetailFragment = {
  __typename: "Recipe";
  createdBy: { __typename: "User" } & UserBasicFragment;
  producer: ({ __typename: "Producer" } & ProducerFragment) | null;
  photos: Array<{ __typename: "CollectionFile" } & CollectionFileFragment>;
  ingredients: Array<
    | ({ __typename: "IngredientRecipeIngredient" } & RecipeIngredientFragment_IngredientRecipeIngredient)
    | ({ __typename: "SubRecipeRecipeIngredient" } & RecipeIngredientFragment_SubRecipeRecipeIngredient)
  >;
  referenceCost: { __typename: "RecipeReferenceCost" } & RecipeReferenceCostFragment;
  usedAsSubRecipeIn: Array<{
    __typename: "UsedByRecipe";
    isOutdated: boolean;
    recipe: { __typename: "Recipe"; id: string; name: string };
  }>;
} & RecipeFragment;

export type RecipeReferenceCostFragment = {
  __typename: "RecipeReferenceCost";
  totalNet: number | null;
  totalGross: number | null;
  perGramNet: number | null;
  perGramGross: number | null;
  per100gNet: number | null;
  per100gGross: number | null;
  perKgNet: number | null;
  perKgGross: number | null;
  perServingNet: number | null;
  perServingGross: number | null;
  perPackageNet: number | null;
  perPackageGross: number | null;
  rows: Array<{
    __typename: "RecipeIngredientCost";
    recipeIngredientId: string;
    net: number | null;
    gross: number | null;
  }>;
};

export type ListRecipesQueryVariables = Exact<{
  search?: string | null | undefined;
  pagination: RecipePaginationInput;
}>;

export type ListRecipesQuery = {
  recipes: {
    __typename: "RecipePageResult";
    total: number;
    recipes: Array<{ __typename: "Recipe" } & RecipeListFragment>;
  };
};

export type GetRecipesQueryVariables = Exact<{
  search?: string | null | undefined;
  pagination: RecipePaginationInput;
}>;

export type GetRecipesQuery = {
  recipes: { __typename: "RecipePageResult"; total: number; recipes: Array<{ __typename: "Recipe" } & RecipeFragment> };
};

export type GetRecipeQueryVariables = Exact<{
  id: string | number;
}>;

export type GetRecipeQuery = {
  draftRecipe: ({ __typename: "Recipe" } & RecipeDetailFragment) | null;
  publishedRecipe: ({ __typename: "Recipe" } & RecipeDetailFragment) | null;
};

export type GetRecipeByVersionQueryVariables = Exact<{
  id: string | number;
  versionNumber: number;
}>;

export type GetRecipeByVersionQuery = { recipeByVersion: ({ __typename: "Recipe" } & RecipeDetailFragment) | null };

export type CreateRecipeMutationVariables = Exact<{
  input: CreateRecipeInput;
}>;

export type CreateRecipeMutation = { createRecipe: { __typename: "Recipe" } & RecipeFragment };

export type DuplicateRecipeMutationVariables = Exact<{
  id: string | number;
  input: DuplicateRecipeInput;
}>;

export type DuplicateRecipeMutation = { duplicateRecipe: { __typename: "Recipe" } & RecipeFragment };

export type UpdateRecipeMutationVariables = Exact<{
  id: string | number;
  input: UpdateRecipeInput;
}>;

export type UpdateRecipeMutation = {
  updateRecipe: {
    __typename: "RecipeMutationPayload";
    refreshedRecipe: { __typename: "Recipe" } & RecipeDetailFragment;
  };
};

export type DeleteRecipeMutationVariables = Exact<{
  id: string | number;
}>;

export type DeleteRecipeMutation = { deleteRecipe: boolean };

export type RestoreRecipeMutationVariables = Exact<{
  id: string | number;
}>;

export type RestoreRecipeMutation = { restoreRecipe: boolean };

export type PublishRecipeMutationVariables = Exact<{
  id: string | number;
  notes?: string | null | undefined;
}>;

export type PublishRecipeMutation = {
  publishRecipe: {
    __typename: "RecipeMutationPayload";
    refreshedRecipe: { __typename: "Recipe" } & RecipeDetailFragment;
  };
};

export type CreateRecipeDraftMutationVariables = Exact<{
  id: string | number;
}>;

export type CreateRecipeDraftMutation = {
  createRecipeDraft: {
    __typename: "RecipeMutationPayload";
    refreshedRecipe: { __typename: "Recipe" } & RecipeDetailFragment;
  };
};

export type DiscardDraftMutationVariables = Exact<{
  id: string | number;
}>;

export type DiscardDraftMutation = { discardDraft: boolean };

export type GenericIngredientFragment = {
  __typename: "GenericIngredient";
  id: string;
  source: IngredientSource;
  sourceId: string | null;
  nameEn: string;
  nameBg: string;
  nameFr: string;
  description: string | null;
  density: number | null;
  allergens: Array<AllergenType>;
  baseNameEn: string | null;
  baseNameBg: string | null;
  baseNameFr: string | null;
  propertiesEn: string | null;
  propertiesBg: string | null;
  propertiesFr: string | null;
  foodCategory: { __typename: "FoodCategory"; id: string; nameEn: string; nameBg: string; nameFr: string } | null;
  nutritionProfile: { __typename: "NutritionProfile" } & NutritionProfileFragment;
};

export type SearchGenericIngredientsQueryVariables = Exact<{
  query: string;
  offset?: number | null | undefined;
  limit?: number | null | undefined;
  language?: string | null | undefined;
}>;

export type SearchGenericIngredientsQuery = {
  searchGenericIngredients: {
    __typename: "GenericIngredientSearchResult";
    total: number;
    ingredients: Array<{ __typename: "GenericIngredient" } & GenericIngredientFragment>;
  };
};

export type IngredientListFragment = {
  __typename: "Ingredient";
  id: string;
  versionStatus: VersionStatus;
  name: string;
  brand: string | null;
  description: string | null;
  hasDraft: boolean;
  hasPublishedVersion: boolean;
  deleted: boolean;
  createdAt: string;
  updatedAt: string;
};

export type IngredientFragment = {
  __typename: "Ingredient";
  id: string;
  versionId: string;
  versionNumber: number;
  versionStatus: VersionStatus;
  name: string;
  nameForLabel: string | null;
  brand: string | null;
  description: string | null;
  density: number | null;
  allergens: Array<AllergenType>;
  nutritionReferenceQuantity: number;
  nutritionReferenceUnitId: string;
  nutritionReferenceGrams: number;
  genericIngredientId: string | null;
  photoCollectionId: string;
  hasDraft: boolean;
  hasPublishedVersion: boolean;
  deleted: boolean;
  createdAt: string;
  updatedAt: string;
  referenceNutritionProfile: { __typename: "NutritionProfile" } & NutritionProfileFragment;
  genericIngredient: ({ __typename: "GenericIngredient" } & GenericIngredientFragment) | null;
  nutritionProfile: { __typename: "NutritionProfile" } & NutritionProfileFragment;
  referencePrice: ({ __typename: "IngredientReferencePrice" } & IngredientReferencePriceFragment) | null;
  createdBy: { __typename: "User" } & UserBasicFragment;
  photos: Array<{ __typename: "CollectionFile" } & CollectionFileFragment>;
  labelIngredients: Array<{
    __typename: "LabelIngredient";
    id: string;
    parentId: string | null;
    name: string;
    percentage: number | null;
    sortOrder: number;
    allergens: Array<AllergenType>;
  }>;
  usedInRecipes: Array<{
    __typename: "UsedByRecipe";
    isOutdated: boolean;
    recipe: { __typename: "Recipe"; id: string; name: string };
  }>;
};

export type IngredientReferencePriceFragment = {
  __typename: "IngredientReferencePrice";
  quantity: number;
  unitId: string;
  price: number;
  includesVat: boolean;
  vatRate: number | null;
  netPerGram: number;
  grossPerGram: number;
};

export type IngredientRecipeIngredientFragment = {
  __typename: "IngredientRecipeIngredient";
  id: string;
  quantity: number;
  unitId: string;
  quantityGrams: number;
  quantityPercent: number;
  showQuantity: boolean;
  sortOrder: number;
  createdAt: string;
  isOutdated: boolean;
  ingredient: { __typename: "Ingredient" } & IngredientFragment;
};

export type SubRecipeRecipeIngredientFragment = {
  __typename: "SubRecipeRecipeIngredient";
  id: string;
  quantity: number;
  unitId: string;
  quantityGrams: number;
  quantityPercent: number;
  showQuantity: boolean;
  sortOrder: number;
  createdAt: string;
  isOutdated: boolean;
  recipe: { __typename: "Recipe" } & RecipeFragment;
};

type RecipeIngredientFragment_IngredientRecipeIngredient = {
  __typename: "IngredientRecipeIngredient";
} & IngredientRecipeIngredientFragment;

type RecipeIngredientFragment_SubRecipeRecipeIngredient = {
  __typename: "SubRecipeRecipeIngredient";
} & SubRecipeRecipeIngredientFragment;

export type RecipeIngredientFragment =
  RecipeIngredientFragment_IngredientRecipeIngredient | RecipeIngredientFragment_SubRecipeRecipeIngredient;

export type GetMeasurementUnitsQueryVariables = Exact<{ [key: string]: never }>;

export type GetMeasurementUnitsQuery = {
  measurementUnits: Array<{
    __typename: "MeasurementUnit";
    id: string;
    code: string;
    nameEn: string;
    nameBg: string;
    unitType: UnitType;
    factor: number;
  }>;
};

export type AddRecipeIngredientMutationVariables = Exact<{
  recipeVersionId: string | number;
  input: AddRecipeIngredientInput;
}>;

export type AddRecipeIngredientMutation = {
  addRecipeIngredient: {
    __typename: "RecipeMutationPayload";
    refreshedRecipe: { __typename: "Recipe" } & RecipeDetailFragment;
  };
};

export type UpdateRecipeIngredientMutationVariables = Exact<{
  recipeVersionId: string | number;
  ingredientId: string | number;
  input: UpdateRecipeIngredientInput;
}>;

export type UpdateRecipeIngredientMutation = {
  updateRecipeIngredient: {
    __typename: "RecipeMutationPayload";
    refreshedRecipe: { __typename: "Recipe" } & RecipeDetailFragment;
  };
};

export type RemoveRecipeIngredientMutationVariables = Exact<{
  recipeVersionId: string | number;
  ingredientId: string | number;
}>;

export type RemoveRecipeIngredientMutation = {
  removeRecipeIngredient: {
    __typename: "RecipeMutationPayload";
    refreshedRecipe: { __typename: "Recipe" } & RecipeDetailFragment;
  };
};

export type ReplaceRecipeIngredientMutationVariables = Exact<{
  recipeVersionId: string | number;
  ingredientId: string | number;
  input: ReplaceRecipeIngredientInput;
}>;

export type ReplaceRecipeIngredientMutation = {
  replaceRecipeIngredient: {
    __typename: "RecipeMutationPayload";
    refreshedRecipe: { __typename: "Recipe" } & RecipeDetailFragment;
  };
};

export type UpdateRecipeIngredientVersionMutationVariables = Exact<{
  recipeVersionId: string | number;
  ingredientId: string | number;
}>;

export type UpdateRecipeIngredientVersionMutation = {
  updateRecipeIngredientVersion: {
    __typename: "RecipeMutationPayload";
    refreshedRecipe: { __typename: "Recipe" } & RecipeDetailFragment;
  };
};

export type SortRecipeIngredientsByWeightMutationVariables = Exact<{
  recipeVersionId: string | number;
}>;

export type SortRecipeIngredientsByWeightMutation = {
  sortRecipeIngredientsByWeight: {
    __typename: "RecipeMutationPayload";
    refreshedRecipe: { __typename: "Recipe" } & RecipeDetailFragment;
  };
};

export type ListIngredientsQueryVariables = Exact<{
  search?: string | null | undefined;
  pagination: IngredientPaginationInput;
}>;

export type ListIngredientsQuery = {
  ingredients: {
    __typename: "IngredientPageResult";
    total: number;
    ingredients: Array<{ __typename: "Ingredient" } & IngredientListFragment>;
  };
};

export type GetIngredientsQueryVariables = Exact<{
  search?: string | null | undefined;
  pagination: IngredientPaginationInput;
}>;

export type GetIngredientsQuery = {
  ingredients: {
    __typename: "IngredientPageResult";
    total: number;
    ingredients: Array<{ __typename: "Ingredient" } & IngredientFragment>;
  };
};

export type CreateIngredientMutationVariables = Exact<{
  input: CreateIngredientInput;
}>;

export type CreateIngredientMutation = { createIngredient: { __typename: "Ingredient" } & IngredientFragment };

export type GetIngredientQueryVariables = Exact<{
  id: string | number;
}>;

export type GetIngredientQuery = {
  draftIngredient: ({ __typename: "Ingredient" } & IngredientFragment) | null;
  publishedIngredient: ({ __typename: "Ingredient" } & IngredientFragment) | null;
};

export type GetIngredientByVersionQueryVariables = Exact<{
  id: string | number;
  versionNumber: number;
}>;

export type GetIngredientByVersionQuery = {
  ingredientByVersion: ({ __typename: "Ingredient" } & IngredientFragment) | null;
};

export type UpdateIngredientMutationVariables = Exact<{
  id: string | number;
  input: UpdateIngredientInput;
}>;

export type UpdateIngredientMutation = {
  updateIngredient: {
    __typename: "IngredientMutationPayload";
    refreshedIngredient: { __typename: "Ingredient" } & IngredientFragment;
  };
};

export type SetIngredientReferencePriceMutationVariables = Exact<{
  ingredientId: string | number;
  input?: SetIngredientReferencePriceInput | null | undefined;
}>;

export type SetIngredientReferencePriceMutation = {
  setIngredientReferencePrice: {
    __typename: "IngredientMutationPayload";
    refreshedIngredient: { __typename: "Ingredient" } & IngredientFragment;
  };
};

export type PublishIngredientMutationVariables = Exact<{
  id: string | number;
  notes?: string | null | undefined;
}>;

export type PublishIngredientMutation = {
  publishIngredient: {
    __typename: "IngredientMutationPayload";
    refreshedIngredient: { __typename: "Ingredient" } & IngredientFragment;
  };
};

export type CreateIngredientDraftMutationVariables = Exact<{
  id: string | number;
}>;

export type CreateIngredientDraftMutation = {
  createIngredientDraft: {
    __typename: "IngredientMutationPayload";
    refreshedIngredient: { __typename: "Ingredient" } & IngredientFragment;
  };
};

export type DiscardIngredientDraftMutationVariables = Exact<{
  id: string | number;
}>;

export type DiscardIngredientDraftMutation = { discardIngredientDraft: boolean };

export type AddFileToCollectionMutationVariables = Exact<{
  collectionId: string | number;
  stagingFileId: string | number;
}>;

export type AddFileToCollectionMutation = {
  addFileToCollection: Array<{ __typename: "CollectionFile" } & CollectionFileFragment>;
};

export type RemoveFileFromCollectionMutationVariables = Exact<{
  collectionId: string | number;
  fileId: string | number;
}>;

export type RemoveFileFromCollectionMutation = {
  removeFileFromCollection: Array<{ __typename: "CollectionFile" } & CollectionFileFragment>;
};

export type AddLabelIngredientMutationVariables = Exact<{
  ingredientId: string | number;
  input: AddLabelIngredientInput;
}>;

export type AddLabelIngredientMutation = {
  addLabelIngredient: {
    __typename: "IngredientMutationPayload";
    refreshedIngredient: { __typename: "Ingredient" } & IngredientFragment;
  };
};

export type UpdateLabelIngredientMutationVariables = Exact<{
  ingredientId: string | number;
  labelIngredientId: string | number;
  input: UpdateLabelIngredientInput;
}>;

export type UpdateLabelIngredientMutation = {
  updateLabelIngredient: {
    __typename: "IngredientMutationPayload";
    refreshedIngredient: { __typename: "Ingredient" } & IngredientFragment;
  };
};

export type RemoveLabelIngredientMutationVariables = Exact<{
  ingredientId: string | number;
  labelIngredientId: string | number;
}>;

export type RemoveLabelIngredientMutation = {
  removeLabelIngredient: {
    __typename: "IngredientMutationPayload";
    refreshedIngredient: { __typename: "Ingredient" } & IngredientFragment;
  };
};

export type MoveLabelIngredientMutationVariables = Exact<{
  ingredientId: string | number;
  labelIngredientId: string | number;
  input: MoveLabelIngredientInput;
}>;

export type MoveLabelIngredientMutation = {
  moveLabelIngredient: {
    __typename: "IngredientMutationPayload";
    refreshedIngredient: { __typename: "Ingredient" } & IngredientFragment;
  };
};

export type RecognizeLabelMutationVariables = Exact<{
  ingredientId: string | number;
  language: string;
}>;

export type RecognizeLabelMutation = {
  recognizeLabel: {
    __typename: "IngredientMutationPayload";
    refreshedIngredient: { __typename: "Ingredient" } & IngredientFragment;
  };
};

export type DeleteIngredientMutationVariables = Exact<{
  id: string | number;
}>;

export type DeleteIngredientMutation = { deleteIngredient: boolean };

export type RestoreIngredientMutationVariables = Exact<{
  id: string | number;
}>;

export type RestoreIngredientMutation = { restoreIngredient: boolean };

export type DeclarationFieldsFragment = {
  __typename: "Declaration";
  rootIndices: Array<number>;
  derivedAllergens: Array<AllergenType>;
  entries: Array<{
    __typename: "DeclarationNode";
    name: string;
    allergens: Array<AllergenType>;
    percentage: number | null;
    showQuantity: boolean;
    childIndices: Array<number>;
  }>;
};

export type GetRecipeDeclarationQueryVariables = Exact<{
  id: string | number;
  versionNumber: number;
}>;

export type GetRecipeDeclarationQuery = {
  recipeDeclaration: { __typename: "Declaration" } & DeclarationFieldsFragment;
};

export type GetIngredientDeclarationQueryVariables = Exact<{
  id: string | number;
  versionNumber: number;
}>;

export type GetIngredientDeclarationQuery = {
  ingredientDeclaration: { __typename: "Declaration" } & DeclarationFieldsFragment;
};

export type GetStagingFilesQueryVariables = Exact<{ [key: string]: never }>;

export type GetStagingFilesQuery = { stagingFiles: Array<{ __typename: "StagingFileItem" } & StagingFileItemFragment> };

export type GenerateCameraUrlMutationVariables = Exact<{ [key: string]: never }>;

export type GenerateCameraUrlMutation = { generateCameraUrl: string };

export type GetStagingFileQueryVariables = Exact<{
  id: string | number;
}>;

export type GetStagingFileQuery = { stagingFile: ({ __typename: "StagingFileItem" } & StagingFileItemFragment) | null };

export type DeleteStagingFileMutationVariables = Exact<{
  id: string | number;
}>;

export type DeleteStagingFileMutation = { deleteStagingFile: boolean };

export type PlanPriceFragment = {
  __typename: "PlanPrice";
  plan: PlanType;
  amount: number;
  amountBgn: number | null;
  currency: string;
  interval: string;
  annualSavings: number | null;
  annualSavingsBgn: number | null;
  monthlyEquivalent: number | null;
  monthlyEquivalentBgn: number | null;
  taxBehavior: TaxBehavior;
};

export type GetPlanPricesQueryVariables = Exact<{ [key: string]: never }>;

export type GetPlanPricesQuery = { planPrices: Array<{ __typename: "PlanPrice" } & PlanPriceFragment> };

export type CreateCheckoutSessionMutationVariables = Exact<{
  plan: PlanType;
}>;

export type CreateCheckoutSessionMutation = { createCheckoutSession: string };

export type CreateBillingPortalSessionMutationVariables = Exact<{ [key: string]: never }>;

export type CreateBillingPortalSessionMutation = { createBillingPortalSession: string };

export const FileVariantFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FileVariantFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "FileVariantInfo" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "kind" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "contentType" } },
          { kind: "Field", name: { kind: "Name", value: "sizeBytes" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FileVariantFragment, unknown>;
export const StagingFileItemFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StagingFileItemFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "StagingFileItem" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "fileId" } },
          { kind: "Field", name: { kind: "Name", value: "originalFilename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "variants" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "FileVariantFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FileVariantFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "FileVariantInfo" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "kind" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "contentType" } },
          { kind: "Field", name: { kind: "Name", value: "sizeBytes" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<StagingFileItemFragment, unknown>;
export const UserFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "User" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "locale" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "membership" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "role" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UserFragment, unknown>;
export const TeamFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TeamFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Team" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "freeAccessUntil" } },
          { kind: "Field", name: { kind: "Name", value: "subscriptionStatus" } },
          { kind: "Field", name: { kind: "Name", value: "currentPeriodEnd" } },
          { kind: "Field", name: { kind: "Name", value: "cancelAt" } },
          { kind: "Field", name: { kind: "Name", value: "endedAt" } },
          { kind: "Field", name: { kind: "Name", value: "hasFullAccess" } },
          { kind: "Field", name: { kind: "Name", value: "currency" } },
          { kind: "Field", name: { kind: "Name", value: "country" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TeamFragment, unknown>;
export const UserBasicFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserBasicFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "User" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UserBasicFragment, unknown>;
export const TeamMemberFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TeamMemberFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "TeamMember" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "teamId" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "joinedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UserBasicFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserBasicFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "User" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TeamMemberFragment, unknown>;
export const TeamInvitationFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TeamInvitationFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "TeamInvitation" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "teamId" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "token" } },
          { kind: "Field", name: { kind: "Name", value: "inviteUrl" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "expiresAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "invitedBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UserBasicFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserBasicFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "User" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TeamInvitationFragment, unknown>;
export const VatRatePresetFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "VatRatePresetFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "VatRatePreset" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "rate" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<VatRatePresetFragment, unknown>;
export const RecipeListFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RecipeListFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recipe" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "versionStatus" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "hasDraft" } },
          { kind: "Field", name: { kind: "Name", value: "hasPublishedVersion" } },
          { kind: "Field", name: { kind: "Name", value: "deleted" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RecipeListFragment, unknown>;
export const NutritionProfileFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "NutritionProfileFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "NutritionProfile" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "energyKj" } },
          { kind: "Field", name: { kind: "Name", value: "energyKcal" } },
          { kind: "Field", name: { kind: "Name", value: "fat" } },
          { kind: "Field", name: { kind: "Name", value: "saturatedFat" } },
          { kind: "Field", name: { kind: "Name", value: "carbohydrate" } },
          { kind: "Field", name: { kind: "Name", value: "sugars" } },
          { kind: "Field", name: { kind: "Name", value: "fibre" } },
          { kind: "Field", name: { kind: "Name", value: "protein" } },
          { kind: "Field", name: { kind: "Name", value: "salt" } },
          { kind: "Field", name: { kind: "Name", value: "alcohol" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<NutritionProfileFragment, unknown>;
export const RecipeFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RecipeFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recipe" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "versionId" } },
          { kind: "Field", name: { kind: "Name", value: "versionNumber" } },
          { kind: "Field", name: { kind: "Name", value: "versionStatus" } },
          { kind: "Field", name: { kind: "Name", value: "versionNotes" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "nameForLabel" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionPerServing" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionPerPackage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "weightAfterCooking" } },
          { kind: "Field", name: { kind: "Name", value: "weightAfterCookingQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "weightAfterCookingUnitId" } },
          { kind: "Field", name: { kind: "Name", value: "servingSize" } },
          { kind: "Field", name: { kind: "Name", value: "servingSizeQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "servingSizeUnitId" } },
          { kind: "Field", name: { kind: "Name", value: "servingsPerPackage" } },
          { kind: "Field", name: { kind: "Name", value: "netWeight" } },
          { kind: "Field", name: { kind: "Name", value: "netWeightQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "netWeightUnitId" } },
          { kind: "Field", name: { kind: "Name", value: "storageRequirements" } },
          { kind: "Field", name: { kind: "Name", value: "labelExportUrl" } },
          { kind: "Field", name: { kind: "Name", value: "producerId" } },
          { kind: "Field", name: { kind: "Name", value: "allergens" } },
          { kind: "Field", name: { kind: "Name", value: "photoCollectionId" } },
          { kind: "Field", name: { kind: "Name", value: "hasDraft" } },
          { kind: "Field", name: { kind: "Name", value: "hasPublishedVersion" } },
          { kind: "Field", name: { kind: "Name", value: "deleted" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "NutritionProfileFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "NutritionProfile" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "energyKj" } },
          { kind: "Field", name: { kind: "Name", value: "energyKcal" } },
          { kind: "Field", name: { kind: "Name", value: "fat" } },
          { kind: "Field", name: { kind: "Name", value: "saturatedFat" } },
          { kind: "Field", name: { kind: "Name", value: "carbohydrate" } },
          { kind: "Field", name: { kind: "Name", value: "sugars" } },
          { kind: "Field", name: { kind: "Name", value: "fibre" } },
          { kind: "Field", name: { kind: "Name", value: "protein" } },
          { kind: "Field", name: { kind: "Name", value: "salt" } },
          { kind: "Field", name: { kind: "Name", value: "alcohol" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RecipeFragment, unknown>;
export const ProducerFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProducerFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Producer" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "companyName" } },
          { kind: "Field", name: { kind: "Name", value: "address" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "website" } },
          { kind: "Field", name: { kind: "Name", value: "deleted" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "createdBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UserBasicFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "usedInRecipes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserBasicFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "User" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ProducerFragment, unknown>;
export const CollectionFileFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CollectionFileFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CollectionFile" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "originalFilename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "variants" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "FileVariantFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FileVariantFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "FileVariantInfo" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "kind" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "contentType" } },
          { kind: "Field", name: { kind: "Name", value: "sizeBytes" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CollectionFileFragment, unknown>;
export const GenericIngredientFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "GenericIngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GenericIngredient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
          { kind: "Field", name: { kind: "Name", value: "sourceId" } },
          { kind: "Field", name: { kind: "Name", value: "nameEn" } },
          { kind: "Field", name: { kind: "Name", value: "nameBg" } },
          { kind: "Field", name: { kind: "Name", value: "nameFr" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "density" } },
          { kind: "Field", name: { kind: "Name", value: "allergens" } },
          { kind: "Field", name: { kind: "Name", value: "baseNameEn" } },
          { kind: "Field", name: { kind: "Name", value: "baseNameBg" } },
          { kind: "Field", name: { kind: "Name", value: "baseNameFr" } },
          { kind: "Field", name: { kind: "Name", value: "propertiesEn" } },
          { kind: "Field", name: { kind: "Name", value: "propertiesBg" } },
          { kind: "Field", name: { kind: "Name", value: "propertiesFr" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "foodCategory" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "nameEn" } },
                { kind: "Field", name: { kind: "Name", value: "nameBg" } },
                { kind: "Field", name: { kind: "Name", value: "nameFr" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "NutritionProfileFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "NutritionProfile" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "energyKj" } },
          { kind: "Field", name: { kind: "Name", value: "energyKcal" } },
          { kind: "Field", name: { kind: "Name", value: "fat" } },
          { kind: "Field", name: { kind: "Name", value: "saturatedFat" } },
          { kind: "Field", name: { kind: "Name", value: "carbohydrate" } },
          { kind: "Field", name: { kind: "Name", value: "sugars" } },
          { kind: "Field", name: { kind: "Name", value: "fibre" } },
          { kind: "Field", name: { kind: "Name", value: "protein" } },
          { kind: "Field", name: { kind: "Name", value: "salt" } },
          { kind: "Field", name: { kind: "Name", value: "alcohol" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GenericIngredientFragment, unknown>;
export const IngredientReferencePriceFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IngredientReferencePriceFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "IngredientReferencePrice" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "quantity" } },
          { kind: "Field", name: { kind: "Name", value: "unitId" } },
          { kind: "Field", name: { kind: "Name", value: "price" } },
          { kind: "Field", name: { kind: "Name", value: "includesVat" } },
          { kind: "Field", name: { kind: "Name", value: "vatRate" } },
          { kind: "Field", name: { kind: "Name", value: "netPerGram" } },
          { kind: "Field", name: { kind: "Name", value: "grossPerGram" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IngredientReferencePriceFragment, unknown>;
export const IngredientFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Ingredient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "versionId" } },
          { kind: "Field", name: { kind: "Name", value: "versionNumber" } },
          { kind: "Field", name: { kind: "Name", value: "versionStatus" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "nameForLabel" } },
          { kind: "Field", name: { kind: "Name", value: "brand" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "density" } },
          { kind: "Field", name: { kind: "Name", value: "allergens" } },
          { kind: "Field", name: { kind: "Name", value: "nutritionReferenceQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "nutritionReferenceUnitId" } },
          { kind: "Field", name: { kind: "Name", value: "nutritionReferenceGrams" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "referenceNutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "genericIngredientId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "genericIngredient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GenericIngredientFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "photoCollectionId" } },
          { kind: "Field", name: { kind: "Name", value: "hasDraft" } },
          { kind: "Field", name: { kind: "Name", value: "hasPublishedVersion" } },
          { kind: "Field", name: { kind: "Name", value: "deleted" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "referencePrice" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "IngredientReferencePriceFragment" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "createdBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UserBasicFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "photos" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "CollectionFileFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "labelIngredients" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "parentId" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "percentage" } },
                { kind: "Field", name: { kind: "Name", value: "sortOrder" } },
                { kind: "Field", name: { kind: "Name", value: "allergens" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "usedInRecipes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "isOutdated" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "recipe" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "NutritionProfileFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "NutritionProfile" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "energyKj" } },
          { kind: "Field", name: { kind: "Name", value: "energyKcal" } },
          { kind: "Field", name: { kind: "Name", value: "fat" } },
          { kind: "Field", name: { kind: "Name", value: "saturatedFat" } },
          { kind: "Field", name: { kind: "Name", value: "carbohydrate" } },
          { kind: "Field", name: { kind: "Name", value: "sugars" } },
          { kind: "Field", name: { kind: "Name", value: "fibre" } },
          { kind: "Field", name: { kind: "Name", value: "protein" } },
          { kind: "Field", name: { kind: "Name", value: "salt" } },
          { kind: "Field", name: { kind: "Name", value: "alcohol" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FileVariantFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "FileVariantInfo" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "kind" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "contentType" } },
          { kind: "Field", name: { kind: "Name", value: "sizeBytes" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "GenericIngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GenericIngredient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
          { kind: "Field", name: { kind: "Name", value: "sourceId" } },
          { kind: "Field", name: { kind: "Name", value: "nameEn" } },
          { kind: "Field", name: { kind: "Name", value: "nameBg" } },
          { kind: "Field", name: { kind: "Name", value: "nameFr" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "density" } },
          { kind: "Field", name: { kind: "Name", value: "allergens" } },
          { kind: "Field", name: { kind: "Name", value: "baseNameEn" } },
          { kind: "Field", name: { kind: "Name", value: "baseNameBg" } },
          { kind: "Field", name: { kind: "Name", value: "baseNameFr" } },
          { kind: "Field", name: { kind: "Name", value: "propertiesEn" } },
          { kind: "Field", name: { kind: "Name", value: "propertiesBg" } },
          { kind: "Field", name: { kind: "Name", value: "propertiesFr" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "foodCategory" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "nameEn" } },
                { kind: "Field", name: { kind: "Name", value: "nameBg" } },
                { kind: "Field", name: { kind: "Name", value: "nameFr" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IngredientReferencePriceFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "IngredientReferencePrice" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "quantity" } },
          { kind: "Field", name: { kind: "Name", value: "unitId" } },
          { kind: "Field", name: { kind: "Name", value: "price" } },
          { kind: "Field", name: { kind: "Name", value: "includesVat" } },
          { kind: "Field", name: { kind: "Name", value: "vatRate" } },
          { kind: "Field", name: { kind: "Name", value: "netPerGram" } },
          { kind: "Field", name: { kind: "Name", value: "grossPerGram" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserBasicFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "User" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CollectionFileFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CollectionFile" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "originalFilename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "variants" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "FileVariantFragment" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IngredientFragment, unknown>;
export const IngredientRecipeIngredientFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IngredientRecipeIngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "IngredientRecipeIngredient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "ingredient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "IngredientFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "quantity" } },
          { kind: "Field", name: { kind: "Name", value: "unitId" } },
          { kind: "Field", name: { kind: "Name", value: "quantityGrams" } },
          { kind: "Field", name: { kind: "Name", value: "quantityPercent" } },
          { kind: "Field", name: { kind: "Name", value: "showQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "sortOrder" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "isOutdated" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "NutritionProfileFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "NutritionProfile" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "energyKj" } },
          { kind: "Field", name: { kind: "Name", value: "energyKcal" } },
          { kind: "Field", name: { kind: "Name", value: "fat" } },
          { kind: "Field", name: { kind: "Name", value: "saturatedFat" } },
          { kind: "Field", name: { kind: "Name", value: "carbohydrate" } },
          { kind: "Field", name: { kind: "Name", value: "sugars" } },
          { kind: "Field", name: { kind: "Name", value: "fibre" } },
          { kind: "Field", name: { kind: "Name", value: "protein" } },
          { kind: "Field", name: { kind: "Name", value: "salt" } },
          { kind: "Field", name: { kind: "Name", value: "alcohol" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "GenericIngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GenericIngredient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
          { kind: "Field", name: { kind: "Name", value: "sourceId" } },
          { kind: "Field", name: { kind: "Name", value: "nameEn" } },
          { kind: "Field", name: { kind: "Name", value: "nameBg" } },
          { kind: "Field", name: { kind: "Name", value: "nameFr" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "density" } },
          { kind: "Field", name: { kind: "Name", value: "allergens" } },
          { kind: "Field", name: { kind: "Name", value: "baseNameEn" } },
          { kind: "Field", name: { kind: "Name", value: "baseNameBg" } },
          { kind: "Field", name: { kind: "Name", value: "baseNameFr" } },
          { kind: "Field", name: { kind: "Name", value: "propertiesEn" } },
          { kind: "Field", name: { kind: "Name", value: "propertiesBg" } },
          { kind: "Field", name: { kind: "Name", value: "propertiesFr" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "foodCategory" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "nameEn" } },
                { kind: "Field", name: { kind: "Name", value: "nameBg" } },
                { kind: "Field", name: { kind: "Name", value: "nameFr" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IngredientReferencePriceFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "IngredientReferencePrice" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "quantity" } },
          { kind: "Field", name: { kind: "Name", value: "unitId" } },
          { kind: "Field", name: { kind: "Name", value: "price" } },
          { kind: "Field", name: { kind: "Name", value: "includesVat" } },
          { kind: "Field", name: { kind: "Name", value: "vatRate" } },
          { kind: "Field", name: { kind: "Name", value: "netPerGram" } },
          { kind: "Field", name: { kind: "Name", value: "grossPerGram" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserBasicFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "User" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FileVariantFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "FileVariantInfo" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "kind" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "contentType" } },
          { kind: "Field", name: { kind: "Name", value: "sizeBytes" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CollectionFileFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CollectionFile" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "originalFilename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "variants" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "FileVariantFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Ingredient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "versionId" } },
          { kind: "Field", name: { kind: "Name", value: "versionNumber" } },
          { kind: "Field", name: { kind: "Name", value: "versionStatus" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "nameForLabel" } },
          { kind: "Field", name: { kind: "Name", value: "brand" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "density" } },
          { kind: "Field", name: { kind: "Name", value: "allergens" } },
          { kind: "Field", name: { kind: "Name", value: "nutritionReferenceQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "nutritionReferenceUnitId" } },
          { kind: "Field", name: { kind: "Name", value: "nutritionReferenceGrams" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "referenceNutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "genericIngredientId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "genericIngredient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GenericIngredientFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "photoCollectionId" } },
          { kind: "Field", name: { kind: "Name", value: "hasDraft" } },
          { kind: "Field", name: { kind: "Name", value: "hasPublishedVersion" } },
          { kind: "Field", name: { kind: "Name", value: "deleted" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "referencePrice" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "IngredientReferencePriceFragment" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "createdBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UserBasicFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "photos" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "CollectionFileFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "labelIngredients" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "parentId" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "percentage" } },
                { kind: "Field", name: { kind: "Name", value: "sortOrder" } },
                { kind: "Field", name: { kind: "Name", value: "allergens" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "usedInRecipes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "isOutdated" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "recipe" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IngredientRecipeIngredientFragment, unknown>;
export const SubRecipeRecipeIngredientFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SubRecipeRecipeIngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "SubRecipeRecipeIngredient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "recipe" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RecipeFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "quantity" } },
          { kind: "Field", name: { kind: "Name", value: "unitId" } },
          { kind: "Field", name: { kind: "Name", value: "quantityGrams" } },
          { kind: "Field", name: { kind: "Name", value: "quantityPercent" } },
          { kind: "Field", name: { kind: "Name", value: "showQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "sortOrder" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "isOutdated" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "NutritionProfileFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "NutritionProfile" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "energyKj" } },
          { kind: "Field", name: { kind: "Name", value: "energyKcal" } },
          { kind: "Field", name: { kind: "Name", value: "fat" } },
          { kind: "Field", name: { kind: "Name", value: "saturatedFat" } },
          { kind: "Field", name: { kind: "Name", value: "carbohydrate" } },
          { kind: "Field", name: { kind: "Name", value: "sugars" } },
          { kind: "Field", name: { kind: "Name", value: "fibre" } },
          { kind: "Field", name: { kind: "Name", value: "protein" } },
          { kind: "Field", name: { kind: "Name", value: "salt" } },
          { kind: "Field", name: { kind: "Name", value: "alcohol" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RecipeFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recipe" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "versionId" } },
          { kind: "Field", name: { kind: "Name", value: "versionNumber" } },
          { kind: "Field", name: { kind: "Name", value: "versionStatus" } },
          { kind: "Field", name: { kind: "Name", value: "versionNotes" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "nameForLabel" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionPerServing" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionPerPackage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "weightAfterCooking" } },
          { kind: "Field", name: { kind: "Name", value: "weightAfterCookingQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "weightAfterCookingUnitId" } },
          { kind: "Field", name: { kind: "Name", value: "servingSize" } },
          { kind: "Field", name: { kind: "Name", value: "servingSizeQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "servingSizeUnitId" } },
          { kind: "Field", name: { kind: "Name", value: "servingsPerPackage" } },
          { kind: "Field", name: { kind: "Name", value: "netWeight" } },
          { kind: "Field", name: { kind: "Name", value: "netWeightQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "netWeightUnitId" } },
          { kind: "Field", name: { kind: "Name", value: "storageRequirements" } },
          { kind: "Field", name: { kind: "Name", value: "labelExportUrl" } },
          { kind: "Field", name: { kind: "Name", value: "producerId" } },
          { kind: "Field", name: { kind: "Name", value: "allergens" } },
          { kind: "Field", name: { kind: "Name", value: "photoCollectionId" } },
          { kind: "Field", name: { kind: "Name", value: "hasDraft" } },
          { kind: "Field", name: { kind: "Name", value: "hasPublishedVersion" } },
          { kind: "Field", name: { kind: "Name", value: "deleted" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SubRecipeRecipeIngredientFragment, unknown>;
export const RecipeIngredientFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RecipeIngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "RecipeIngredientItem" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "FragmentSpread", name: { kind: "Name", value: "IngredientRecipeIngredientFragment" } },
          { kind: "FragmentSpread", name: { kind: "Name", value: "SubRecipeRecipeIngredientFragment" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "NutritionProfileFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "NutritionProfile" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "energyKj" } },
          { kind: "Field", name: { kind: "Name", value: "energyKcal" } },
          { kind: "Field", name: { kind: "Name", value: "fat" } },
          { kind: "Field", name: { kind: "Name", value: "saturatedFat" } },
          { kind: "Field", name: { kind: "Name", value: "carbohydrate" } },
          { kind: "Field", name: { kind: "Name", value: "sugars" } },
          { kind: "Field", name: { kind: "Name", value: "fibre" } },
          { kind: "Field", name: { kind: "Name", value: "protein" } },
          { kind: "Field", name: { kind: "Name", value: "salt" } },
          { kind: "Field", name: { kind: "Name", value: "alcohol" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "GenericIngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GenericIngredient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
          { kind: "Field", name: { kind: "Name", value: "sourceId" } },
          { kind: "Field", name: { kind: "Name", value: "nameEn" } },
          { kind: "Field", name: { kind: "Name", value: "nameBg" } },
          { kind: "Field", name: { kind: "Name", value: "nameFr" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "density" } },
          { kind: "Field", name: { kind: "Name", value: "allergens" } },
          { kind: "Field", name: { kind: "Name", value: "baseNameEn" } },
          { kind: "Field", name: { kind: "Name", value: "baseNameBg" } },
          { kind: "Field", name: { kind: "Name", value: "baseNameFr" } },
          { kind: "Field", name: { kind: "Name", value: "propertiesEn" } },
          { kind: "Field", name: { kind: "Name", value: "propertiesBg" } },
          { kind: "Field", name: { kind: "Name", value: "propertiesFr" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "foodCategory" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "nameEn" } },
                { kind: "Field", name: { kind: "Name", value: "nameBg" } },
                { kind: "Field", name: { kind: "Name", value: "nameFr" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IngredientReferencePriceFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "IngredientReferencePrice" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "quantity" } },
          { kind: "Field", name: { kind: "Name", value: "unitId" } },
          { kind: "Field", name: { kind: "Name", value: "price" } },
          { kind: "Field", name: { kind: "Name", value: "includesVat" } },
          { kind: "Field", name: { kind: "Name", value: "vatRate" } },
          { kind: "Field", name: { kind: "Name", value: "netPerGram" } },
          { kind: "Field", name: { kind: "Name", value: "grossPerGram" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserBasicFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "User" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FileVariantFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "FileVariantInfo" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "kind" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "contentType" } },
          { kind: "Field", name: { kind: "Name", value: "sizeBytes" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CollectionFileFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CollectionFile" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "originalFilename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "variants" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "FileVariantFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Ingredient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "versionId" } },
          { kind: "Field", name: { kind: "Name", value: "versionNumber" } },
          { kind: "Field", name: { kind: "Name", value: "versionStatus" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "nameForLabel" } },
          { kind: "Field", name: { kind: "Name", value: "brand" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "density" } },
          { kind: "Field", name: { kind: "Name", value: "allergens" } },
          { kind: "Field", name: { kind: "Name", value: "nutritionReferenceQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "nutritionReferenceUnitId" } },
          { kind: "Field", name: { kind: "Name", value: "nutritionReferenceGrams" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "referenceNutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "genericIngredientId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "genericIngredient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GenericIngredientFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "photoCollectionId" } },
          { kind: "Field", name: { kind: "Name", value: "hasDraft" } },
          { kind: "Field", name: { kind: "Name", value: "hasPublishedVersion" } },
          { kind: "Field", name: { kind: "Name", value: "deleted" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "referencePrice" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "IngredientReferencePriceFragment" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "createdBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UserBasicFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "photos" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "CollectionFileFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "labelIngredients" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "parentId" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "percentage" } },
                { kind: "Field", name: { kind: "Name", value: "sortOrder" } },
                { kind: "Field", name: { kind: "Name", value: "allergens" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "usedInRecipes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "isOutdated" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "recipe" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RecipeFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recipe" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "versionId" } },
          { kind: "Field", name: { kind: "Name", value: "versionNumber" } },
          { kind: "Field", name: { kind: "Name", value: "versionStatus" } },
          { kind: "Field", name: { kind: "Name", value: "versionNotes" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "nameForLabel" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionPerServing" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionPerPackage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "weightAfterCooking" } },
          { kind: "Field", name: { kind: "Name", value: "weightAfterCookingQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "weightAfterCookingUnitId" } },
          { kind: "Field", name: { kind: "Name", value: "servingSize" } },
          { kind: "Field", name: { kind: "Name", value: "servingSizeQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "servingSizeUnitId" } },
          { kind: "Field", name: { kind: "Name", value: "servingsPerPackage" } },
          { kind: "Field", name: { kind: "Name", value: "netWeight" } },
          { kind: "Field", name: { kind: "Name", value: "netWeightQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "netWeightUnitId" } },
          { kind: "Field", name: { kind: "Name", value: "storageRequirements" } },
          { kind: "Field", name: { kind: "Name", value: "labelExportUrl" } },
          { kind: "Field", name: { kind: "Name", value: "producerId" } },
          { kind: "Field", name: { kind: "Name", value: "allergens" } },
          { kind: "Field", name: { kind: "Name", value: "photoCollectionId" } },
          { kind: "Field", name: { kind: "Name", value: "hasDraft" } },
          { kind: "Field", name: { kind: "Name", value: "hasPublishedVersion" } },
          { kind: "Field", name: { kind: "Name", value: "deleted" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IngredientRecipeIngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "IngredientRecipeIngredient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "ingredient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "IngredientFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "quantity" } },
          { kind: "Field", name: { kind: "Name", value: "unitId" } },
          { kind: "Field", name: { kind: "Name", value: "quantityGrams" } },
          { kind: "Field", name: { kind: "Name", value: "quantityPercent" } },
          { kind: "Field", name: { kind: "Name", value: "showQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "sortOrder" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "isOutdated" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SubRecipeRecipeIngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "SubRecipeRecipeIngredient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "recipe" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RecipeFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "quantity" } },
          { kind: "Field", name: { kind: "Name", value: "unitId" } },
          { kind: "Field", name: { kind: "Name", value: "quantityGrams" } },
          { kind: "Field", name: { kind: "Name", value: "quantityPercent" } },
          { kind: "Field", name: { kind: "Name", value: "showQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "sortOrder" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "isOutdated" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RecipeIngredientFragment, unknown>;
export const RecipeReferenceCostFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RecipeReferenceCostFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "RecipeReferenceCost" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "totalNet" } },
          { kind: "Field", name: { kind: "Name", value: "totalGross" } },
          { kind: "Field", name: { kind: "Name", value: "perGramNet" } },
          { kind: "Field", name: { kind: "Name", value: "perGramGross" } },
          { kind: "Field", name: { kind: "Name", value: "per100gNet" } },
          { kind: "Field", name: { kind: "Name", value: "per100gGross" } },
          { kind: "Field", name: { kind: "Name", value: "perKgNet" } },
          { kind: "Field", name: { kind: "Name", value: "perKgGross" } },
          { kind: "Field", name: { kind: "Name", value: "perServingNet" } },
          { kind: "Field", name: { kind: "Name", value: "perServingGross" } },
          { kind: "Field", name: { kind: "Name", value: "perPackageNet" } },
          { kind: "Field", name: { kind: "Name", value: "perPackageGross" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "rows" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "recipeIngredientId" } },
                { kind: "Field", name: { kind: "Name", value: "net" } },
                { kind: "Field", name: { kind: "Name", value: "gross" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RecipeReferenceCostFragment, unknown>;
export const RecipeDetailFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RecipeDetailFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recipe" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "FragmentSpread", name: { kind: "Name", value: "RecipeFragment" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "createdBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UserBasicFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "producer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ProducerFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "photos" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "CollectionFileFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "ingredients" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RecipeIngredientFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "referenceCost" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RecipeReferenceCostFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "usedAsSubRecipeIn" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "isOutdated" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "recipe" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "NutritionProfileFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "NutritionProfile" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "energyKj" } },
          { kind: "Field", name: { kind: "Name", value: "energyKcal" } },
          { kind: "Field", name: { kind: "Name", value: "fat" } },
          { kind: "Field", name: { kind: "Name", value: "saturatedFat" } },
          { kind: "Field", name: { kind: "Name", value: "carbohydrate" } },
          { kind: "Field", name: { kind: "Name", value: "sugars" } },
          { kind: "Field", name: { kind: "Name", value: "fibre" } },
          { kind: "Field", name: { kind: "Name", value: "protein" } },
          { kind: "Field", name: { kind: "Name", value: "salt" } },
          { kind: "Field", name: { kind: "Name", value: "alcohol" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserBasicFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "User" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FileVariantFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "FileVariantInfo" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "kind" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "contentType" } },
          { kind: "Field", name: { kind: "Name", value: "sizeBytes" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "GenericIngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GenericIngredient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
          { kind: "Field", name: { kind: "Name", value: "sourceId" } },
          { kind: "Field", name: { kind: "Name", value: "nameEn" } },
          { kind: "Field", name: { kind: "Name", value: "nameBg" } },
          { kind: "Field", name: { kind: "Name", value: "nameFr" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "density" } },
          { kind: "Field", name: { kind: "Name", value: "allergens" } },
          { kind: "Field", name: { kind: "Name", value: "baseNameEn" } },
          { kind: "Field", name: { kind: "Name", value: "baseNameBg" } },
          { kind: "Field", name: { kind: "Name", value: "baseNameFr" } },
          { kind: "Field", name: { kind: "Name", value: "propertiesEn" } },
          { kind: "Field", name: { kind: "Name", value: "propertiesBg" } },
          { kind: "Field", name: { kind: "Name", value: "propertiesFr" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "foodCategory" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "nameEn" } },
                { kind: "Field", name: { kind: "Name", value: "nameBg" } },
                { kind: "Field", name: { kind: "Name", value: "nameFr" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IngredientReferencePriceFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "IngredientReferencePrice" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "quantity" } },
          { kind: "Field", name: { kind: "Name", value: "unitId" } },
          { kind: "Field", name: { kind: "Name", value: "price" } },
          { kind: "Field", name: { kind: "Name", value: "includesVat" } },
          { kind: "Field", name: { kind: "Name", value: "vatRate" } },
          { kind: "Field", name: { kind: "Name", value: "netPerGram" } },
          { kind: "Field", name: { kind: "Name", value: "grossPerGram" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CollectionFileFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CollectionFile" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "originalFilename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "variants" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "FileVariantFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Ingredient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "versionId" } },
          { kind: "Field", name: { kind: "Name", value: "versionNumber" } },
          { kind: "Field", name: { kind: "Name", value: "versionStatus" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "nameForLabel" } },
          { kind: "Field", name: { kind: "Name", value: "brand" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "density" } },
          { kind: "Field", name: { kind: "Name", value: "allergens" } },
          { kind: "Field", name: { kind: "Name", value: "nutritionReferenceQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "nutritionReferenceUnitId" } },
          { kind: "Field", name: { kind: "Name", value: "nutritionReferenceGrams" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "referenceNutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "genericIngredientId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "genericIngredient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GenericIngredientFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "photoCollectionId" } },
          { kind: "Field", name: { kind: "Name", value: "hasDraft" } },
          { kind: "Field", name: { kind: "Name", value: "hasPublishedVersion" } },
          { kind: "Field", name: { kind: "Name", value: "deleted" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "referencePrice" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "IngredientReferencePriceFragment" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "createdBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UserBasicFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "photos" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "CollectionFileFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "labelIngredients" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "parentId" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "percentage" } },
                { kind: "Field", name: { kind: "Name", value: "sortOrder" } },
                { kind: "Field", name: { kind: "Name", value: "allergens" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "usedInRecipes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "isOutdated" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "recipe" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IngredientRecipeIngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "IngredientRecipeIngredient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "ingredient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "IngredientFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "quantity" } },
          { kind: "Field", name: { kind: "Name", value: "unitId" } },
          { kind: "Field", name: { kind: "Name", value: "quantityGrams" } },
          { kind: "Field", name: { kind: "Name", value: "quantityPercent" } },
          { kind: "Field", name: { kind: "Name", value: "showQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "sortOrder" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "isOutdated" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RecipeFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recipe" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "versionId" } },
          { kind: "Field", name: { kind: "Name", value: "versionNumber" } },
          { kind: "Field", name: { kind: "Name", value: "versionStatus" } },
          { kind: "Field", name: { kind: "Name", value: "versionNotes" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "nameForLabel" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionPerServing" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionPerPackage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "weightAfterCooking" } },
          { kind: "Field", name: { kind: "Name", value: "weightAfterCookingQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "weightAfterCookingUnitId" } },
          { kind: "Field", name: { kind: "Name", value: "servingSize" } },
          { kind: "Field", name: { kind: "Name", value: "servingSizeQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "servingSizeUnitId" } },
          { kind: "Field", name: { kind: "Name", value: "servingsPerPackage" } },
          { kind: "Field", name: { kind: "Name", value: "netWeight" } },
          { kind: "Field", name: { kind: "Name", value: "netWeightQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "netWeightUnitId" } },
          { kind: "Field", name: { kind: "Name", value: "storageRequirements" } },
          { kind: "Field", name: { kind: "Name", value: "labelExportUrl" } },
          { kind: "Field", name: { kind: "Name", value: "producerId" } },
          { kind: "Field", name: { kind: "Name", value: "allergens" } },
          { kind: "Field", name: { kind: "Name", value: "photoCollectionId" } },
          { kind: "Field", name: { kind: "Name", value: "hasDraft" } },
          { kind: "Field", name: { kind: "Name", value: "hasPublishedVersion" } },
          { kind: "Field", name: { kind: "Name", value: "deleted" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SubRecipeRecipeIngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "SubRecipeRecipeIngredient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "recipe" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RecipeFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "quantity" } },
          { kind: "Field", name: { kind: "Name", value: "unitId" } },
          { kind: "Field", name: { kind: "Name", value: "quantityGrams" } },
          { kind: "Field", name: { kind: "Name", value: "quantityPercent" } },
          { kind: "Field", name: { kind: "Name", value: "showQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "sortOrder" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "isOutdated" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProducerFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Producer" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "companyName" } },
          { kind: "Field", name: { kind: "Name", value: "address" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "website" } },
          { kind: "Field", name: { kind: "Name", value: "deleted" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "createdBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UserBasicFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "usedInRecipes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RecipeIngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "RecipeIngredientItem" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "FragmentSpread", name: { kind: "Name", value: "IngredientRecipeIngredientFragment" } },
          { kind: "FragmentSpread", name: { kind: "Name", value: "SubRecipeRecipeIngredientFragment" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RecipeReferenceCostFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "RecipeReferenceCost" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "totalNet" } },
          { kind: "Field", name: { kind: "Name", value: "totalGross" } },
          { kind: "Field", name: { kind: "Name", value: "perGramNet" } },
          { kind: "Field", name: { kind: "Name", value: "perGramGross" } },
          { kind: "Field", name: { kind: "Name", value: "per100gNet" } },
          { kind: "Field", name: { kind: "Name", value: "per100gGross" } },
          { kind: "Field", name: { kind: "Name", value: "perKgNet" } },
          { kind: "Field", name: { kind: "Name", value: "perKgGross" } },
          { kind: "Field", name: { kind: "Name", value: "perServingNet" } },
          { kind: "Field", name: { kind: "Name", value: "perServingGross" } },
          { kind: "Field", name: { kind: "Name", value: "perPackageNet" } },
          { kind: "Field", name: { kind: "Name", value: "perPackageGross" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "rows" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "recipeIngredientId" } },
                { kind: "Field", name: { kind: "Name", value: "net" } },
                { kind: "Field", name: { kind: "Name", value: "gross" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RecipeDetailFragment, unknown>;
export const IngredientListFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IngredientListFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Ingredient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "versionStatus" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "brand" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "hasDraft" } },
          { kind: "Field", name: { kind: "Name", value: "hasPublishedVersion" } },
          { kind: "Field", name: { kind: "Name", value: "deleted" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IngredientListFragment, unknown>;
export const DeclarationFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DeclarationFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Declaration" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "rootIndices" } },
          { kind: "Field", name: { kind: "Name", value: "derivedAllergens" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "entries" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "allergens" } },
                { kind: "Field", name: { kind: "Name", value: "percentage" } },
                { kind: "Field", name: { kind: "Name", value: "showQuantity" } },
                { kind: "Field", name: { kind: "Name", value: "childIndices" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeclarationFieldsFragment, unknown>;
export const PlanPriceFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PlanPriceFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "PlanPrice" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "plan" } },
          { kind: "Field", name: { kind: "Name", value: "amount" } },
          { kind: "Field", name: { kind: "Name", value: "amountBgn" } },
          { kind: "Field", name: { kind: "Name", value: "currency" } },
          { kind: "Field", name: { kind: "Name", value: "interval" } },
          { kind: "Field", name: { kind: "Name", value: "annualSavings" } },
          { kind: "Field", name: { kind: "Name", value: "annualSavingsBgn" } },
          { kind: "Field", name: { kind: "Name", value: "monthlyEquivalent" } },
          { kind: "Field", name: { kind: "Name", value: "monthlyEquivalentBgn" } },
          { kind: "Field", name: { kind: "Name", value: "taxBehavior" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PlanPriceFragment, unknown>;
export const GetCurrentTeamDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetCurrentTeam" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "currentTeam" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "TeamFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TeamFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Team" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "freeAccessUntil" } },
          { kind: "Field", name: { kind: "Name", value: "subscriptionStatus" } },
          { kind: "Field", name: { kind: "Name", value: "currentPeriodEnd" } },
          { kind: "Field", name: { kind: "Name", value: "cancelAt" } },
          { kind: "Field", name: { kind: "Name", value: "endedAt" } },
          { kind: "Field", name: { kind: "Name", value: "hasFullAccess" } },
          { kind: "Field", name: { kind: "Name", value: "currency" } },
          { kind: "Field", name: { kind: "Name", value: "country" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCurrentTeamQuery, GetCurrentTeamQueryVariables>;
export const GetTeamMembersDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetTeamMembers" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "teamMembers" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "TeamMemberFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserBasicFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "User" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TeamMemberFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "TeamMember" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "teamId" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "joinedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UserBasicFragment" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetTeamMembersQuery, GetTeamMembersQueryVariables>;
export const UpdateTeamSettingsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateTeamSettings" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UpdateTeamSettingsInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateTeamSettings" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "TeamFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TeamFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Team" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "freeAccessUntil" } },
          { kind: "Field", name: { kind: "Name", value: "subscriptionStatus" } },
          { kind: "Field", name: { kind: "Name", value: "currentPeriodEnd" } },
          { kind: "Field", name: { kind: "Name", value: "cancelAt" } },
          { kind: "Field", name: { kind: "Name", value: "endedAt" } },
          { kind: "Field", name: { kind: "Name", value: "hasFullAccess" } },
          { kind: "Field", name: { kind: "Name", value: "currency" } },
          { kind: "Field", name: { kind: "Name", value: "country" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateTeamSettingsMutation, UpdateTeamSettingsMutationVariables>;
export const GetVatRatePresetsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetVatRatePresets" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "vatRatePresets" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "VatRatePresetFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "VatRatePresetFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "VatRatePreset" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "rate" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetVatRatePresetsQuery, GetVatRatePresetsQueryVariables>;
export const GetPendingTeamInvitationsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetPendingTeamInvitations" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "pendingTeamInvitations" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "TeamInvitationFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserBasicFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "User" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TeamInvitationFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "TeamInvitation" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "teamId" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "token" } },
          { kind: "Field", name: { kind: "Name", value: "inviteUrl" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "expiresAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "invitedBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UserBasicFragment" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetPendingTeamInvitationsQuery, GetPendingTeamInvitationsQueryVariables>;
export const GetEmailLinkPreviewDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetEmailLinkPreview" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "token" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "emailLinkPreview" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "token" },
                value: { kind: "Variable", name: { kind: "Name", value: "token" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "email" } },
                { kind: "Field", name: { kind: "Name", value: "locale" } },
                { kind: "Field", name: { kind: "Name", value: "mode" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "invitation" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "teamId" } },
                      { kind: "Field", name: { kind: "Name", value: "inviterName" } },
                      { kind: "Field", name: { kind: "Name", value: "inviterEmail" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetEmailLinkPreviewQuery, GetEmailLinkPreviewQueryVariables>;
export const RequestEmailLinkDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "RequestEmailLink" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "RequestEmailLinkInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "requestEmailLink" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RequestEmailLinkMutation, RequestEmailLinkMutationVariables>;
export const CompleteEmailLinkDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CompleteEmailLink" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "CompleteEmailLinkInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "completeEmailLink" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UserFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "User" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "locale" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "membership" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "role" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CompleteEmailLinkMutation, CompleteEmailLinkMutationVariables>;
export const InviteTeamMemberDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "InviteTeamMember" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "InviteMemberInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "inviteMember" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "TeamInvitationFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserBasicFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "User" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TeamInvitationFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "TeamInvitation" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "teamId" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "token" } },
          { kind: "Field", name: { kind: "Name", value: "inviteUrl" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "expiresAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "invitedBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UserBasicFragment" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InviteTeamMemberMutation, InviteTeamMemberMutationVariables>;
export const CancelTeamInvitationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CancelTeamInvitation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "invitationId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Long" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "cancelTeamInvitation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "invitationId" },
                value: { kind: "Variable", name: { kind: "Name", value: "invitationId" } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CancelTeamInvitationMutation, CancelTeamInvitationMutationVariables>;
export const ChangeTeamMemberRoleDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ChangeTeamMemberRole" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ChangeMemberRoleInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "changeMemberRole" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ChangeTeamMemberRoleMutation, ChangeTeamMemberRoleMutationVariables>;
export const RemoveTeamMemberDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "RemoveTeamMember" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "userId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Long" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "removeTeamMember" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: { kind: "Variable", name: { kind: "Name", value: "userId" } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RemoveTeamMemberMutation, RemoveTeamMemberMutationVariables>;
export const GetCurrentLoggedUserDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getCurrentLoggedUser" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getCurrentLoggedUser" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UserFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "User" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "locale" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "membership" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "role" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCurrentLoggedUserQuery, GetCurrentLoggedUserQueryVariables>;
export const UpdateUserDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateUser" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "UpdateUserInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateUser" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UserFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "User" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "locale" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "membership" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "role" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateUserMutation, UpdateUserMutationVariables>;
export const LogoutDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "Logout" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [{ kind: "Field", name: { kind: "Name", value: "logoutUser" } }],
      },
    },
  ],
} as unknown as DocumentNode<LogoutMutation, LogoutMutationVariables>;
export const ListProducersDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ListProducers" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "search" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ProducerPaginationInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "producers" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "search" },
                value: { kind: "Variable", name: { kind: "Name", value: "search" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "producers" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ProducerFragment" } }],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "total" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserBasicFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "User" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProducerFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Producer" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "companyName" } },
          { kind: "Field", name: { kind: "Name", value: "address" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "website" } },
          { kind: "Field", name: { kind: "Name", value: "deleted" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "createdBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UserBasicFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "usedInRecipes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ListProducersQuery, ListProducersQueryVariables>;
export const GetProducerByIdDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetProducerById" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Long" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "producerById" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ProducerFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserBasicFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "User" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProducerFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Producer" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "companyName" } },
          { kind: "Field", name: { kind: "Name", value: "address" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "website" } },
          { kind: "Field", name: { kind: "Name", value: "deleted" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "createdBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UserBasicFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "usedInRecipes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetProducerByIdQuery, GetProducerByIdQueryVariables>;
export const CreateProducerDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateProducer" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "CreateProducerInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createProducer" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ProducerFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserBasicFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "User" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProducerFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Producer" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "companyName" } },
          { kind: "Field", name: { kind: "Name", value: "address" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "website" } },
          { kind: "Field", name: { kind: "Name", value: "deleted" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "createdBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UserBasicFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "usedInRecipes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateProducerMutation, CreateProducerMutationVariables>;
export const UpdateProducerByIdDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateProducerById" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Long" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UpdateProducerInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateProducer" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ProducerFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserBasicFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "User" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProducerFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Producer" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "companyName" } },
          { kind: "Field", name: { kind: "Name", value: "address" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "website" } },
          { kind: "Field", name: { kind: "Name", value: "deleted" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "createdBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UserBasicFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "usedInRecipes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateProducerByIdMutation, UpdateProducerByIdMutationVariables>;
export const DeleteProducerDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeleteProducer" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Long" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteProducer" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteProducerMutation, DeleteProducerMutationVariables>;
export const RestoreProducerDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "RestoreProducer" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Long" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "restoreProducer" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RestoreProducerMutation, RestoreProducerMutationVariables>;
export const ListRecipesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ListRecipes" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "search" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "RecipePaginationInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "recipes" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "search" },
                value: { kind: "Variable", name: { kind: "Name", value: "search" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "recipes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RecipeListFragment" } }],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "total" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RecipeListFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recipe" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "versionStatus" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "hasDraft" } },
          { kind: "Field", name: { kind: "Name", value: "hasPublishedVersion" } },
          { kind: "Field", name: { kind: "Name", value: "deleted" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ListRecipesQuery, ListRecipesQueryVariables>;
export const GetRecipesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetRecipes" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "search" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "RecipePaginationInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "recipes" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "search" },
                value: { kind: "Variable", name: { kind: "Name", value: "search" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "publishedOnly" },
                value: { kind: "BooleanValue", value: true },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "recipes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RecipeFragment" } }],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "total" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "NutritionProfileFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "NutritionProfile" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "energyKj" } },
          { kind: "Field", name: { kind: "Name", value: "energyKcal" } },
          { kind: "Field", name: { kind: "Name", value: "fat" } },
          { kind: "Field", name: { kind: "Name", value: "saturatedFat" } },
          { kind: "Field", name: { kind: "Name", value: "carbohydrate" } },
          { kind: "Field", name: { kind: "Name", value: "sugars" } },
          { kind: "Field", name: { kind: "Name", value: "fibre" } },
          { kind: "Field", name: { kind: "Name", value: "protein" } },
          { kind: "Field", name: { kind: "Name", value: "salt" } },
          { kind: "Field", name: { kind: "Name", value: "alcohol" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RecipeFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recipe" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "versionId" } },
          { kind: "Field", name: { kind: "Name", value: "versionNumber" } },
          { kind: "Field", name: { kind: "Name", value: "versionStatus" } },
          { kind: "Field", name: { kind: "Name", value: "versionNotes" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "nameForLabel" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionPerServing" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionPerPackage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "weightAfterCooking" } },
          { kind: "Field", name: { kind: "Name", value: "weightAfterCookingQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "weightAfterCookingUnitId" } },
          { kind: "Field", name: { kind: "Name", value: "servingSize" } },
          { kind: "Field", name: { kind: "Name", value: "servingSizeQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "servingSizeUnitId" } },
          { kind: "Field", name: { kind: "Name", value: "servingsPerPackage" } },
          { kind: "Field", name: { kind: "Name", value: "netWeight" } },
          { kind: "Field", name: { kind: "Name", value: "netWeightQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "netWeightUnitId" } },
          { kind: "Field", name: { kind: "Name", value: "storageRequirements" } },
          { kind: "Field", name: { kind: "Name", value: "labelExportUrl" } },
          { kind: "Field", name: { kind: "Name", value: "producerId" } },
          { kind: "Field", name: { kind: "Name", value: "allergens" } },
          { kind: "Field", name: { kind: "Name", value: "photoCollectionId" } },
          { kind: "Field", name: { kind: "Name", value: "hasDraft" } },
          { kind: "Field", name: { kind: "Name", value: "hasPublishedVersion" } },
          { kind: "Field", name: { kind: "Name", value: "deleted" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetRecipesQuery, GetRecipesQueryVariables>;
export const GetRecipeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetRecipe" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Long" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "draftRecipe" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RecipeDetailFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "publishedRecipe" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RecipeDetailFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "NutritionProfileFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "NutritionProfile" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "energyKj" } },
          { kind: "Field", name: { kind: "Name", value: "energyKcal" } },
          { kind: "Field", name: { kind: "Name", value: "fat" } },
          { kind: "Field", name: { kind: "Name", value: "saturatedFat" } },
          { kind: "Field", name: { kind: "Name", value: "carbohydrate" } },
          { kind: "Field", name: { kind: "Name", value: "sugars" } },
          { kind: "Field", name: { kind: "Name", value: "fibre" } },
          { kind: "Field", name: { kind: "Name", value: "protein" } },
          { kind: "Field", name: { kind: "Name", value: "salt" } },
          { kind: "Field", name: { kind: "Name", value: "alcohol" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RecipeFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recipe" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "versionId" } },
          { kind: "Field", name: { kind: "Name", value: "versionNumber" } },
          { kind: "Field", name: { kind: "Name", value: "versionStatus" } },
          { kind: "Field", name: { kind: "Name", value: "versionNotes" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "nameForLabel" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionPerServing" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionPerPackage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "weightAfterCooking" } },
          { kind: "Field", name: { kind: "Name", value: "weightAfterCookingQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "weightAfterCookingUnitId" } },
          { kind: "Field", name: { kind: "Name", value: "servingSize" } },
          { kind: "Field", name: { kind: "Name", value: "servingSizeQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "servingSizeUnitId" } },
          { kind: "Field", name: { kind: "Name", value: "servingsPerPackage" } },
          { kind: "Field", name: { kind: "Name", value: "netWeight" } },
          { kind: "Field", name: { kind: "Name", value: "netWeightQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "netWeightUnitId" } },
          { kind: "Field", name: { kind: "Name", value: "storageRequirements" } },
          { kind: "Field", name: { kind: "Name", value: "labelExportUrl" } },
          { kind: "Field", name: { kind: "Name", value: "producerId" } },
          { kind: "Field", name: { kind: "Name", value: "allergens" } },
          { kind: "Field", name: { kind: "Name", value: "photoCollectionId" } },
          { kind: "Field", name: { kind: "Name", value: "hasDraft" } },
          { kind: "Field", name: { kind: "Name", value: "hasPublishedVersion" } },
          { kind: "Field", name: { kind: "Name", value: "deleted" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserBasicFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "User" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProducerFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Producer" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "companyName" } },
          { kind: "Field", name: { kind: "Name", value: "address" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "website" } },
          { kind: "Field", name: { kind: "Name", value: "deleted" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "createdBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UserBasicFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "usedInRecipes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FileVariantFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "FileVariantInfo" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "kind" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "contentType" } },
          { kind: "Field", name: { kind: "Name", value: "sizeBytes" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CollectionFileFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CollectionFile" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "originalFilename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "variants" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "FileVariantFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "GenericIngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GenericIngredient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
          { kind: "Field", name: { kind: "Name", value: "sourceId" } },
          { kind: "Field", name: { kind: "Name", value: "nameEn" } },
          { kind: "Field", name: { kind: "Name", value: "nameBg" } },
          { kind: "Field", name: { kind: "Name", value: "nameFr" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "density" } },
          { kind: "Field", name: { kind: "Name", value: "allergens" } },
          { kind: "Field", name: { kind: "Name", value: "baseNameEn" } },
          { kind: "Field", name: { kind: "Name", value: "baseNameBg" } },
          { kind: "Field", name: { kind: "Name", value: "baseNameFr" } },
          { kind: "Field", name: { kind: "Name", value: "propertiesEn" } },
          { kind: "Field", name: { kind: "Name", value: "propertiesBg" } },
          { kind: "Field", name: { kind: "Name", value: "propertiesFr" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "foodCategory" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "nameEn" } },
                { kind: "Field", name: { kind: "Name", value: "nameBg" } },
                { kind: "Field", name: { kind: "Name", value: "nameFr" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IngredientReferencePriceFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "IngredientReferencePrice" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "quantity" } },
          { kind: "Field", name: { kind: "Name", value: "unitId" } },
          { kind: "Field", name: { kind: "Name", value: "price" } },
          { kind: "Field", name: { kind: "Name", value: "includesVat" } },
          { kind: "Field", name: { kind: "Name", value: "vatRate" } },
          { kind: "Field", name: { kind: "Name", value: "netPerGram" } },
          { kind: "Field", name: { kind: "Name", value: "grossPerGram" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Ingredient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "versionId" } },
          { kind: "Field", name: { kind: "Name", value: "versionNumber" } },
          { kind: "Field", name: { kind: "Name", value: "versionStatus" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "nameForLabel" } },
          { kind: "Field", name: { kind: "Name", value: "brand" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "density" } },
          { kind: "Field", name: { kind: "Name", value: "allergens" } },
          { kind: "Field", name: { kind: "Name", value: "nutritionReferenceQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "nutritionReferenceUnitId" } },
          { kind: "Field", name: { kind: "Name", value: "nutritionReferenceGrams" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "referenceNutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "genericIngredientId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "genericIngredient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GenericIngredientFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "photoCollectionId" } },
          { kind: "Field", name: { kind: "Name", value: "hasDraft" } },
          { kind: "Field", name: { kind: "Name", value: "hasPublishedVersion" } },
          { kind: "Field", name: { kind: "Name", value: "deleted" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "referencePrice" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "IngredientReferencePriceFragment" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "createdBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UserBasicFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "photos" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "CollectionFileFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "labelIngredients" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "parentId" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "percentage" } },
                { kind: "Field", name: { kind: "Name", value: "sortOrder" } },
                { kind: "Field", name: { kind: "Name", value: "allergens" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "usedInRecipes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "isOutdated" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "recipe" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IngredientRecipeIngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "IngredientRecipeIngredient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "ingredient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "IngredientFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "quantity" } },
          { kind: "Field", name: { kind: "Name", value: "unitId" } },
          { kind: "Field", name: { kind: "Name", value: "quantityGrams" } },
          { kind: "Field", name: { kind: "Name", value: "quantityPercent" } },
          { kind: "Field", name: { kind: "Name", value: "showQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "sortOrder" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "isOutdated" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SubRecipeRecipeIngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "SubRecipeRecipeIngredient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "recipe" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RecipeFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "quantity" } },
          { kind: "Field", name: { kind: "Name", value: "unitId" } },
          { kind: "Field", name: { kind: "Name", value: "quantityGrams" } },
          { kind: "Field", name: { kind: "Name", value: "quantityPercent" } },
          { kind: "Field", name: { kind: "Name", value: "showQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "sortOrder" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "isOutdated" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RecipeIngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "RecipeIngredientItem" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "FragmentSpread", name: { kind: "Name", value: "IngredientRecipeIngredientFragment" } },
          { kind: "FragmentSpread", name: { kind: "Name", value: "SubRecipeRecipeIngredientFragment" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RecipeReferenceCostFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "RecipeReferenceCost" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "totalNet" } },
          { kind: "Field", name: { kind: "Name", value: "totalGross" } },
          { kind: "Field", name: { kind: "Name", value: "perGramNet" } },
          { kind: "Field", name: { kind: "Name", value: "perGramGross" } },
          { kind: "Field", name: { kind: "Name", value: "per100gNet" } },
          { kind: "Field", name: { kind: "Name", value: "per100gGross" } },
          { kind: "Field", name: { kind: "Name", value: "perKgNet" } },
          { kind: "Field", name: { kind: "Name", value: "perKgGross" } },
          { kind: "Field", name: { kind: "Name", value: "perServingNet" } },
          { kind: "Field", name: { kind: "Name", value: "perServingGross" } },
          { kind: "Field", name: { kind: "Name", value: "perPackageNet" } },
          { kind: "Field", name: { kind: "Name", value: "perPackageGross" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "rows" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "recipeIngredientId" } },
                { kind: "Field", name: { kind: "Name", value: "net" } },
                { kind: "Field", name: { kind: "Name", value: "gross" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RecipeDetailFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recipe" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "FragmentSpread", name: { kind: "Name", value: "RecipeFragment" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "createdBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UserBasicFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "producer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ProducerFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "photos" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "CollectionFileFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "ingredients" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RecipeIngredientFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "referenceCost" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RecipeReferenceCostFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "usedAsSubRecipeIn" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "isOutdated" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "recipe" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetRecipeQuery, GetRecipeQueryVariables>;
export const GetRecipeByVersionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetRecipeByVersion" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Long" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "versionNumber" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "recipeByVersion" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "versionNumber" },
                value: { kind: "Variable", name: { kind: "Name", value: "versionNumber" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RecipeDetailFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "NutritionProfileFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "NutritionProfile" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "energyKj" } },
          { kind: "Field", name: { kind: "Name", value: "energyKcal" } },
          { kind: "Field", name: { kind: "Name", value: "fat" } },
          { kind: "Field", name: { kind: "Name", value: "saturatedFat" } },
          { kind: "Field", name: { kind: "Name", value: "carbohydrate" } },
          { kind: "Field", name: { kind: "Name", value: "sugars" } },
          { kind: "Field", name: { kind: "Name", value: "fibre" } },
          { kind: "Field", name: { kind: "Name", value: "protein" } },
          { kind: "Field", name: { kind: "Name", value: "salt" } },
          { kind: "Field", name: { kind: "Name", value: "alcohol" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RecipeFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recipe" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "versionId" } },
          { kind: "Field", name: { kind: "Name", value: "versionNumber" } },
          { kind: "Field", name: { kind: "Name", value: "versionStatus" } },
          { kind: "Field", name: { kind: "Name", value: "versionNotes" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "nameForLabel" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionPerServing" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionPerPackage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "weightAfterCooking" } },
          { kind: "Field", name: { kind: "Name", value: "weightAfterCookingQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "weightAfterCookingUnitId" } },
          { kind: "Field", name: { kind: "Name", value: "servingSize" } },
          { kind: "Field", name: { kind: "Name", value: "servingSizeQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "servingSizeUnitId" } },
          { kind: "Field", name: { kind: "Name", value: "servingsPerPackage" } },
          { kind: "Field", name: { kind: "Name", value: "netWeight" } },
          { kind: "Field", name: { kind: "Name", value: "netWeightQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "netWeightUnitId" } },
          { kind: "Field", name: { kind: "Name", value: "storageRequirements" } },
          { kind: "Field", name: { kind: "Name", value: "labelExportUrl" } },
          { kind: "Field", name: { kind: "Name", value: "producerId" } },
          { kind: "Field", name: { kind: "Name", value: "allergens" } },
          { kind: "Field", name: { kind: "Name", value: "photoCollectionId" } },
          { kind: "Field", name: { kind: "Name", value: "hasDraft" } },
          { kind: "Field", name: { kind: "Name", value: "hasPublishedVersion" } },
          { kind: "Field", name: { kind: "Name", value: "deleted" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserBasicFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "User" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProducerFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Producer" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "companyName" } },
          { kind: "Field", name: { kind: "Name", value: "address" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "website" } },
          { kind: "Field", name: { kind: "Name", value: "deleted" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "createdBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UserBasicFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "usedInRecipes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FileVariantFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "FileVariantInfo" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "kind" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "contentType" } },
          { kind: "Field", name: { kind: "Name", value: "sizeBytes" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CollectionFileFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CollectionFile" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "originalFilename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "variants" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "FileVariantFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "GenericIngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GenericIngredient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
          { kind: "Field", name: { kind: "Name", value: "sourceId" } },
          { kind: "Field", name: { kind: "Name", value: "nameEn" } },
          { kind: "Field", name: { kind: "Name", value: "nameBg" } },
          { kind: "Field", name: { kind: "Name", value: "nameFr" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "density" } },
          { kind: "Field", name: { kind: "Name", value: "allergens" } },
          { kind: "Field", name: { kind: "Name", value: "baseNameEn" } },
          { kind: "Field", name: { kind: "Name", value: "baseNameBg" } },
          { kind: "Field", name: { kind: "Name", value: "baseNameFr" } },
          { kind: "Field", name: { kind: "Name", value: "propertiesEn" } },
          { kind: "Field", name: { kind: "Name", value: "propertiesBg" } },
          { kind: "Field", name: { kind: "Name", value: "propertiesFr" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "foodCategory" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "nameEn" } },
                { kind: "Field", name: { kind: "Name", value: "nameBg" } },
                { kind: "Field", name: { kind: "Name", value: "nameFr" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IngredientReferencePriceFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "IngredientReferencePrice" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "quantity" } },
          { kind: "Field", name: { kind: "Name", value: "unitId" } },
          { kind: "Field", name: { kind: "Name", value: "price" } },
          { kind: "Field", name: { kind: "Name", value: "includesVat" } },
          { kind: "Field", name: { kind: "Name", value: "vatRate" } },
          { kind: "Field", name: { kind: "Name", value: "netPerGram" } },
          { kind: "Field", name: { kind: "Name", value: "grossPerGram" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Ingredient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "versionId" } },
          { kind: "Field", name: { kind: "Name", value: "versionNumber" } },
          { kind: "Field", name: { kind: "Name", value: "versionStatus" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "nameForLabel" } },
          { kind: "Field", name: { kind: "Name", value: "brand" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "density" } },
          { kind: "Field", name: { kind: "Name", value: "allergens" } },
          { kind: "Field", name: { kind: "Name", value: "nutritionReferenceQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "nutritionReferenceUnitId" } },
          { kind: "Field", name: { kind: "Name", value: "nutritionReferenceGrams" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "referenceNutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "genericIngredientId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "genericIngredient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GenericIngredientFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "photoCollectionId" } },
          { kind: "Field", name: { kind: "Name", value: "hasDraft" } },
          { kind: "Field", name: { kind: "Name", value: "hasPublishedVersion" } },
          { kind: "Field", name: { kind: "Name", value: "deleted" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "referencePrice" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "IngredientReferencePriceFragment" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "createdBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UserBasicFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "photos" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "CollectionFileFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "labelIngredients" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "parentId" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "percentage" } },
                { kind: "Field", name: { kind: "Name", value: "sortOrder" } },
                { kind: "Field", name: { kind: "Name", value: "allergens" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "usedInRecipes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "isOutdated" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "recipe" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IngredientRecipeIngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "IngredientRecipeIngredient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "ingredient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "IngredientFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "quantity" } },
          { kind: "Field", name: { kind: "Name", value: "unitId" } },
          { kind: "Field", name: { kind: "Name", value: "quantityGrams" } },
          { kind: "Field", name: { kind: "Name", value: "quantityPercent" } },
          { kind: "Field", name: { kind: "Name", value: "showQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "sortOrder" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "isOutdated" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SubRecipeRecipeIngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "SubRecipeRecipeIngredient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "recipe" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RecipeFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "quantity" } },
          { kind: "Field", name: { kind: "Name", value: "unitId" } },
          { kind: "Field", name: { kind: "Name", value: "quantityGrams" } },
          { kind: "Field", name: { kind: "Name", value: "quantityPercent" } },
          { kind: "Field", name: { kind: "Name", value: "showQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "sortOrder" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "isOutdated" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RecipeIngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "RecipeIngredientItem" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "FragmentSpread", name: { kind: "Name", value: "IngredientRecipeIngredientFragment" } },
          { kind: "FragmentSpread", name: { kind: "Name", value: "SubRecipeRecipeIngredientFragment" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RecipeReferenceCostFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "RecipeReferenceCost" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "totalNet" } },
          { kind: "Field", name: { kind: "Name", value: "totalGross" } },
          { kind: "Field", name: { kind: "Name", value: "perGramNet" } },
          { kind: "Field", name: { kind: "Name", value: "perGramGross" } },
          { kind: "Field", name: { kind: "Name", value: "per100gNet" } },
          { kind: "Field", name: { kind: "Name", value: "per100gGross" } },
          { kind: "Field", name: { kind: "Name", value: "perKgNet" } },
          { kind: "Field", name: { kind: "Name", value: "perKgGross" } },
          { kind: "Field", name: { kind: "Name", value: "perServingNet" } },
          { kind: "Field", name: { kind: "Name", value: "perServingGross" } },
          { kind: "Field", name: { kind: "Name", value: "perPackageNet" } },
          { kind: "Field", name: { kind: "Name", value: "perPackageGross" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "rows" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "recipeIngredientId" } },
                { kind: "Field", name: { kind: "Name", value: "net" } },
                { kind: "Field", name: { kind: "Name", value: "gross" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RecipeDetailFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recipe" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "FragmentSpread", name: { kind: "Name", value: "RecipeFragment" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "createdBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UserBasicFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "producer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ProducerFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "photos" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "CollectionFileFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "ingredients" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RecipeIngredientFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "referenceCost" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RecipeReferenceCostFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "usedAsSubRecipeIn" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "isOutdated" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "recipe" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetRecipeByVersionQuery, GetRecipeByVersionQueryVariables>;
export const CreateRecipeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateRecipe" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "CreateRecipeInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createRecipe" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RecipeFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "NutritionProfileFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "NutritionProfile" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "energyKj" } },
          { kind: "Field", name: { kind: "Name", value: "energyKcal" } },
          { kind: "Field", name: { kind: "Name", value: "fat" } },
          { kind: "Field", name: { kind: "Name", value: "saturatedFat" } },
          { kind: "Field", name: { kind: "Name", value: "carbohydrate" } },
          { kind: "Field", name: { kind: "Name", value: "sugars" } },
          { kind: "Field", name: { kind: "Name", value: "fibre" } },
          { kind: "Field", name: { kind: "Name", value: "protein" } },
          { kind: "Field", name: { kind: "Name", value: "salt" } },
          { kind: "Field", name: { kind: "Name", value: "alcohol" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RecipeFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recipe" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "versionId" } },
          { kind: "Field", name: { kind: "Name", value: "versionNumber" } },
          { kind: "Field", name: { kind: "Name", value: "versionStatus" } },
          { kind: "Field", name: { kind: "Name", value: "versionNotes" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "nameForLabel" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionPerServing" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionPerPackage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "weightAfterCooking" } },
          { kind: "Field", name: { kind: "Name", value: "weightAfterCookingQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "weightAfterCookingUnitId" } },
          { kind: "Field", name: { kind: "Name", value: "servingSize" } },
          { kind: "Field", name: { kind: "Name", value: "servingSizeQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "servingSizeUnitId" } },
          { kind: "Field", name: { kind: "Name", value: "servingsPerPackage" } },
          { kind: "Field", name: { kind: "Name", value: "netWeight" } },
          { kind: "Field", name: { kind: "Name", value: "netWeightQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "netWeightUnitId" } },
          { kind: "Field", name: { kind: "Name", value: "storageRequirements" } },
          { kind: "Field", name: { kind: "Name", value: "labelExportUrl" } },
          { kind: "Field", name: { kind: "Name", value: "producerId" } },
          { kind: "Field", name: { kind: "Name", value: "allergens" } },
          { kind: "Field", name: { kind: "Name", value: "photoCollectionId" } },
          { kind: "Field", name: { kind: "Name", value: "hasDraft" } },
          { kind: "Field", name: { kind: "Name", value: "hasPublishedVersion" } },
          { kind: "Field", name: { kind: "Name", value: "deleted" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateRecipeMutation, CreateRecipeMutationVariables>;
export const DuplicateRecipeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DuplicateRecipe" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Long" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "DuplicateRecipeInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "duplicateRecipe" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RecipeFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "NutritionProfileFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "NutritionProfile" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "energyKj" } },
          { kind: "Field", name: { kind: "Name", value: "energyKcal" } },
          { kind: "Field", name: { kind: "Name", value: "fat" } },
          { kind: "Field", name: { kind: "Name", value: "saturatedFat" } },
          { kind: "Field", name: { kind: "Name", value: "carbohydrate" } },
          { kind: "Field", name: { kind: "Name", value: "sugars" } },
          { kind: "Field", name: { kind: "Name", value: "fibre" } },
          { kind: "Field", name: { kind: "Name", value: "protein" } },
          { kind: "Field", name: { kind: "Name", value: "salt" } },
          { kind: "Field", name: { kind: "Name", value: "alcohol" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RecipeFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recipe" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "versionId" } },
          { kind: "Field", name: { kind: "Name", value: "versionNumber" } },
          { kind: "Field", name: { kind: "Name", value: "versionStatus" } },
          { kind: "Field", name: { kind: "Name", value: "versionNotes" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "nameForLabel" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionPerServing" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionPerPackage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "weightAfterCooking" } },
          { kind: "Field", name: { kind: "Name", value: "weightAfterCookingQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "weightAfterCookingUnitId" } },
          { kind: "Field", name: { kind: "Name", value: "servingSize" } },
          { kind: "Field", name: { kind: "Name", value: "servingSizeQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "servingSizeUnitId" } },
          { kind: "Field", name: { kind: "Name", value: "servingsPerPackage" } },
          { kind: "Field", name: { kind: "Name", value: "netWeight" } },
          { kind: "Field", name: { kind: "Name", value: "netWeightQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "netWeightUnitId" } },
          { kind: "Field", name: { kind: "Name", value: "storageRequirements" } },
          { kind: "Field", name: { kind: "Name", value: "labelExportUrl" } },
          { kind: "Field", name: { kind: "Name", value: "producerId" } },
          { kind: "Field", name: { kind: "Name", value: "allergens" } },
          { kind: "Field", name: { kind: "Name", value: "photoCollectionId" } },
          { kind: "Field", name: { kind: "Name", value: "hasDraft" } },
          { kind: "Field", name: { kind: "Name", value: "hasPublishedVersion" } },
          { kind: "Field", name: { kind: "Name", value: "deleted" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DuplicateRecipeMutation, DuplicateRecipeMutationVariables>;
export const UpdateRecipeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateRecipe" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Long" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UpdateRecipeInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateRecipe" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "refreshedRecipe" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RecipeDetailFragment" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "NutritionProfileFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "NutritionProfile" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "energyKj" } },
          { kind: "Field", name: { kind: "Name", value: "energyKcal" } },
          { kind: "Field", name: { kind: "Name", value: "fat" } },
          { kind: "Field", name: { kind: "Name", value: "saturatedFat" } },
          { kind: "Field", name: { kind: "Name", value: "carbohydrate" } },
          { kind: "Field", name: { kind: "Name", value: "sugars" } },
          { kind: "Field", name: { kind: "Name", value: "fibre" } },
          { kind: "Field", name: { kind: "Name", value: "protein" } },
          { kind: "Field", name: { kind: "Name", value: "salt" } },
          { kind: "Field", name: { kind: "Name", value: "alcohol" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RecipeFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recipe" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "versionId" } },
          { kind: "Field", name: { kind: "Name", value: "versionNumber" } },
          { kind: "Field", name: { kind: "Name", value: "versionStatus" } },
          { kind: "Field", name: { kind: "Name", value: "versionNotes" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "nameForLabel" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionPerServing" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionPerPackage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "weightAfterCooking" } },
          { kind: "Field", name: { kind: "Name", value: "weightAfterCookingQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "weightAfterCookingUnitId" } },
          { kind: "Field", name: { kind: "Name", value: "servingSize" } },
          { kind: "Field", name: { kind: "Name", value: "servingSizeQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "servingSizeUnitId" } },
          { kind: "Field", name: { kind: "Name", value: "servingsPerPackage" } },
          { kind: "Field", name: { kind: "Name", value: "netWeight" } },
          { kind: "Field", name: { kind: "Name", value: "netWeightQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "netWeightUnitId" } },
          { kind: "Field", name: { kind: "Name", value: "storageRequirements" } },
          { kind: "Field", name: { kind: "Name", value: "labelExportUrl" } },
          { kind: "Field", name: { kind: "Name", value: "producerId" } },
          { kind: "Field", name: { kind: "Name", value: "allergens" } },
          { kind: "Field", name: { kind: "Name", value: "photoCollectionId" } },
          { kind: "Field", name: { kind: "Name", value: "hasDraft" } },
          { kind: "Field", name: { kind: "Name", value: "hasPublishedVersion" } },
          { kind: "Field", name: { kind: "Name", value: "deleted" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserBasicFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "User" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProducerFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Producer" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "companyName" } },
          { kind: "Field", name: { kind: "Name", value: "address" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "website" } },
          { kind: "Field", name: { kind: "Name", value: "deleted" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "createdBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UserBasicFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "usedInRecipes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FileVariantFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "FileVariantInfo" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "kind" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "contentType" } },
          { kind: "Field", name: { kind: "Name", value: "sizeBytes" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CollectionFileFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CollectionFile" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "originalFilename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "variants" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "FileVariantFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "GenericIngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GenericIngredient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
          { kind: "Field", name: { kind: "Name", value: "sourceId" } },
          { kind: "Field", name: { kind: "Name", value: "nameEn" } },
          { kind: "Field", name: { kind: "Name", value: "nameBg" } },
          { kind: "Field", name: { kind: "Name", value: "nameFr" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "density" } },
          { kind: "Field", name: { kind: "Name", value: "allergens" } },
          { kind: "Field", name: { kind: "Name", value: "baseNameEn" } },
          { kind: "Field", name: { kind: "Name", value: "baseNameBg" } },
          { kind: "Field", name: { kind: "Name", value: "baseNameFr" } },
          { kind: "Field", name: { kind: "Name", value: "propertiesEn" } },
          { kind: "Field", name: { kind: "Name", value: "propertiesBg" } },
          { kind: "Field", name: { kind: "Name", value: "propertiesFr" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "foodCategory" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "nameEn" } },
                { kind: "Field", name: { kind: "Name", value: "nameBg" } },
                { kind: "Field", name: { kind: "Name", value: "nameFr" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IngredientReferencePriceFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "IngredientReferencePrice" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "quantity" } },
          { kind: "Field", name: { kind: "Name", value: "unitId" } },
          { kind: "Field", name: { kind: "Name", value: "price" } },
          { kind: "Field", name: { kind: "Name", value: "includesVat" } },
          { kind: "Field", name: { kind: "Name", value: "vatRate" } },
          { kind: "Field", name: { kind: "Name", value: "netPerGram" } },
          { kind: "Field", name: { kind: "Name", value: "grossPerGram" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Ingredient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "versionId" } },
          { kind: "Field", name: { kind: "Name", value: "versionNumber" } },
          { kind: "Field", name: { kind: "Name", value: "versionStatus" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "nameForLabel" } },
          { kind: "Field", name: { kind: "Name", value: "brand" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "density" } },
          { kind: "Field", name: { kind: "Name", value: "allergens" } },
          { kind: "Field", name: { kind: "Name", value: "nutritionReferenceQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "nutritionReferenceUnitId" } },
          { kind: "Field", name: { kind: "Name", value: "nutritionReferenceGrams" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "referenceNutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "genericIngredientId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "genericIngredient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GenericIngredientFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "photoCollectionId" } },
          { kind: "Field", name: { kind: "Name", value: "hasDraft" } },
          { kind: "Field", name: { kind: "Name", value: "hasPublishedVersion" } },
          { kind: "Field", name: { kind: "Name", value: "deleted" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "referencePrice" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "IngredientReferencePriceFragment" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "createdBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UserBasicFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "photos" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "CollectionFileFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "labelIngredients" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "parentId" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "percentage" } },
                { kind: "Field", name: { kind: "Name", value: "sortOrder" } },
                { kind: "Field", name: { kind: "Name", value: "allergens" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "usedInRecipes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "isOutdated" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "recipe" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IngredientRecipeIngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "IngredientRecipeIngredient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "ingredient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "IngredientFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "quantity" } },
          { kind: "Field", name: { kind: "Name", value: "unitId" } },
          { kind: "Field", name: { kind: "Name", value: "quantityGrams" } },
          { kind: "Field", name: { kind: "Name", value: "quantityPercent" } },
          { kind: "Field", name: { kind: "Name", value: "showQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "sortOrder" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "isOutdated" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SubRecipeRecipeIngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "SubRecipeRecipeIngredient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "recipe" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RecipeFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "quantity" } },
          { kind: "Field", name: { kind: "Name", value: "unitId" } },
          { kind: "Field", name: { kind: "Name", value: "quantityGrams" } },
          { kind: "Field", name: { kind: "Name", value: "quantityPercent" } },
          { kind: "Field", name: { kind: "Name", value: "showQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "sortOrder" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "isOutdated" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RecipeIngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "RecipeIngredientItem" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "FragmentSpread", name: { kind: "Name", value: "IngredientRecipeIngredientFragment" } },
          { kind: "FragmentSpread", name: { kind: "Name", value: "SubRecipeRecipeIngredientFragment" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RecipeReferenceCostFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "RecipeReferenceCost" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "totalNet" } },
          { kind: "Field", name: { kind: "Name", value: "totalGross" } },
          { kind: "Field", name: { kind: "Name", value: "perGramNet" } },
          { kind: "Field", name: { kind: "Name", value: "perGramGross" } },
          { kind: "Field", name: { kind: "Name", value: "per100gNet" } },
          { kind: "Field", name: { kind: "Name", value: "per100gGross" } },
          { kind: "Field", name: { kind: "Name", value: "perKgNet" } },
          { kind: "Field", name: { kind: "Name", value: "perKgGross" } },
          { kind: "Field", name: { kind: "Name", value: "perServingNet" } },
          { kind: "Field", name: { kind: "Name", value: "perServingGross" } },
          { kind: "Field", name: { kind: "Name", value: "perPackageNet" } },
          { kind: "Field", name: { kind: "Name", value: "perPackageGross" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "rows" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "recipeIngredientId" } },
                { kind: "Field", name: { kind: "Name", value: "net" } },
                { kind: "Field", name: { kind: "Name", value: "gross" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RecipeDetailFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recipe" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "FragmentSpread", name: { kind: "Name", value: "RecipeFragment" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "createdBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UserBasicFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "producer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ProducerFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "photos" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "CollectionFileFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "ingredients" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RecipeIngredientFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "referenceCost" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RecipeReferenceCostFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "usedAsSubRecipeIn" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "isOutdated" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "recipe" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateRecipeMutation, UpdateRecipeMutationVariables>;
export const DeleteRecipeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeleteRecipe" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Long" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteRecipe" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteRecipeMutation, DeleteRecipeMutationVariables>;
export const RestoreRecipeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "RestoreRecipe" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Long" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "restoreRecipe" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RestoreRecipeMutation, RestoreRecipeMutationVariables>;
export const PublishRecipeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "PublishRecipe" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Long" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "notes" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "publishRecipe" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "notes" },
                value: { kind: "Variable", name: { kind: "Name", value: "notes" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "refreshedRecipe" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RecipeDetailFragment" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "NutritionProfileFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "NutritionProfile" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "energyKj" } },
          { kind: "Field", name: { kind: "Name", value: "energyKcal" } },
          { kind: "Field", name: { kind: "Name", value: "fat" } },
          { kind: "Field", name: { kind: "Name", value: "saturatedFat" } },
          { kind: "Field", name: { kind: "Name", value: "carbohydrate" } },
          { kind: "Field", name: { kind: "Name", value: "sugars" } },
          { kind: "Field", name: { kind: "Name", value: "fibre" } },
          { kind: "Field", name: { kind: "Name", value: "protein" } },
          { kind: "Field", name: { kind: "Name", value: "salt" } },
          { kind: "Field", name: { kind: "Name", value: "alcohol" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RecipeFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recipe" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "versionId" } },
          { kind: "Field", name: { kind: "Name", value: "versionNumber" } },
          { kind: "Field", name: { kind: "Name", value: "versionStatus" } },
          { kind: "Field", name: { kind: "Name", value: "versionNotes" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "nameForLabel" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionPerServing" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionPerPackage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "weightAfterCooking" } },
          { kind: "Field", name: { kind: "Name", value: "weightAfterCookingQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "weightAfterCookingUnitId" } },
          { kind: "Field", name: { kind: "Name", value: "servingSize" } },
          { kind: "Field", name: { kind: "Name", value: "servingSizeQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "servingSizeUnitId" } },
          { kind: "Field", name: { kind: "Name", value: "servingsPerPackage" } },
          { kind: "Field", name: { kind: "Name", value: "netWeight" } },
          { kind: "Field", name: { kind: "Name", value: "netWeightQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "netWeightUnitId" } },
          { kind: "Field", name: { kind: "Name", value: "storageRequirements" } },
          { kind: "Field", name: { kind: "Name", value: "labelExportUrl" } },
          { kind: "Field", name: { kind: "Name", value: "producerId" } },
          { kind: "Field", name: { kind: "Name", value: "allergens" } },
          { kind: "Field", name: { kind: "Name", value: "photoCollectionId" } },
          { kind: "Field", name: { kind: "Name", value: "hasDraft" } },
          { kind: "Field", name: { kind: "Name", value: "hasPublishedVersion" } },
          { kind: "Field", name: { kind: "Name", value: "deleted" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserBasicFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "User" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProducerFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Producer" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "companyName" } },
          { kind: "Field", name: { kind: "Name", value: "address" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "website" } },
          { kind: "Field", name: { kind: "Name", value: "deleted" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "createdBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UserBasicFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "usedInRecipes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FileVariantFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "FileVariantInfo" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "kind" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "contentType" } },
          { kind: "Field", name: { kind: "Name", value: "sizeBytes" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CollectionFileFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CollectionFile" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "originalFilename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "variants" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "FileVariantFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "GenericIngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GenericIngredient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
          { kind: "Field", name: { kind: "Name", value: "sourceId" } },
          { kind: "Field", name: { kind: "Name", value: "nameEn" } },
          { kind: "Field", name: { kind: "Name", value: "nameBg" } },
          { kind: "Field", name: { kind: "Name", value: "nameFr" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "density" } },
          { kind: "Field", name: { kind: "Name", value: "allergens" } },
          { kind: "Field", name: { kind: "Name", value: "baseNameEn" } },
          { kind: "Field", name: { kind: "Name", value: "baseNameBg" } },
          { kind: "Field", name: { kind: "Name", value: "baseNameFr" } },
          { kind: "Field", name: { kind: "Name", value: "propertiesEn" } },
          { kind: "Field", name: { kind: "Name", value: "propertiesBg" } },
          { kind: "Field", name: { kind: "Name", value: "propertiesFr" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "foodCategory" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "nameEn" } },
                { kind: "Field", name: { kind: "Name", value: "nameBg" } },
                { kind: "Field", name: { kind: "Name", value: "nameFr" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IngredientReferencePriceFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "IngredientReferencePrice" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "quantity" } },
          { kind: "Field", name: { kind: "Name", value: "unitId" } },
          { kind: "Field", name: { kind: "Name", value: "price" } },
          { kind: "Field", name: { kind: "Name", value: "includesVat" } },
          { kind: "Field", name: { kind: "Name", value: "vatRate" } },
          { kind: "Field", name: { kind: "Name", value: "netPerGram" } },
          { kind: "Field", name: { kind: "Name", value: "grossPerGram" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Ingredient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "versionId" } },
          { kind: "Field", name: { kind: "Name", value: "versionNumber" } },
          { kind: "Field", name: { kind: "Name", value: "versionStatus" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "nameForLabel" } },
          { kind: "Field", name: { kind: "Name", value: "brand" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "density" } },
          { kind: "Field", name: { kind: "Name", value: "allergens" } },
          { kind: "Field", name: { kind: "Name", value: "nutritionReferenceQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "nutritionReferenceUnitId" } },
          { kind: "Field", name: { kind: "Name", value: "nutritionReferenceGrams" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "referenceNutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "genericIngredientId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "genericIngredient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GenericIngredientFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "photoCollectionId" } },
          { kind: "Field", name: { kind: "Name", value: "hasDraft" } },
          { kind: "Field", name: { kind: "Name", value: "hasPublishedVersion" } },
          { kind: "Field", name: { kind: "Name", value: "deleted" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "referencePrice" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "IngredientReferencePriceFragment" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "createdBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UserBasicFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "photos" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "CollectionFileFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "labelIngredients" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "parentId" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "percentage" } },
                { kind: "Field", name: { kind: "Name", value: "sortOrder" } },
                { kind: "Field", name: { kind: "Name", value: "allergens" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "usedInRecipes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "isOutdated" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "recipe" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IngredientRecipeIngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "IngredientRecipeIngredient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "ingredient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "IngredientFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "quantity" } },
          { kind: "Field", name: { kind: "Name", value: "unitId" } },
          { kind: "Field", name: { kind: "Name", value: "quantityGrams" } },
          { kind: "Field", name: { kind: "Name", value: "quantityPercent" } },
          { kind: "Field", name: { kind: "Name", value: "showQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "sortOrder" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "isOutdated" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SubRecipeRecipeIngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "SubRecipeRecipeIngredient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "recipe" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RecipeFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "quantity" } },
          { kind: "Field", name: { kind: "Name", value: "unitId" } },
          { kind: "Field", name: { kind: "Name", value: "quantityGrams" } },
          { kind: "Field", name: { kind: "Name", value: "quantityPercent" } },
          { kind: "Field", name: { kind: "Name", value: "showQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "sortOrder" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "isOutdated" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RecipeIngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "RecipeIngredientItem" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "FragmentSpread", name: { kind: "Name", value: "IngredientRecipeIngredientFragment" } },
          { kind: "FragmentSpread", name: { kind: "Name", value: "SubRecipeRecipeIngredientFragment" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RecipeReferenceCostFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "RecipeReferenceCost" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "totalNet" } },
          { kind: "Field", name: { kind: "Name", value: "totalGross" } },
          { kind: "Field", name: { kind: "Name", value: "perGramNet" } },
          { kind: "Field", name: { kind: "Name", value: "perGramGross" } },
          { kind: "Field", name: { kind: "Name", value: "per100gNet" } },
          { kind: "Field", name: { kind: "Name", value: "per100gGross" } },
          { kind: "Field", name: { kind: "Name", value: "perKgNet" } },
          { kind: "Field", name: { kind: "Name", value: "perKgGross" } },
          { kind: "Field", name: { kind: "Name", value: "perServingNet" } },
          { kind: "Field", name: { kind: "Name", value: "perServingGross" } },
          { kind: "Field", name: { kind: "Name", value: "perPackageNet" } },
          { kind: "Field", name: { kind: "Name", value: "perPackageGross" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "rows" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "recipeIngredientId" } },
                { kind: "Field", name: { kind: "Name", value: "net" } },
                { kind: "Field", name: { kind: "Name", value: "gross" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RecipeDetailFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recipe" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "FragmentSpread", name: { kind: "Name", value: "RecipeFragment" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "createdBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UserBasicFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "producer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ProducerFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "photos" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "CollectionFileFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "ingredients" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RecipeIngredientFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "referenceCost" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RecipeReferenceCostFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "usedAsSubRecipeIn" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "isOutdated" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "recipe" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PublishRecipeMutation, PublishRecipeMutationVariables>;
export const CreateRecipeDraftDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateRecipeDraft" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Long" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createRecipeDraft" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "refreshedRecipe" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RecipeDetailFragment" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "NutritionProfileFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "NutritionProfile" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "energyKj" } },
          { kind: "Field", name: { kind: "Name", value: "energyKcal" } },
          { kind: "Field", name: { kind: "Name", value: "fat" } },
          { kind: "Field", name: { kind: "Name", value: "saturatedFat" } },
          { kind: "Field", name: { kind: "Name", value: "carbohydrate" } },
          { kind: "Field", name: { kind: "Name", value: "sugars" } },
          { kind: "Field", name: { kind: "Name", value: "fibre" } },
          { kind: "Field", name: { kind: "Name", value: "protein" } },
          { kind: "Field", name: { kind: "Name", value: "salt" } },
          { kind: "Field", name: { kind: "Name", value: "alcohol" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RecipeFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recipe" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "versionId" } },
          { kind: "Field", name: { kind: "Name", value: "versionNumber" } },
          { kind: "Field", name: { kind: "Name", value: "versionStatus" } },
          { kind: "Field", name: { kind: "Name", value: "versionNotes" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "nameForLabel" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionPerServing" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionPerPackage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "weightAfterCooking" } },
          { kind: "Field", name: { kind: "Name", value: "weightAfterCookingQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "weightAfterCookingUnitId" } },
          { kind: "Field", name: { kind: "Name", value: "servingSize" } },
          { kind: "Field", name: { kind: "Name", value: "servingSizeQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "servingSizeUnitId" } },
          { kind: "Field", name: { kind: "Name", value: "servingsPerPackage" } },
          { kind: "Field", name: { kind: "Name", value: "netWeight" } },
          { kind: "Field", name: { kind: "Name", value: "netWeightQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "netWeightUnitId" } },
          { kind: "Field", name: { kind: "Name", value: "storageRequirements" } },
          { kind: "Field", name: { kind: "Name", value: "labelExportUrl" } },
          { kind: "Field", name: { kind: "Name", value: "producerId" } },
          { kind: "Field", name: { kind: "Name", value: "allergens" } },
          { kind: "Field", name: { kind: "Name", value: "photoCollectionId" } },
          { kind: "Field", name: { kind: "Name", value: "hasDraft" } },
          { kind: "Field", name: { kind: "Name", value: "hasPublishedVersion" } },
          { kind: "Field", name: { kind: "Name", value: "deleted" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserBasicFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "User" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProducerFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Producer" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "companyName" } },
          { kind: "Field", name: { kind: "Name", value: "address" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "website" } },
          { kind: "Field", name: { kind: "Name", value: "deleted" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "createdBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UserBasicFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "usedInRecipes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FileVariantFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "FileVariantInfo" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "kind" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "contentType" } },
          { kind: "Field", name: { kind: "Name", value: "sizeBytes" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CollectionFileFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CollectionFile" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "originalFilename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "variants" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "FileVariantFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "GenericIngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GenericIngredient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
          { kind: "Field", name: { kind: "Name", value: "sourceId" } },
          { kind: "Field", name: { kind: "Name", value: "nameEn" } },
          { kind: "Field", name: { kind: "Name", value: "nameBg" } },
          { kind: "Field", name: { kind: "Name", value: "nameFr" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "density" } },
          { kind: "Field", name: { kind: "Name", value: "allergens" } },
          { kind: "Field", name: { kind: "Name", value: "baseNameEn" } },
          { kind: "Field", name: { kind: "Name", value: "baseNameBg" } },
          { kind: "Field", name: { kind: "Name", value: "baseNameFr" } },
          { kind: "Field", name: { kind: "Name", value: "propertiesEn" } },
          { kind: "Field", name: { kind: "Name", value: "propertiesBg" } },
          { kind: "Field", name: { kind: "Name", value: "propertiesFr" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "foodCategory" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "nameEn" } },
                { kind: "Field", name: { kind: "Name", value: "nameBg" } },
                { kind: "Field", name: { kind: "Name", value: "nameFr" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IngredientReferencePriceFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "IngredientReferencePrice" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "quantity" } },
          { kind: "Field", name: { kind: "Name", value: "unitId" } },
          { kind: "Field", name: { kind: "Name", value: "price" } },
          { kind: "Field", name: { kind: "Name", value: "includesVat" } },
          { kind: "Field", name: { kind: "Name", value: "vatRate" } },
          { kind: "Field", name: { kind: "Name", value: "netPerGram" } },
          { kind: "Field", name: { kind: "Name", value: "grossPerGram" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Ingredient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "versionId" } },
          { kind: "Field", name: { kind: "Name", value: "versionNumber" } },
          { kind: "Field", name: { kind: "Name", value: "versionStatus" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "nameForLabel" } },
          { kind: "Field", name: { kind: "Name", value: "brand" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "density" } },
          { kind: "Field", name: { kind: "Name", value: "allergens" } },
          { kind: "Field", name: { kind: "Name", value: "nutritionReferenceQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "nutritionReferenceUnitId" } },
          { kind: "Field", name: { kind: "Name", value: "nutritionReferenceGrams" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "referenceNutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "genericIngredientId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "genericIngredient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GenericIngredientFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "photoCollectionId" } },
          { kind: "Field", name: { kind: "Name", value: "hasDraft" } },
          { kind: "Field", name: { kind: "Name", value: "hasPublishedVersion" } },
          { kind: "Field", name: { kind: "Name", value: "deleted" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "referencePrice" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "IngredientReferencePriceFragment" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "createdBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UserBasicFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "photos" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "CollectionFileFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "labelIngredients" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "parentId" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "percentage" } },
                { kind: "Field", name: { kind: "Name", value: "sortOrder" } },
                { kind: "Field", name: { kind: "Name", value: "allergens" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "usedInRecipes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "isOutdated" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "recipe" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IngredientRecipeIngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "IngredientRecipeIngredient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "ingredient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "IngredientFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "quantity" } },
          { kind: "Field", name: { kind: "Name", value: "unitId" } },
          { kind: "Field", name: { kind: "Name", value: "quantityGrams" } },
          { kind: "Field", name: { kind: "Name", value: "quantityPercent" } },
          { kind: "Field", name: { kind: "Name", value: "showQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "sortOrder" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "isOutdated" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SubRecipeRecipeIngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "SubRecipeRecipeIngredient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "recipe" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RecipeFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "quantity" } },
          { kind: "Field", name: { kind: "Name", value: "unitId" } },
          { kind: "Field", name: { kind: "Name", value: "quantityGrams" } },
          { kind: "Field", name: { kind: "Name", value: "quantityPercent" } },
          { kind: "Field", name: { kind: "Name", value: "showQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "sortOrder" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "isOutdated" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RecipeIngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "RecipeIngredientItem" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "FragmentSpread", name: { kind: "Name", value: "IngredientRecipeIngredientFragment" } },
          { kind: "FragmentSpread", name: { kind: "Name", value: "SubRecipeRecipeIngredientFragment" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RecipeReferenceCostFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "RecipeReferenceCost" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "totalNet" } },
          { kind: "Field", name: { kind: "Name", value: "totalGross" } },
          { kind: "Field", name: { kind: "Name", value: "perGramNet" } },
          { kind: "Field", name: { kind: "Name", value: "perGramGross" } },
          { kind: "Field", name: { kind: "Name", value: "per100gNet" } },
          { kind: "Field", name: { kind: "Name", value: "per100gGross" } },
          { kind: "Field", name: { kind: "Name", value: "perKgNet" } },
          { kind: "Field", name: { kind: "Name", value: "perKgGross" } },
          { kind: "Field", name: { kind: "Name", value: "perServingNet" } },
          { kind: "Field", name: { kind: "Name", value: "perServingGross" } },
          { kind: "Field", name: { kind: "Name", value: "perPackageNet" } },
          { kind: "Field", name: { kind: "Name", value: "perPackageGross" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "rows" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "recipeIngredientId" } },
                { kind: "Field", name: { kind: "Name", value: "net" } },
                { kind: "Field", name: { kind: "Name", value: "gross" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RecipeDetailFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recipe" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "FragmentSpread", name: { kind: "Name", value: "RecipeFragment" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "createdBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UserBasicFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "producer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ProducerFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "photos" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "CollectionFileFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "ingredients" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RecipeIngredientFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "referenceCost" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RecipeReferenceCostFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "usedAsSubRecipeIn" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "isOutdated" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "recipe" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateRecipeDraftMutation, CreateRecipeDraftMutationVariables>;
export const DiscardDraftDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DiscardDraft" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Long" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "discardDraft" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DiscardDraftMutation, DiscardDraftMutationVariables>;
export const SearchGenericIngredientsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "SearchGenericIngredients" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "query" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "offset" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "limit" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "language" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "searchGenericIngredients" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "query" },
                value: { kind: "Variable", name: { kind: "Name", value: "query" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "offset" },
                value: { kind: "Variable", name: { kind: "Name", value: "offset" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: { kind: "Variable", name: { kind: "Name", value: "limit" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "language" },
                value: { kind: "Variable", name: { kind: "Name", value: "language" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ingredients" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "FragmentSpread", name: { kind: "Name", value: "GenericIngredientFragment" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "total" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "NutritionProfileFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "NutritionProfile" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "energyKj" } },
          { kind: "Field", name: { kind: "Name", value: "energyKcal" } },
          { kind: "Field", name: { kind: "Name", value: "fat" } },
          { kind: "Field", name: { kind: "Name", value: "saturatedFat" } },
          { kind: "Field", name: { kind: "Name", value: "carbohydrate" } },
          { kind: "Field", name: { kind: "Name", value: "sugars" } },
          { kind: "Field", name: { kind: "Name", value: "fibre" } },
          { kind: "Field", name: { kind: "Name", value: "protein" } },
          { kind: "Field", name: { kind: "Name", value: "salt" } },
          { kind: "Field", name: { kind: "Name", value: "alcohol" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "GenericIngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GenericIngredient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
          { kind: "Field", name: { kind: "Name", value: "sourceId" } },
          { kind: "Field", name: { kind: "Name", value: "nameEn" } },
          { kind: "Field", name: { kind: "Name", value: "nameBg" } },
          { kind: "Field", name: { kind: "Name", value: "nameFr" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "density" } },
          { kind: "Field", name: { kind: "Name", value: "allergens" } },
          { kind: "Field", name: { kind: "Name", value: "baseNameEn" } },
          { kind: "Field", name: { kind: "Name", value: "baseNameBg" } },
          { kind: "Field", name: { kind: "Name", value: "baseNameFr" } },
          { kind: "Field", name: { kind: "Name", value: "propertiesEn" } },
          { kind: "Field", name: { kind: "Name", value: "propertiesBg" } },
          { kind: "Field", name: { kind: "Name", value: "propertiesFr" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "foodCategory" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "nameEn" } },
                { kind: "Field", name: { kind: "Name", value: "nameBg" } },
                { kind: "Field", name: { kind: "Name", value: "nameFr" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SearchGenericIngredientsQuery, SearchGenericIngredientsQueryVariables>;
export const GetMeasurementUnitsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetMeasurementUnits" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "measurementUnits" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "code" } },
                { kind: "Field", name: { kind: "Name", value: "nameEn" } },
                { kind: "Field", name: { kind: "Name", value: "nameBg" } },
                { kind: "Field", name: { kind: "Name", value: "unitType" } },
                { kind: "Field", name: { kind: "Name", value: "factor" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetMeasurementUnitsQuery, GetMeasurementUnitsQueryVariables>;
export const AddRecipeIngredientDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AddRecipeIngredient" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "recipeVersionId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Long" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "AddRecipeIngredientInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "addRecipeIngredient" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "recipeVersionId" },
                value: { kind: "Variable", name: { kind: "Name", value: "recipeVersionId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "refreshedRecipe" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RecipeDetailFragment" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "NutritionProfileFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "NutritionProfile" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "energyKj" } },
          { kind: "Field", name: { kind: "Name", value: "energyKcal" } },
          { kind: "Field", name: { kind: "Name", value: "fat" } },
          { kind: "Field", name: { kind: "Name", value: "saturatedFat" } },
          { kind: "Field", name: { kind: "Name", value: "carbohydrate" } },
          { kind: "Field", name: { kind: "Name", value: "sugars" } },
          { kind: "Field", name: { kind: "Name", value: "fibre" } },
          { kind: "Field", name: { kind: "Name", value: "protein" } },
          { kind: "Field", name: { kind: "Name", value: "salt" } },
          { kind: "Field", name: { kind: "Name", value: "alcohol" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RecipeFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recipe" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "versionId" } },
          { kind: "Field", name: { kind: "Name", value: "versionNumber" } },
          { kind: "Field", name: { kind: "Name", value: "versionStatus" } },
          { kind: "Field", name: { kind: "Name", value: "versionNotes" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "nameForLabel" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionPerServing" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionPerPackage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "weightAfterCooking" } },
          { kind: "Field", name: { kind: "Name", value: "weightAfterCookingQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "weightAfterCookingUnitId" } },
          { kind: "Field", name: { kind: "Name", value: "servingSize" } },
          { kind: "Field", name: { kind: "Name", value: "servingSizeQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "servingSizeUnitId" } },
          { kind: "Field", name: { kind: "Name", value: "servingsPerPackage" } },
          { kind: "Field", name: { kind: "Name", value: "netWeight" } },
          { kind: "Field", name: { kind: "Name", value: "netWeightQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "netWeightUnitId" } },
          { kind: "Field", name: { kind: "Name", value: "storageRequirements" } },
          { kind: "Field", name: { kind: "Name", value: "labelExportUrl" } },
          { kind: "Field", name: { kind: "Name", value: "producerId" } },
          { kind: "Field", name: { kind: "Name", value: "allergens" } },
          { kind: "Field", name: { kind: "Name", value: "photoCollectionId" } },
          { kind: "Field", name: { kind: "Name", value: "hasDraft" } },
          { kind: "Field", name: { kind: "Name", value: "hasPublishedVersion" } },
          { kind: "Field", name: { kind: "Name", value: "deleted" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserBasicFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "User" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProducerFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Producer" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "companyName" } },
          { kind: "Field", name: { kind: "Name", value: "address" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "website" } },
          { kind: "Field", name: { kind: "Name", value: "deleted" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "createdBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UserBasicFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "usedInRecipes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FileVariantFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "FileVariantInfo" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "kind" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "contentType" } },
          { kind: "Field", name: { kind: "Name", value: "sizeBytes" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CollectionFileFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CollectionFile" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "originalFilename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "variants" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "FileVariantFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "GenericIngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GenericIngredient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
          { kind: "Field", name: { kind: "Name", value: "sourceId" } },
          { kind: "Field", name: { kind: "Name", value: "nameEn" } },
          { kind: "Field", name: { kind: "Name", value: "nameBg" } },
          { kind: "Field", name: { kind: "Name", value: "nameFr" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "density" } },
          { kind: "Field", name: { kind: "Name", value: "allergens" } },
          { kind: "Field", name: { kind: "Name", value: "baseNameEn" } },
          { kind: "Field", name: { kind: "Name", value: "baseNameBg" } },
          { kind: "Field", name: { kind: "Name", value: "baseNameFr" } },
          { kind: "Field", name: { kind: "Name", value: "propertiesEn" } },
          { kind: "Field", name: { kind: "Name", value: "propertiesBg" } },
          { kind: "Field", name: { kind: "Name", value: "propertiesFr" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "foodCategory" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "nameEn" } },
                { kind: "Field", name: { kind: "Name", value: "nameBg" } },
                { kind: "Field", name: { kind: "Name", value: "nameFr" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IngredientReferencePriceFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "IngredientReferencePrice" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "quantity" } },
          { kind: "Field", name: { kind: "Name", value: "unitId" } },
          { kind: "Field", name: { kind: "Name", value: "price" } },
          { kind: "Field", name: { kind: "Name", value: "includesVat" } },
          { kind: "Field", name: { kind: "Name", value: "vatRate" } },
          { kind: "Field", name: { kind: "Name", value: "netPerGram" } },
          { kind: "Field", name: { kind: "Name", value: "grossPerGram" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Ingredient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "versionId" } },
          { kind: "Field", name: { kind: "Name", value: "versionNumber" } },
          { kind: "Field", name: { kind: "Name", value: "versionStatus" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "nameForLabel" } },
          { kind: "Field", name: { kind: "Name", value: "brand" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "density" } },
          { kind: "Field", name: { kind: "Name", value: "allergens" } },
          { kind: "Field", name: { kind: "Name", value: "nutritionReferenceQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "nutritionReferenceUnitId" } },
          { kind: "Field", name: { kind: "Name", value: "nutritionReferenceGrams" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "referenceNutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "genericIngredientId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "genericIngredient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GenericIngredientFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "photoCollectionId" } },
          { kind: "Field", name: { kind: "Name", value: "hasDraft" } },
          { kind: "Field", name: { kind: "Name", value: "hasPublishedVersion" } },
          { kind: "Field", name: { kind: "Name", value: "deleted" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "referencePrice" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "IngredientReferencePriceFragment" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "createdBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UserBasicFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "photos" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "CollectionFileFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "labelIngredients" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "parentId" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "percentage" } },
                { kind: "Field", name: { kind: "Name", value: "sortOrder" } },
                { kind: "Field", name: { kind: "Name", value: "allergens" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "usedInRecipes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "isOutdated" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "recipe" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IngredientRecipeIngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "IngredientRecipeIngredient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "ingredient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "IngredientFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "quantity" } },
          { kind: "Field", name: { kind: "Name", value: "unitId" } },
          { kind: "Field", name: { kind: "Name", value: "quantityGrams" } },
          { kind: "Field", name: { kind: "Name", value: "quantityPercent" } },
          { kind: "Field", name: { kind: "Name", value: "showQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "sortOrder" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "isOutdated" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SubRecipeRecipeIngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "SubRecipeRecipeIngredient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "recipe" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RecipeFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "quantity" } },
          { kind: "Field", name: { kind: "Name", value: "unitId" } },
          { kind: "Field", name: { kind: "Name", value: "quantityGrams" } },
          { kind: "Field", name: { kind: "Name", value: "quantityPercent" } },
          { kind: "Field", name: { kind: "Name", value: "showQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "sortOrder" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "isOutdated" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RecipeIngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "RecipeIngredientItem" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "FragmentSpread", name: { kind: "Name", value: "IngredientRecipeIngredientFragment" } },
          { kind: "FragmentSpread", name: { kind: "Name", value: "SubRecipeRecipeIngredientFragment" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RecipeReferenceCostFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "RecipeReferenceCost" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "totalNet" } },
          { kind: "Field", name: { kind: "Name", value: "totalGross" } },
          { kind: "Field", name: { kind: "Name", value: "perGramNet" } },
          { kind: "Field", name: { kind: "Name", value: "perGramGross" } },
          { kind: "Field", name: { kind: "Name", value: "per100gNet" } },
          { kind: "Field", name: { kind: "Name", value: "per100gGross" } },
          { kind: "Field", name: { kind: "Name", value: "perKgNet" } },
          { kind: "Field", name: { kind: "Name", value: "perKgGross" } },
          { kind: "Field", name: { kind: "Name", value: "perServingNet" } },
          { kind: "Field", name: { kind: "Name", value: "perServingGross" } },
          { kind: "Field", name: { kind: "Name", value: "perPackageNet" } },
          { kind: "Field", name: { kind: "Name", value: "perPackageGross" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "rows" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "recipeIngredientId" } },
                { kind: "Field", name: { kind: "Name", value: "net" } },
                { kind: "Field", name: { kind: "Name", value: "gross" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RecipeDetailFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recipe" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "FragmentSpread", name: { kind: "Name", value: "RecipeFragment" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "createdBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UserBasicFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "producer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ProducerFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "photos" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "CollectionFileFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "ingredients" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RecipeIngredientFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "referenceCost" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RecipeReferenceCostFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "usedAsSubRecipeIn" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "isOutdated" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "recipe" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AddRecipeIngredientMutation, AddRecipeIngredientMutationVariables>;
export const UpdateRecipeIngredientDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateRecipeIngredient" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "recipeVersionId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Long" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "ingredientId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Long" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UpdateRecipeIngredientInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateRecipeIngredient" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "recipeVersionId" },
                value: { kind: "Variable", name: { kind: "Name", value: "recipeVersionId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "ingredientId" },
                value: { kind: "Variable", name: { kind: "Name", value: "ingredientId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "refreshedRecipe" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RecipeDetailFragment" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "NutritionProfileFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "NutritionProfile" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "energyKj" } },
          { kind: "Field", name: { kind: "Name", value: "energyKcal" } },
          { kind: "Field", name: { kind: "Name", value: "fat" } },
          { kind: "Field", name: { kind: "Name", value: "saturatedFat" } },
          { kind: "Field", name: { kind: "Name", value: "carbohydrate" } },
          { kind: "Field", name: { kind: "Name", value: "sugars" } },
          { kind: "Field", name: { kind: "Name", value: "fibre" } },
          { kind: "Field", name: { kind: "Name", value: "protein" } },
          { kind: "Field", name: { kind: "Name", value: "salt" } },
          { kind: "Field", name: { kind: "Name", value: "alcohol" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RecipeFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recipe" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "versionId" } },
          { kind: "Field", name: { kind: "Name", value: "versionNumber" } },
          { kind: "Field", name: { kind: "Name", value: "versionStatus" } },
          { kind: "Field", name: { kind: "Name", value: "versionNotes" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "nameForLabel" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionPerServing" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionPerPackage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "weightAfterCooking" } },
          { kind: "Field", name: { kind: "Name", value: "weightAfterCookingQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "weightAfterCookingUnitId" } },
          { kind: "Field", name: { kind: "Name", value: "servingSize" } },
          { kind: "Field", name: { kind: "Name", value: "servingSizeQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "servingSizeUnitId" } },
          { kind: "Field", name: { kind: "Name", value: "servingsPerPackage" } },
          { kind: "Field", name: { kind: "Name", value: "netWeight" } },
          { kind: "Field", name: { kind: "Name", value: "netWeightQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "netWeightUnitId" } },
          { kind: "Field", name: { kind: "Name", value: "storageRequirements" } },
          { kind: "Field", name: { kind: "Name", value: "labelExportUrl" } },
          { kind: "Field", name: { kind: "Name", value: "producerId" } },
          { kind: "Field", name: { kind: "Name", value: "allergens" } },
          { kind: "Field", name: { kind: "Name", value: "photoCollectionId" } },
          { kind: "Field", name: { kind: "Name", value: "hasDraft" } },
          { kind: "Field", name: { kind: "Name", value: "hasPublishedVersion" } },
          { kind: "Field", name: { kind: "Name", value: "deleted" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserBasicFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "User" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProducerFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Producer" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "companyName" } },
          { kind: "Field", name: { kind: "Name", value: "address" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "website" } },
          { kind: "Field", name: { kind: "Name", value: "deleted" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "createdBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UserBasicFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "usedInRecipes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FileVariantFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "FileVariantInfo" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "kind" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "contentType" } },
          { kind: "Field", name: { kind: "Name", value: "sizeBytes" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CollectionFileFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CollectionFile" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "originalFilename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "variants" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "FileVariantFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "GenericIngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GenericIngredient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
          { kind: "Field", name: { kind: "Name", value: "sourceId" } },
          { kind: "Field", name: { kind: "Name", value: "nameEn" } },
          { kind: "Field", name: { kind: "Name", value: "nameBg" } },
          { kind: "Field", name: { kind: "Name", value: "nameFr" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "density" } },
          { kind: "Field", name: { kind: "Name", value: "allergens" } },
          { kind: "Field", name: { kind: "Name", value: "baseNameEn" } },
          { kind: "Field", name: { kind: "Name", value: "baseNameBg" } },
          { kind: "Field", name: { kind: "Name", value: "baseNameFr" } },
          { kind: "Field", name: { kind: "Name", value: "propertiesEn" } },
          { kind: "Field", name: { kind: "Name", value: "propertiesBg" } },
          { kind: "Field", name: { kind: "Name", value: "propertiesFr" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "foodCategory" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "nameEn" } },
                { kind: "Field", name: { kind: "Name", value: "nameBg" } },
                { kind: "Field", name: { kind: "Name", value: "nameFr" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IngredientReferencePriceFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "IngredientReferencePrice" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "quantity" } },
          { kind: "Field", name: { kind: "Name", value: "unitId" } },
          { kind: "Field", name: { kind: "Name", value: "price" } },
          { kind: "Field", name: { kind: "Name", value: "includesVat" } },
          { kind: "Field", name: { kind: "Name", value: "vatRate" } },
          { kind: "Field", name: { kind: "Name", value: "netPerGram" } },
          { kind: "Field", name: { kind: "Name", value: "grossPerGram" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Ingredient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "versionId" } },
          { kind: "Field", name: { kind: "Name", value: "versionNumber" } },
          { kind: "Field", name: { kind: "Name", value: "versionStatus" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "nameForLabel" } },
          { kind: "Field", name: { kind: "Name", value: "brand" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "density" } },
          { kind: "Field", name: { kind: "Name", value: "allergens" } },
          { kind: "Field", name: { kind: "Name", value: "nutritionReferenceQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "nutritionReferenceUnitId" } },
          { kind: "Field", name: { kind: "Name", value: "nutritionReferenceGrams" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "referenceNutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "genericIngredientId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "genericIngredient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GenericIngredientFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "photoCollectionId" } },
          { kind: "Field", name: { kind: "Name", value: "hasDraft" } },
          { kind: "Field", name: { kind: "Name", value: "hasPublishedVersion" } },
          { kind: "Field", name: { kind: "Name", value: "deleted" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "referencePrice" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "IngredientReferencePriceFragment" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "createdBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UserBasicFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "photos" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "CollectionFileFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "labelIngredients" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "parentId" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "percentage" } },
                { kind: "Field", name: { kind: "Name", value: "sortOrder" } },
                { kind: "Field", name: { kind: "Name", value: "allergens" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "usedInRecipes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "isOutdated" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "recipe" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IngredientRecipeIngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "IngredientRecipeIngredient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "ingredient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "IngredientFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "quantity" } },
          { kind: "Field", name: { kind: "Name", value: "unitId" } },
          { kind: "Field", name: { kind: "Name", value: "quantityGrams" } },
          { kind: "Field", name: { kind: "Name", value: "quantityPercent" } },
          { kind: "Field", name: { kind: "Name", value: "showQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "sortOrder" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "isOutdated" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SubRecipeRecipeIngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "SubRecipeRecipeIngredient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "recipe" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RecipeFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "quantity" } },
          { kind: "Field", name: { kind: "Name", value: "unitId" } },
          { kind: "Field", name: { kind: "Name", value: "quantityGrams" } },
          { kind: "Field", name: { kind: "Name", value: "quantityPercent" } },
          { kind: "Field", name: { kind: "Name", value: "showQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "sortOrder" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "isOutdated" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RecipeIngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "RecipeIngredientItem" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "FragmentSpread", name: { kind: "Name", value: "IngredientRecipeIngredientFragment" } },
          { kind: "FragmentSpread", name: { kind: "Name", value: "SubRecipeRecipeIngredientFragment" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RecipeReferenceCostFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "RecipeReferenceCost" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "totalNet" } },
          { kind: "Field", name: { kind: "Name", value: "totalGross" } },
          { kind: "Field", name: { kind: "Name", value: "perGramNet" } },
          { kind: "Field", name: { kind: "Name", value: "perGramGross" } },
          { kind: "Field", name: { kind: "Name", value: "per100gNet" } },
          { kind: "Field", name: { kind: "Name", value: "per100gGross" } },
          { kind: "Field", name: { kind: "Name", value: "perKgNet" } },
          { kind: "Field", name: { kind: "Name", value: "perKgGross" } },
          { kind: "Field", name: { kind: "Name", value: "perServingNet" } },
          { kind: "Field", name: { kind: "Name", value: "perServingGross" } },
          { kind: "Field", name: { kind: "Name", value: "perPackageNet" } },
          { kind: "Field", name: { kind: "Name", value: "perPackageGross" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "rows" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "recipeIngredientId" } },
                { kind: "Field", name: { kind: "Name", value: "net" } },
                { kind: "Field", name: { kind: "Name", value: "gross" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RecipeDetailFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recipe" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "FragmentSpread", name: { kind: "Name", value: "RecipeFragment" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "createdBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UserBasicFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "producer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ProducerFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "photos" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "CollectionFileFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "ingredients" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RecipeIngredientFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "referenceCost" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RecipeReferenceCostFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "usedAsSubRecipeIn" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "isOutdated" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "recipe" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateRecipeIngredientMutation, UpdateRecipeIngredientMutationVariables>;
export const RemoveRecipeIngredientDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "RemoveRecipeIngredient" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "recipeVersionId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Long" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "ingredientId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Long" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "removeRecipeIngredient" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "recipeVersionId" },
                value: { kind: "Variable", name: { kind: "Name", value: "recipeVersionId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "ingredientId" },
                value: { kind: "Variable", name: { kind: "Name", value: "ingredientId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "refreshedRecipe" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RecipeDetailFragment" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "NutritionProfileFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "NutritionProfile" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "energyKj" } },
          { kind: "Field", name: { kind: "Name", value: "energyKcal" } },
          { kind: "Field", name: { kind: "Name", value: "fat" } },
          { kind: "Field", name: { kind: "Name", value: "saturatedFat" } },
          { kind: "Field", name: { kind: "Name", value: "carbohydrate" } },
          { kind: "Field", name: { kind: "Name", value: "sugars" } },
          { kind: "Field", name: { kind: "Name", value: "fibre" } },
          { kind: "Field", name: { kind: "Name", value: "protein" } },
          { kind: "Field", name: { kind: "Name", value: "salt" } },
          { kind: "Field", name: { kind: "Name", value: "alcohol" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RecipeFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recipe" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "versionId" } },
          { kind: "Field", name: { kind: "Name", value: "versionNumber" } },
          { kind: "Field", name: { kind: "Name", value: "versionStatus" } },
          { kind: "Field", name: { kind: "Name", value: "versionNotes" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "nameForLabel" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionPerServing" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionPerPackage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "weightAfterCooking" } },
          { kind: "Field", name: { kind: "Name", value: "weightAfterCookingQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "weightAfterCookingUnitId" } },
          { kind: "Field", name: { kind: "Name", value: "servingSize" } },
          { kind: "Field", name: { kind: "Name", value: "servingSizeQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "servingSizeUnitId" } },
          { kind: "Field", name: { kind: "Name", value: "servingsPerPackage" } },
          { kind: "Field", name: { kind: "Name", value: "netWeight" } },
          { kind: "Field", name: { kind: "Name", value: "netWeightQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "netWeightUnitId" } },
          { kind: "Field", name: { kind: "Name", value: "storageRequirements" } },
          { kind: "Field", name: { kind: "Name", value: "labelExportUrl" } },
          { kind: "Field", name: { kind: "Name", value: "producerId" } },
          { kind: "Field", name: { kind: "Name", value: "allergens" } },
          { kind: "Field", name: { kind: "Name", value: "photoCollectionId" } },
          { kind: "Field", name: { kind: "Name", value: "hasDraft" } },
          { kind: "Field", name: { kind: "Name", value: "hasPublishedVersion" } },
          { kind: "Field", name: { kind: "Name", value: "deleted" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserBasicFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "User" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProducerFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Producer" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "companyName" } },
          { kind: "Field", name: { kind: "Name", value: "address" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "website" } },
          { kind: "Field", name: { kind: "Name", value: "deleted" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "createdBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UserBasicFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "usedInRecipes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FileVariantFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "FileVariantInfo" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "kind" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "contentType" } },
          { kind: "Field", name: { kind: "Name", value: "sizeBytes" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CollectionFileFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CollectionFile" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "originalFilename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "variants" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "FileVariantFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "GenericIngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GenericIngredient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
          { kind: "Field", name: { kind: "Name", value: "sourceId" } },
          { kind: "Field", name: { kind: "Name", value: "nameEn" } },
          { kind: "Field", name: { kind: "Name", value: "nameBg" } },
          { kind: "Field", name: { kind: "Name", value: "nameFr" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "density" } },
          { kind: "Field", name: { kind: "Name", value: "allergens" } },
          { kind: "Field", name: { kind: "Name", value: "baseNameEn" } },
          { kind: "Field", name: { kind: "Name", value: "baseNameBg" } },
          { kind: "Field", name: { kind: "Name", value: "baseNameFr" } },
          { kind: "Field", name: { kind: "Name", value: "propertiesEn" } },
          { kind: "Field", name: { kind: "Name", value: "propertiesBg" } },
          { kind: "Field", name: { kind: "Name", value: "propertiesFr" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "foodCategory" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "nameEn" } },
                { kind: "Field", name: { kind: "Name", value: "nameBg" } },
                { kind: "Field", name: { kind: "Name", value: "nameFr" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IngredientReferencePriceFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "IngredientReferencePrice" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "quantity" } },
          { kind: "Field", name: { kind: "Name", value: "unitId" } },
          { kind: "Field", name: { kind: "Name", value: "price" } },
          { kind: "Field", name: { kind: "Name", value: "includesVat" } },
          { kind: "Field", name: { kind: "Name", value: "vatRate" } },
          { kind: "Field", name: { kind: "Name", value: "netPerGram" } },
          { kind: "Field", name: { kind: "Name", value: "grossPerGram" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Ingredient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "versionId" } },
          { kind: "Field", name: { kind: "Name", value: "versionNumber" } },
          { kind: "Field", name: { kind: "Name", value: "versionStatus" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "nameForLabel" } },
          { kind: "Field", name: { kind: "Name", value: "brand" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "density" } },
          { kind: "Field", name: { kind: "Name", value: "allergens" } },
          { kind: "Field", name: { kind: "Name", value: "nutritionReferenceQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "nutritionReferenceUnitId" } },
          { kind: "Field", name: { kind: "Name", value: "nutritionReferenceGrams" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "referenceNutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "genericIngredientId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "genericIngredient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GenericIngredientFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "photoCollectionId" } },
          { kind: "Field", name: { kind: "Name", value: "hasDraft" } },
          { kind: "Field", name: { kind: "Name", value: "hasPublishedVersion" } },
          { kind: "Field", name: { kind: "Name", value: "deleted" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "referencePrice" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "IngredientReferencePriceFragment" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "createdBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UserBasicFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "photos" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "CollectionFileFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "labelIngredients" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "parentId" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "percentage" } },
                { kind: "Field", name: { kind: "Name", value: "sortOrder" } },
                { kind: "Field", name: { kind: "Name", value: "allergens" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "usedInRecipes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "isOutdated" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "recipe" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IngredientRecipeIngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "IngredientRecipeIngredient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "ingredient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "IngredientFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "quantity" } },
          { kind: "Field", name: { kind: "Name", value: "unitId" } },
          { kind: "Field", name: { kind: "Name", value: "quantityGrams" } },
          { kind: "Field", name: { kind: "Name", value: "quantityPercent" } },
          { kind: "Field", name: { kind: "Name", value: "showQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "sortOrder" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "isOutdated" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SubRecipeRecipeIngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "SubRecipeRecipeIngredient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "recipe" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RecipeFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "quantity" } },
          { kind: "Field", name: { kind: "Name", value: "unitId" } },
          { kind: "Field", name: { kind: "Name", value: "quantityGrams" } },
          { kind: "Field", name: { kind: "Name", value: "quantityPercent" } },
          { kind: "Field", name: { kind: "Name", value: "showQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "sortOrder" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "isOutdated" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RecipeIngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "RecipeIngredientItem" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "FragmentSpread", name: { kind: "Name", value: "IngredientRecipeIngredientFragment" } },
          { kind: "FragmentSpread", name: { kind: "Name", value: "SubRecipeRecipeIngredientFragment" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RecipeReferenceCostFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "RecipeReferenceCost" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "totalNet" } },
          { kind: "Field", name: { kind: "Name", value: "totalGross" } },
          { kind: "Field", name: { kind: "Name", value: "perGramNet" } },
          { kind: "Field", name: { kind: "Name", value: "perGramGross" } },
          { kind: "Field", name: { kind: "Name", value: "per100gNet" } },
          { kind: "Field", name: { kind: "Name", value: "per100gGross" } },
          { kind: "Field", name: { kind: "Name", value: "perKgNet" } },
          { kind: "Field", name: { kind: "Name", value: "perKgGross" } },
          { kind: "Field", name: { kind: "Name", value: "perServingNet" } },
          { kind: "Field", name: { kind: "Name", value: "perServingGross" } },
          { kind: "Field", name: { kind: "Name", value: "perPackageNet" } },
          { kind: "Field", name: { kind: "Name", value: "perPackageGross" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "rows" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "recipeIngredientId" } },
                { kind: "Field", name: { kind: "Name", value: "net" } },
                { kind: "Field", name: { kind: "Name", value: "gross" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RecipeDetailFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recipe" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "FragmentSpread", name: { kind: "Name", value: "RecipeFragment" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "createdBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UserBasicFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "producer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ProducerFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "photos" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "CollectionFileFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "ingredients" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RecipeIngredientFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "referenceCost" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RecipeReferenceCostFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "usedAsSubRecipeIn" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "isOutdated" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "recipe" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RemoveRecipeIngredientMutation, RemoveRecipeIngredientMutationVariables>;
export const ReplaceRecipeIngredientDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ReplaceRecipeIngredient" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "recipeVersionId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Long" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "ingredientId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Long" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ReplaceRecipeIngredientInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "replaceRecipeIngredient" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "recipeVersionId" },
                value: { kind: "Variable", name: { kind: "Name", value: "recipeVersionId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "ingredientId" },
                value: { kind: "Variable", name: { kind: "Name", value: "ingredientId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "refreshedRecipe" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RecipeDetailFragment" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "NutritionProfileFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "NutritionProfile" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "energyKj" } },
          { kind: "Field", name: { kind: "Name", value: "energyKcal" } },
          { kind: "Field", name: { kind: "Name", value: "fat" } },
          { kind: "Field", name: { kind: "Name", value: "saturatedFat" } },
          { kind: "Field", name: { kind: "Name", value: "carbohydrate" } },
          { kind: "Field", name: { kind: "Name", value: "sugars" } },
          { kind: "Field", name: { kind: "Name", value: "fibre" } },
          { kind: "Field", name: { kind: "Name", value: "protein" } },
          { kind: "Field", name: { kind: "Name", value: "salt" } },
          { kind: "Field", name: { kind: "Name", value: "alcohol" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RecipeFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recipe" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "versionId" } },
          { kind: "Field", name: { kind: "Name", value: "versionNumber" } },
          { kind: "Field", name: { kind: "Name", value: "versionStatus" } },
          { kind: "Field", name: { kind: "Name", value: "versionNotes" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "nameForLabel" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionPerServing" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionPerPackage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "weightAfterCooking" } },
          { kind: "Field", name: { kind: "Name", value: "weightAfterCookingQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "weightAfterCookingUnitId" } },
          { kind: "Field", name: { kind: "Name", value: "servingSize" } },
          { kind: "Field", name: { kind: "Name", value: "servingSizeQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "servingSizeUnitId" } },
          { kind: "Field", name: { kind: "Name", value: "servingsPerPackage" } },
          { kind: "Field", name: { kind: "Name", value: "netWeight" } },
          { kind: "Field", name: { kind: "Name", value: "netWeightQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "netWeightUnitId" } },
          { kind: "Field", name: { kind: "Name", value: "storageRequirements" } },
          { kind: "Field", name: { kind: "Name", value: "labelExportUrl" } },
          { kind: "Field", name: { kind: "Name", value: "producerId" } },
          { kind: "Field", name: { kind: "Name", value: "allergens" } },
          { kind: "Field", name: { kind: "Name", value: "photoCollectionId" } },
          { kind: "Field", name: { kind: "Name", value: "hasDraft" } },
          { kind: "Field", name: { kind: "Name", value: "hasPublishedVersion" } },
          { kind: "Field", name: { kind: "Name", value: "deleted" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserBasicFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "User" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProducerFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Producer" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "companyName" } },
          { kind: "Field", name: { kind: "Name", value: "address" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "website" } },
          { kind: "Field", name: { kind: "Name", value: "deleted" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "createdBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UserBasicFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "usedInRecipes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FileVariantFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "FileVariantInfo" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "kind" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "contentType" } },
          { kind: "Field", name: { kind: "Name", value: "sizeBytes" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CollectionFileFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CollectionFile" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "originalFilename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "variants" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "FileVariantFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "GenericIngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GenericIngredient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
          { kind: "Field", name: { kind: "Name", value: "sourceId" } },
          { kind: "Field", name: { kind: "Name", value: "nameEn" } },
          { kind: "Field", name: { kind: "Name", value: "nameBg" } },
          { kind: "Field", name: { kind: "Name", value: "nameFr" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "density" } },
          { kind: "Field", name: { kind: "Name", value: "allergens" } },
          { kind: "Field", name: { kind: "Name", value: "baseNameEn" } },
          { kind: "Field", name: { kind: "Name", value: "baseNameBg" } },
          { kind: "Field", name: { kind: "Name", value: "baseNameFr" } },
          { kind: "Field", name: { kind: "Name", value: "propertiesEn" } },
          { kind: "Field", name: { kind: "Name", value: "propertiesBg" } },
          { kind: "Field", name: { kind: "Name", value: "propertiesFr" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "foodCategory" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "nameEn" } },
                { kind: "Field", name: { kind: "Name", value: "nameBg" } },
                { kind: "Field", name: { kind: "Name", value: "nameFr" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IngredientReferencePriceFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "IngredientReferencePrice" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "quantity" } },
          { kind: "Field", name: { kind: "Name", value: "unitId" } },
          { kind: "Field", name: { kind: "Name", value: "price" } },
          { kind: "Field", name: { kind: "Name", value: "includesVat" } },
          { kind: "Field", name: { kind: "Name", value: "vatRate" } },
          { kind: "Field", name: { kind: "Name", value: "netPerGram" } },
          { kind: "Field", name: { kind: "Name", value: "grossPerGram" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Ingredient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "versionId" } },
          { kind: "Field", name: { kind: "Name", value: "versionNumber" } },
          { kind: "Field", name: { kind: "Name", value: "versionStatus" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "nameForLabel" } },
          { kind: "Field", name: { kind: "Name", value: "brand" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "density" } },
          { kind: "Field", name: { kind: "Name", value: "allergens" } },
          { kind: "Field", name: { kind: "Name", value: "nutritionReferenceQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "nutritionReferenceUnitId" } },
          { kind: "Field", name: { kind: "Name", value: "nutritionReferenceGrams" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "referenceNutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "genericIngredientId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "genericIngredient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GenericIngredientFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "photoCollectionId" } },
          { kind: "Field", name: { kind: "Name", value: "hasDraft" } },
          { kind: "Field", name: { kind: "Name", value: "hasPublishedVersion" } },
          { kind: "Field", name: { kind: "Name", value: "deleted" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "referencePrice" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "IngredientReferencePriceFragment" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "createdBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UserBasicFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "photos" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "CollectionFileFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "labelIngredients" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "parentId" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "percentage" } },
                { kind: "Field", name: { kind: "Name", value: "sortOrder" } },
                { kind: "Field", name: { kind: "Name", value: "allergens" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "usedInRecipes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "isOutdated" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "recipe" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IngredientRecipeIngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "IngredientRecipeIngredient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "ingredient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "IngredientFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "quantity" } },
          { kind: "Field", name: { kind: "Name", value: "unitId" } },
          { kind: "Field", name: { kind: "Name", value: "quantityGrams" } },
          { kind: "Field", name: { kind: "Name", value: "quantityPercent" } },
          { kind: "Field", name: { kind: "Name", value: "showQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "sortOrder" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "isOutdated" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SubRecipeRecipeIngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "SubRecipeRecipeIngredient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "recipe" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RecipeFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "quantity" } },
          { kind: "Field", name: { kind: "Name", value: "unitId" } },
          { kind: "Field", name: { kind: "Name", value: "quantityGrams" } },
          { kind: "Field", name: { kind: "Name", value: "quantityPercent" } },
          { kind: "Field", name: { kind: "Name", value: "showQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "sortOrder" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "isOutdated" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RecipeIngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "RecipeIngredientItem" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "FragmentSpread", name: { kind: "Name", value: "IngredientRecipeIngredientFragment" } },
          { kind: "FragmentSpread", name: { kind: "Name", value: "SubRecipeRecipeIngredientFragment" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RecipeReferenceCostFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "RecipeReferenceCost" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "totalNet" } },
          { kind: "Field", name: { kind: "Name", value: "totalGross" } },
          { kind: "Field", name: { kind: "Name", value: "perGramNet" } },
          { kind: "Field", name: { kind: "Name", value: "perGramGross" } },
          { kind: "Field", name: { kind: "Name", value: "per100gNet" } },
          { kind: "Field", name: { kind: "Name", value: "per100gGross" } },
          { kind: "Field", name: { kind: "Name", value: "perKgNet" } },
          { kind: "Field", name: { kind: "Name", value: "perKgGross" } },
          { kind: "Field", name: { kind: "Name", value: "perServingNet" } },
          { kind: "Field", name: { kind: "Name", value: "perServingGross" } },
          { kind: "Field", name: { kind: "Name", value: "perPackageNet" } },
          { kind: "Field", name: { kind: "Name", value: "perPackageGross" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "rows" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "recipeIngredientId" } },
                { kind: "Field", name: { kind: "Name", value: "net" } },
                { kind: "Field", name: { kind: "Name", value: "gross" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RecipeDetailFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recipe" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "FragmentSpread", name: { kind: "Name", value: "RecipeFragment" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "createdBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UserBasicFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "producer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ProducerFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "photos" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "CollectionFileFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "ingredients" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RecipeIngredientFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "referenceCost" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RecipeReferenceCostFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "usedAsSubRecipeIn" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "isOutdated" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "recipe" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ReplaceRecipeIngredientMutation, ReplaceRecipeIngredientMutationVariables>;
export const UpdateRecipeIngredientVersionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateRecipeIngredientVersion" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "recipeVersionId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Long" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "ingredientId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Long" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateRecipeIngredientVersion" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "recipeVersionId" },
                value: { kind: "Variable", name: { kind: "Name", value: "recipeVersionId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "ingredientId" },
                value: { kind: "Variable", name: { kind: "Name", value: "ingredientId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "refreshedRecipe" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RecipeDetailFragment" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "NutritionProfileFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "NutritionProfile" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "energyKj" } },
          { kind: "Field", name: { kind: "Name", value: "energyKcal" } },
          { kind: "Field", name: { kind: "Name", value: "fat" } },
          { kind: "Field", name: { kind: "Name", value: "saturatedFat" } },
          { kind: "Field", name: { kind: "Name", value: "carbohydrate" } },
          { kind: "Field", name: { kind: "Name", value: "sugars" } },
          { kind: "Field", name: { kind: "Name", value: "fibre" } },
          { kind: "Field", name: { kind: "Name", value: "protein" } },
          { kind: "Field", name: { kind: "Name", value: "salt" } },
          { kind: "Field", name: { kind: "Name", value: "alcohol" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RecipeFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recipe" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "versionId" } },
          { kind: "Field", name: { kind: "Name", value: "versionNumber" } },
          { kind: "Field", name: { kind: "Name", value: "versionStatus" } },
          { kind: "Field", name: { kind: "Name", value: "versionNotes" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "nameForLabel" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionPerServing" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionPerPackage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "weightAfterCooking" } },
          { kind: "Field", name: { kind: "Name", value: "weightAfterCookingQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "weightAfterCookingUnitId" } },
          { kind: "Field", name: { kind: "Name", value: "servingSize" } },
          { kind: "Field", name: { kind: "Name", value: "servingSizeQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "servingSizeUnitId" } },
          { kind: "Field", name: { kind: "Name", value: "servingsPerPackage" } },
          { kind: "Field", name: { kind: "Name", value: "netWeight" } },
          { kind: "Field", name: { kind: "Name", value: "netWeightQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "netWeightUnitId" } },
          { kind: "Field", name: { kind: "Name", value: "storageRequirements" } },
          { kind: "Field", name: { kind: "Name", value: "labelExportUrl" } },
          { kind: "Field", name: { kind: "Name", value: "producerId" } },
          { kind: "Field", name: { kind: "Name", value: "allergens" } },
          { kind: "Field", name: { kind: "Name", value: "photoCollectionId" } },
          { kind: "Field", name: { kind: "Name", value: "hasDraft" } },
          { kind: "Field", name: { kind: "Name", value: "hasPublishedVersion" } },
          { kind: "Field", name: { kind: "Name", value: "deleted" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserBasicFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "User" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProducerFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Producer" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "companyName" } },
          { kind: "Field", name: { kind: "Name", value: "address" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "website" } },
          { kind: "Field", name: { kind: "Name", value: "deleted" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "createdBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UserBasicFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "usedInRecipes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FileVariantFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "FileVariantInfo" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "kind" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "contentType" } },
          { kind: "Field", name: { kind: "Name", value: "sizeBytes" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CollectionFileFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CollectionFile" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "originalFilename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "variants" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "FileVariantFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "GenericIngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GenericIngredient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
          { kind: "Field", name: { kind: "Name", value: "sourceId" } },
          { kind: "Field", name: { kind: "Name", value: "nameEn" } },
          { kind: "Field", name: { kind: "Name", value: "nameBg" } },
          { kind: "Field", name: { kind: "Name", value: "nameFr" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "density" } },
          { kind: "Field", name: { kind: "Name", value: "allergens" } },
          { kind: "Field", name: { kind: "Name", value: "baseNameEn" } },
          { kind: "Field", name: { kind: "Name", value: "baseNameBg" } },
          { kind: "Field", name: { kind: "Name", value: "baseNameFr" } },
          { kind: "Field", name: { kind: "Name", value: "propertiesEn" } },
          { kind: "Field", name: { kind: "Name", value: "propertiesBg" } },
          { kind: "Field", name: { kind: "Name", value: "propertiesFr" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "foodCategory" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "nameEn" } },
                { kind: "Field", name: { kind: "Name", value: "nameBg" } },
                { kind: "Field", name: { kind: "Name", value: "nameFr" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IngredientReferencePriceFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "IngredientReferencePrice" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "quantity" } },
          { kind: "Field", name: { kind: "Name", value: "unitId" } },
          { kind: "Field", name: { kind: "Name", value: "price" } },
          { kind: "Field", name: { kind: "Name", value: "includesVat" } },
          { kind: "Field", name: { kind: "Name", value: "vatRate" } },
          { kind: "Field", name: { kind: "Name", value: "netPerGram" } },
          { kind: "Field", name: { kind: "Name", value: "grossPerGram" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Ingredient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "versionId" } },
          { kind: "Field", name: { kind: "Name", value: "versionNumber" } },
          { kind: "Field", name: { kind: "Name", value: "versionStatus" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "nameForLabel" } },
          { kind: "Field", name: { kind: "Name", value: "brand" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "density" } },
          { kind: "Field", name: { kind: "Name", value: "allergens" } },
          { kind: "Field", name: { kind: "Name", value: "nutritionReferenceQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "nutritionReferenceUnitId" } },
          { kind: "Field", name: { kind: "Name", value: "nutritionReferenceGrams" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "referenceNutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "genericIngredientId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "genericIngredient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GenericIngredientFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "photoCollectionId" } },
          { kind: "Field", name: { kind: "Name", value: "hasDraft" } },
          { kind: "Field", name: { kind: "Name", value: "hasPublishedVersion" } },
          { kind: "Field", name: { kind: "Name", value: "deleted" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "referencePrice" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "IngredientReferencePriceFragment" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "createdBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UserBasicFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "photos" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "CollectionFileFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "labelIngredients" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "parentId" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "percentage" } },
                { kind: "Field", name: { kind: "Name", value: "sortOrder" } },
                { kind: "Field", name: { kind: "Name", value: "allergens" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "usedInRecipes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "isOutdated" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "recipe" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IngredientRecipeIngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "IngredientRecipeIngredient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "ingredient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "IngredientFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "quantity" } },
          { kind: "Field", name: { kind: "Name", value: "unitId" } },
          { kind: "Field", name: { kind: "Name", value: "quantityGrams" } },
          { kind: "Field", name: { kind: "Name", value: "quantityPercent" } },
          { kind: "Field", name: { kind: "Name", value: "showQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "sortOrder" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "isOutdated" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SubRecipeRecipeIngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "SubRecipeRecipeIngredient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "recipe" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RecipeFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "quantity" } },
          { kind: "Field", name: { kind: "Name", value: "unitId" } },
          { kind: "Field", name: { kind: "Name", value: "quantityGrams" } },
          { kind: "Field", name: { kind: "Name", value: "quantityPercent" } },
          { kind: "Field", name: { kind: "Name", value: "showQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "sortOrder" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "isOutdated" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RecipeIngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "RecipeIngredientItem" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "FragmentSpread", name: { kind: "Name", value: "IngredientRecipeIngredientFragment" } },
          { kind: "FragmentSpread", name: { kind: "Name", value: "SubRecipeRecipeIngredientFragment" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RecipeReferenceCostFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "RecipeReferenceCost" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "totalNet" } },
          { kind: "Field", name: { kind: "Name", value: "totalGross" } },
          { kind: "Field", name: { kind: "Name", value: "perGramNet" } },
          { kind: "Field", name: { kind: "Name", value: "perGramGross" } },
          { kind: "Field", name: { kind: "Name", value: "per100gNet" } },
          { kind: "Field", name: { kind: "Name", value: "per100gGross" } },
          { kind: "Field", name: { kind: "Name", value: "perKgNet" } },
          { kind: "Field", name: { kind: "Name", value: "perKgGross" } },
          { kind: "Field", name: { kind: "Name", value: "perServingNet" } },
          { kind: "Field", name: { kind: "Name", value: "perServingGross" } },
          { kind: "Field", name: { kind: "Name", value: "perPackageNet" } },
          { kind: "Field", name: { kind: "Name", value: "perPackageGross" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "rows" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "recipeIngredientId" } },
                { kind: "Field", name: { kind: "Name", value: "net" } },
                { kind: "Field", name: { kind: "Name", value: "gross" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RecipeDetailFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recipe" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "FragmentSpread", name: { kind: "Name", value: "RecipeFragment" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "createdBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UserBasicFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "producer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ProducerFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "photos" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "CollectionFileFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "ingredients" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RecipeIngredientFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "referenceCost" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RecipeReferenceCostFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "usedAsSubRecipeIn" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "isOutdated" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "recipe" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateRecipeIngredientVersionMutation, UpdateRecipeIngredientVersionMutationVariables>;
export const SortRecipeIngredientsByWeightDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SortRecipeIngredientsByWeight" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "recipeVersionId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Long" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sortRecipeIngredientsByWeight" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "recipeVersionId" },
                value: { kind: "Variable", name: { kind: "Name", value: "recipeVersionId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "refreshedRecipe" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RecipeDetailFragment" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "NutritionProfileFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "NutritionProfile" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "energyKj" } },
          { kind: "Field", name: { kind: "Name", value: "energyKcal" } },
          { kind: "Field", name: { kind: "Name", value: "fat" } },
          { kind: "Field", name: { kind: "Name", value: "saturatedFat" } },
          { kind: "Field", name: { kind: "Name", value: "carbohydrate" } },
          { kind: "Field", name: { kind: "Name", value: "sugars" } },
          { kind: "Field", name: { kind: "Name", value: "fibre" } },
          { kind: "Field", name: { kind: "Name", value: "protein" } },
          { kind: "Field", name: { kind: "Name", value: "salt" } },
          { kind: "Field", name: { kind: "Name", value: "alcohol" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RecipeFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recipe" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "versionId" } },
          { kind: "Field", name: { kind: "Name", value: "versionNumber" } },
          { kind: "Field", name: { kind: "Name", value: "versionStatus" } },
          { kind: "Field", name: { kind: "Name", value: "versionNotes" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "nameForLabel" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionPerServing" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionPerPackage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "weightAfterCooking" } },
          { kind: "Field", name: { kind: "Name", value: "weightAfterCookingQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "weightAfterCookingUnitId" } },
          { kind: "Field", name: { kind: "Name", value: "servingSize" } },
          { kind: "Field", name: { kind: "Name", value: "servingSizeQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "servingSizeUnitId" } },
          { kind: "Field", name: { kind: "Name", value: "servingsPerPackage" } },
          { kind: "Field", name: { kind: "Name", value: "netWeight" } },
          { kind: "Field", name: { kind: "Name", value: "netWeightQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "netWeightUnitId" } },
          { kind: "Field", name: { kind: "Name", value: "storageRequirements" } },
          { kind: "Field", name: { kind: "Name", value: "labelExportUrl" } },
          { kind: "Field", name: { kind: "Name", value: "producerId" } },
          { kind: "Field", name: { kind: "Name", value: "allergens" } },
          { kind: "Field", name: { kind: "Name", value: "photoCollectionId" } },
          { kind: "Field", name: { kind: "Name", value: "hasDraft" } },
          { kind: "Field", name: { kind: "Name", value: "hasPublishedVersion" } },
          { kind: "Field", name: { kind: "Name", value: "deleted" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserBasicFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "User" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProducerFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Producer" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "companyName" } },
          { kind: "Field", name: { kind: "Name", value: "address" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "website" } },
          { kind: "Field", name: { kind: "Name", value: "deleted" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "createdBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UserBasicFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "usedInRecipes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FileVariantFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "FileVariantInfo" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "kind" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "contentType" } },
          { kind: "Field", name: { kind: "Name", value: "sizeBytes" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CollectionFileFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CollectionFile" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "originalFilename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "variants" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "FileVariantFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "GenericIngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GenericIngredient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
          { kind: "Field", name: { kind: "Name", value: "sourceId" } },
          { kind: "Field", name: { kind: "Name", value: "nameEn" } },
          { kind: "Field", name: { kind: "Name", value: "nameBg" } },
          { kind: "Field", name: { kind: "Name", value: "nameFr" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "density" } },
          { kind: "Field", name: { kind: "Name", value: "allergens" } },
          { kind: "Field", name: { kind: "Name", value: "baseNameEn" } },
          { kind: "Field", name: { kind: "Name", value: "baseNameBg" } },
          { kind: "Field", name: { kind: "Name", value: "baseNameFr" } },
          { kind: "Field", name: { kind: "Name", value: "propertiesEn" } },
          { kind: "Field", name: { kind: "Name", value: "propertiesBg" } },
          { kind: "Field", name: { kind: "Name", value: "propertiesFr" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "foodCategory" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "nameEn" } },
                { kind: "Field", name: { kind: "Name", value: "nameBg" } },
                { kind: "Field", name: { kind: "Name", value: "nameFr" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IngredientReferencePriceFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "IngredientReferencePrice" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "quantity" } },
          { kind: "Field", name: { kind: "Name", value: "unitId" } },
          { kind: "Field", name: { kind: "Name", value: "price" } },
          { kind: "Field", name: { kind: "Name", value: "includesVat" } },
          { kind: "Field", name: { kind: "Name", value: "vatRate" } },
          { kind: "Field", name: { kind: "Name", value: "netPerGram" } },
          { kind: "Field", name: { kind: "Name", value: "grossPerGram" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Ingredient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "versionId" } },
          { kind: "Field", name: { kind: "Name", value: "versionNumber" } },
          { kind: "Field", name: { kind: "Name", value: "versionStatus" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "nameForLabel" } },
          { kind: "Field", name: { kind: "Name", value: "brand" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "density" } },
          { kind: "Field", name: { kind: "Name", value: "allergens" } },
          { kind: "Field", name: { kind: "Name", value: "nutritionReferenceQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "nutritionReferenceUnitId" } },
          { kind: "Field", name: { kind: "Name", value: "nutritionReferenceGrams" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "referenceNutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "genericIngredientId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "genericIngredient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GenericIngredientFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "photoCollectionId" } },
          { kind: "Field", name: { kind: "Name", value: "hasDraft" } },
          { kind: "Field", name: { kind: "Name", value: "hasPublishedVersion" } },
          { kind: "Field", name: { kind: "Name", value: "deleted" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "referencePrice" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "IngredientReferencePriceFragment" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "createdBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UserBasicFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "photos" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "CollectionFileFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "labelIngredients" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "parentId" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "percentage" } },
                { kind: "Field", name: { kind: "Name", value: "sortOrder" } },
                { kind: "Field", name: { kind: "Name", value: "allergens" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "usedInRecipes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "isOutdated" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "recipe" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IngredientRecipeIngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "IngredientRecipeIngredient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "ingredient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "IngredientFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "quantity" } },
          { kind: "Field", name: { kind: "Name", value: "unitId" } },
          { kind: "Field", name: { kind: "Name", value: "quantityGrams" } },
          { kind: "Field", name: { kind: "Name", value: "quantityPercent" } },
          { kind: "Field", name: { kind: "Name", value: "showQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "sortOrder" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "isOutdated" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SubRecipeRecipeIngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "SubRecipeRecipeIngredient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "recipe" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RecipeFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "quantity" } },
          { kind: "Field", name: { kind: "Name", value: "unitId" } },
          { kind: "Field", name: { kind: "Name", value: "quantityGrams" } },
          { kind: "Field", name: { kind: "Name", value: "quantityPercent" } },
          { kind: "Field", name: { kind: "Name", value: "showQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "sortOrder" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "isOutdated" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RecipeIngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "RecipeIngredientItem" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "FragmentSpread", name: { kind: "Name", value: "IngredientRecipeIngredientFragment" } },
          { kind: "FragmentSpread", name: { kind: "Name", value: "SubRecipeRecipeIngredientFragment" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RecipeReferenceCostFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "RecipeReferenceCost" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "totalNet" } },
          { kind: "Field", name: { kind: "Name", value: "totalGross" } },
          { kind: "Field", name: { kind: "Name", value: "perGramNet" } },
          { kind: "Field", name: { kind: "Name", value: "perGramGross" } },
          { kind: "Field", name: { kind: "Name", value: "per100gNet" } },
          { kind: "Field", name: { kind: "Name", value: "per100gGross" } },
          { kind: "Field", name: { kind: "Name", value: "perKgNet" } },
          { kind: "Field", name: { kind: "Name", value: "perKgGross" } },
          { kind: "Field", name: { kind: "Name", value: "perServingNet" } },
          { kind: "Field", name: { kind: "Name", value: "perServingGross" } },
          { kind: "Field", name: { kind: "Name", value: "perPackageNet" } },
          { kind: "Field", name: { kind: "Name", value: "perPackageGross" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "rows" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "recipeIngredientId" } },
                { kind: "Field", name: { kind: "Name", value: "net" } },
                { kind: "Field", name: { kind: "Name", value: "gross" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RecipeDetailFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recipe" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "FragmentSpread", name: { kind: "Name", value: "RecipeFragment" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "createdBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UserBasicFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "producer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ProducerFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "photos" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "CollectionFileFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "ingredients" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RecipeIngredientFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "referenceCost" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RecipeReferenceCostFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "usedAsSubRecipeIn" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "isOutdated" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "recipe" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SortRecipeIngredientsByWeightMutation, SortRecipeIngredientsByWeightMutationVariables>;
export const ListIngredientsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ListIngredients" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "search" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "IngredientPaginationInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "ingredients" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "search" },
                value: { kind: "Variable", name: { kind: "Name", value: "search" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ingredients" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "IngredientListFragment" } }],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "total" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IngredientListFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Ingredient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "versionStatus" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "brand" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "hasDraft" } },
          { kind: "Field", name: { kind: "Name", value: "hasPublishedVersion" } },
          { kind: "Field", name: { kind: "Name", value: "deleted" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ListIngredientsQuery, ListIngredientsQueryVariables>;
export const GetIngredientsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetIngredients" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "search" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "IngredientPaginationInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "ingredients" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "search" },
                value: { kind: "Variable", name: { kind: "Name", value: "search" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pagination" },
                value: { kind: "Variable", name: { kind: "Name", value: "pagination" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "publishedOnly" },
                value: { kind: "BooleanValue", value: true },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ingredients" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "IngredientFragment" } }],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "total" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "NutritionProfileFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "NutritionProfile" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "energyKj" } },
          { kind: "Field", name: { kind: "Name", value: "energyKcal" } },
          { kind: "Field", name: { kind: "Name", value: "fat" } },
          { kind: "Field", name: { kind: "Name", value: "saturatedFat" } },
          { kind: "Field", name: { kind: "Name", value: "carbohydrate" } },
          { kind: "Field", name: { kind: "Name", value: "sugars" } },
          { kind: "Field", name: { kind: "Name", value: "fibre" } },
          { kind: "Field", name: { kind: "Name", value: "protein" } },
          { kind: "Field", name: { kind: "Name", value: "salt" } },
          { kind: "Field", name: { kind: "Name", value: "alcohol" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "GenericIngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GenericIngredient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
          { kind: "Field", name: { kind: "Name", value: "sourceId" } },
          { kind: "Field", name: { kind: "Name", value: "nameEn" } },
          { kind: "Field", name: { kind: "Name", value: "nameBg" } },
          { kind: "Field", name: { kind: "Name", value: "nameFr" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "density" } },
          { kind: "Field", name: { kind: "Name", value: "allergens" } },
          { kind: "Field", name: { kind: "Name", value: "baseNameEn" } },
          { kind: "Field", name: { kind: "Name", value: "baseNameBg" } },
          { kind: "Field", name: { kind: "Name", value: "baseNameFr" } },
          { kind: "Field", name: { kind: "Name", value: "propertiesEn" } },
          { kind: "Field", name: { kind: "Name", value: "propertiesBg" } },
          { kind: "Field", name: { kind: "Name", value: "propertiesFr" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "foodCategory" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "nameEn" } },
                { kind: "Field", name: { kind: "Name", value: "nameBg" } },
                { kind: "Field", name: { kind: "Name", value: "nameFr" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IngredientReferencePriceFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "IngredientReferencePrice" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "quantity" } },
          { kind: "Field", name: { kind: "Name", value: "unitId" } },
          { kind: "Field", name: { kind: "Name", value: "price" } },
          { kind: "Field", name: { kind: "Name", value: "includesVat" } },
          { kind: "Field", name: { kind: "Name", value: "vatRate" } },
          { kind: "Field", name: { kind: "Name", value: "netPerGram" } },
          { kind: "Field", name: { kind: "Name", value: "grossPerGram" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserBasicFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "User" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FileVariantFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "FileVariantInfo" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "kind" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "contentType" } },
          { kind: "Field", name: { kind: "Name", value: "sizeBytes" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CollectionFileFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CollectionFile" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "originalFilename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "variants" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "FileVariantFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Ingredient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "versionId" } },
          { kind: "Field", name: { kind: "Name", value: "versionNumber" } },
          { kind: "Field", name: { kind: "Name", value: "versionStatus" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "nameForLabel" } },
          { kind: "Field", name: { kind: "Name", value: "brand" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "density" } },
          { kind: "Field", name: { kind: "Name", value: "allergens" } },
          { kind: "Field", name: { kind: "Name", value: "nutritionReferenceQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "nutritionReferenceUnitId" } },
          { kind: "Field", name: { kind: "Name", value: "nutritionReferenceGrams" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "referenceNutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "genericIngredientId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "genericIngredient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GenericIngredientFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "photoCollectionId" } },
          { kind: "Field", name: { kind: "Name", value: "hasDraft" } },
          { kind: "Field", name: { kind: "Name", value: "hasPublishedVersion" } },
          { kind: "Field", name: { kind: "Name", value: "deleted" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "referencePrice" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "IngredientReferencePriceFragment" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "createdBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UserBasicFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "photos" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "CollectionFileFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "labelIngredients" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "parentId" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "percentage" } },
                { kind: "Field", name: { kind: "Name", value: "sortOrder" } },
                { kind: "Field", name: { kind: "Name", value: "allergens" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "usedInRecipes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "isOutdated" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "recipe" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetIngredientsQuery, GetIngredientsQueryVariables>;
export const CreateIngredientDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateIngredient" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "CreateIngredientInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createIngredient" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "IngredientFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "NutritionProfileFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "NutritionProfile" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "energyKj" } },
          { kind: "Field", name: { kind: "Name", value: "energyKcal" } },
          { kind: "Field", name: { kind: "Name", value: "fat" } },
          { kind: "Field", name: { kind: "Name", value: "saturatedFat" } },
          { kind: "Field", name: { kind: "Name", value: "carbohydrate" } },
          { kind: "Field", name: { kind: "Name", value: "sugars" } },
          { kind: "Field", name: { kind: "Name", value: "fibre" } },
          { kind: "Field", name: { kind: "Name", value: "protein" } },
          { kind: "Field", name: { kind: "Name", value: "salt" } },
          { kind: "Field", name: { kind: "Name", value: "alcohol" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "GenericIngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GenericIngredient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
          { kind: "Field", name: { kind: "Name", value: "sourceId" } },
          { kind: "Field", name: { kind: "Name", value: "nameEn" } },
          { kind: "Field", name: { kind: "Name", value: "nameBg" } },
          { kind: "Field", name: { kind: "Name", value: "nameFr" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "density" } },
          { kind: "Field", name: { kind: "Name", value: "allergens" } },
          { kind: "Field", name: { kind: "Name", value: "baseNameEn" } },
          { kind: "Field", name: { kind: "Name", value: "baseNameBg" } },
          { kind: "Field", name: { kind: "Name", value: "baseNameFr" } },
          { kind: "Field", name: { kind: "Name", value: "propertiesEn" } },
          { kind: "Field", name: { kind: "Name", value: "propertiesBg" } },
          { kind: "Field", name: { kind: "Name", value: "propertiesFr" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "foodCategory" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "nameEn" } },
                { kind: "Field", name: { kind: "Name", value: "nameBg" } },
                { kind: "Field", name: { kind: "Name", value: "nameFr" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IngredientReferencePriceFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "IngredientReferencePrice" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "quantity" } },
          { kind: "Field", name: { kind: "Name", value: "unitId" } },
          { kind: "Field", name: { kind: "Name", value: "price" } },
          { kind: "Field", name: { kind: "Name", value: "includesVat" } },
          { kind: "Field", name: { kind: "Name", value: "vatRate" } },
          { kind: "Field", name: { kind: "Name", value: "netPerGram" } },
          { kind: "Field", name: { kind: "Name", value: "grossPerGram" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserBasicFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "User" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FileVariantFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "FileVariantInfo" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "kind" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "contentType" } },
          { kind: "Field", name: { kind: "Name", value: "sizeBytes" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CollectionFileFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CollectionFile" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "originalFilename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "variants" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "FileVariantFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Ingredient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "versionId" } },
          { kind: "Field", name: { kind: "Name", value: "versionNumber" } },
          { kind: "Field", name: { kind: "Name", value: "versionStatus" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "nameForLabel" } },
          { kind: "Field", name: { kind: "Name", value: "brand" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "density" } },
          { kind: "Field", name: { kind: "Name", value: "allergens" } },
          { kind: "Field", name: { kind: "Name", value: "nutritionReferenceQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "nutritionReferenceUnitId" } },
          { kind: "Field", name: { kind: "Name", value: "nutritionReferenceGrams" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "referenceNutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "genericIngredientId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "genericIngredient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GenericIngredientFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "photoCollectionId" } },
          { kind: "Field", name: { kind: "Name", value: "hasDraft" } },
          { kind: "Field", name: { kind: "Name", value: "hasPublishedVersion" } },
          { kind: "Field", name: { kind: "Name", value: "deleted" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "referencePrice" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "IngredientReferencePriceFragment" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "createdBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UserBasicFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "photos" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "CollectionFileFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "labelIngredients" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "parentId" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "percentage" } },
                { kind: "Field", name: { kind: "Name", value: "sortOrder" } },
                { kind: "Field", name: { kind: "Name", value: "allergens" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "usedInRecipes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "isOutdated" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "recipe" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateIngredientMutation, CreateIngredientMutationVariables>;
export const GetIngredientDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetIngredient" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Long" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "draftIngredient" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "IngredientFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "publishedIngredient" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "IngredientFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "NutritionProfileFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "NutritionProfile" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "energyKj" } },
          { kind: "Field", name: { kind: "Name", value: "energyKcal" } },
          { kind: "Field", name: { kind: "Name", value: "fat" } },
          { kind: "Field", name: { kind: "Name", value: "saturatedFat" } },
          { kind: "Field", name: { kind: "Name", value: "carbohydrate" } },
          { kind: "Field", name: { kind: "Name", value: "sugars" } },
          { kind: "Field", name: { kind: "Name", value: "fibre" } },
          { kind: "Field", name: { kind: "Name", value: "protein" } },
          { kind: "Field", name: { kind: "Name", value: "salt" } },
          { kind: "Field", name: { kind: "Name", value: "alcohol" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "GenericIngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GenericIngredient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
          { kind: "Field", name: { kind: "Name", value: "sourceId" } },
          { kind: "Field", name: { kind: "Name", value: "nameEn" } },
          { kind: "Field", name: { kind: "Name", value: "nameBg" } },
          { kind: "Field", name: { kind: "Name", value: "nameFr" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "density" } },
          { kind: "Field", name: { kind: "Name", value: "allergens" } },
          { kind: "Field", name: { kind: "Name", value: "baseNameEn" } },
          { kind: "Field", name: { kind: "Name", value: "baseNameBg" } },
          { kind: "Field", name: { kind: "Name", value: "baseNameFr" } },
          { kind: "Field", name: { kind: "Name", value: "propertiesEn" } },
          { kind: "Field", name: { kind: "Name", value: "propertiesBg" } },
          { kind: "Field", name: { kind: "Name", value: "propertiesFr" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "foodCategory" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "nameEn" } },
                { kind: "Field", name: { kind: "Name", value: "nameBg" } },
                { kind: "Field", name: { kind: "Name", value: "nameFr" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IngredientReferencePriceFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "IngredientReferencePrice" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "quantity" } },
          { kind: "Field", name: { kind: "Name", value: "unitId" } },
          { kind: "Field", name: { kind: "Name", value: "price" } },
          { kind: "Field", name: { kind: "Name", value: "includesVat" } },
          { kind: "Field", name: { kind: "Name", value: "vatRate" } },
          { kind: "Field", name: { kind: "Name", value: "netPerGram" } },
          { kind: "Field", name: { kind: "Name", value: "grossPerGram" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserBasicFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "User" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FileVariantFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "FileVariantInfo" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "kind" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "contentType" } },
          { kind: "Field", name: { kind: "Name", value: "sizeBytes" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CollectionFileFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CollectionFile" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "originalFilename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "variants" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "FileVariantFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Ingredient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "versionId" } },
          { kind: "Field", name: { kind: "Name", value: "versionNumber" } },
          { kind: "Field", name: { kind: "Name", value: "versionStatus" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "nameForLabel" } },
          { kind: "Field", name: { kind: "Name", value: "brand" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "density" } },
          { kind: "Field", name: { kind: "Name", value: "allergens" } },
          { kind: "Field", name: { kind: "Name", value: "nutritionReferenceQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "nutritionReferenceUnitId" } },
          { kind: "Field", name: { kind: "Name", value: "nutritionReferenceGrams" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "referenceNutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "genericIngredientId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "genericIngredient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GenericIngredientFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "photoCollectionId" } },
          { kind: "Field", name: { kind: "Name", value: "hasDraft" } },
          { kind: "Field", name: { kind: "Name", value: "hasPublishedVersion" } },
          { kind: "Field", name: { kind: "Name", value: "deleted" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "referencePrice" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "IngredientReferencePriceFragment" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "createdBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UserBasicFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "photos" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "CollectionFileFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "labelIngredients" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "parentId" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "percentage" } },
                { kind: "Field", name: { kind: "Name", value: "sortOrder" } },
                { kind: "Field", name: { kind: "Name", value: "allergens" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "usedInRecipes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "isOutdated" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "recipe" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetIngredientQuery, GetIngredientQueryVariables>;
export const GetIngredientByVersionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetIngredientByVersion" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Long" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "versionNumber" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "ingredientByVersion" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "versionNumber" },
                value: { kind: "Variable", name: { kind: "Name", value: "versionNumber" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "IngredientFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "NutritionProfileFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "NutritionProfile" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "energyKj" } },
          { kind: "Field", name: { kind: "Name", value: "energyKcal" } },
          { kind: "Field", name: { kind: "Name", value: "fat" } },
          { kind: "Field", name: { kind: "Name", value: "saturatedFat" } },
          { kind: "Field", name: { kind: "Name", value: "carbohydrate" } },
          { kind: "Field", name: { kind: "Name", value: "sugars" } },
          { kind: "Field", name: { kind: "Name", value: "fibre" } },
          { kind: "Field", name: { kind: "Name", value: "protein" } },
          { kind: "Field", name: { kind: "Name", value: "salt" } },
          { kind: "Field", name: { kind: "Name", value: "alcohol" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "GenericIngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GenericIngredient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
          { kind: "Field", name: { kind: "Name", value: "sourceId" } },
          { kind: "Field", name: { kind: "Name", value: "nameEn" } },
          { kind: "Field", name: { kind: "Name", value: "nameBg" } },
          { kind: "Field", name: { kind: "Name", value: "nameFr" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "density" } },
          { kind: "Field", name: { kind: "Name", value: "allergens" } },
          { kind: "Field", name: { kind: "Name", value: "baseNameEn" } },
          { kind: "Field", name: { kind: "Name", value: "baseNameBg" } },
          { kind: "Field", name: { kind: "Name", value: "baseNameFr" } },
          { kind: "Field", name: { kind: "Name", value: "propertiesEn" } },
          { kind: "Field", name: { kind: "Name", value: "propertiesBg" } },
          { kind: "Field", name: { kind: "Name", value: "propertiesFr" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "foodCategory" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "nameEn" } },
                { kind: "Field", name: { kind: "Name", value: "nameBg" } },
                { kind: "Field", name: { kind: "Name", value: "nameFr" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IngredientReferencePriceFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "IngredientReferencePrice" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "quantity" } },
          { kind: "Field", name: { kind: "Name", value: "unitId" } },
          { kind: "Field", name: { kind: "Name", value: "price" } },
          { kind: "Field", name: { kind: "Name", value: "includesVat" } },
          { kind: "Field", name: { kind: "Name", value: "vatRate" } },
          { kind: "Field", name: { kind: "Name", value: "netPerGram" } },
          { kind: "Field", name: { kind: "Name", value: "grossPerGram" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserBasicFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "User" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FileVariantFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "FileVariantInfo" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "kind" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "contentType" } },
          { kind: "Field", name: { kind: "Name", value: "sizeBytes" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CollectionFileFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CollectionFile" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "originalFilename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "variants" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "FileVariantFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Ingredient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "versionId" } },
          { kind: "Field", name: { kind: "Name", value: "versionNumber" } },
          { kind: "Field", name: { kind: "Name", value: "versionStatus" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "nameForLabel" } },
          { kind: "Field", name: { kind: "Name", value: "brand" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "density" } },
          { kind: "Field", name: { kind: "Name", value: "allergens" } },
          { kind: "Field", name: { kind: "Name", value: "nutritionReferenceQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "nutritionReferenceUnitId" } },
          { kind: "Field", name: { kind: "Name", value: "nutritionReferenceGrams" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "referenceNutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "genericIngredientId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "genericIngredient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GenericIngredientFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "photoCollectionId" } },
          { kind: "Field", name: { kind: "Name", value: "hasDraft" } },
          { kind: "Field", name: { kind: "Name", value: "hasPublishedVersion" } },
          { kind: "Field", name: { kind: "Name", value: "deleted" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "referencePrice" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "IngredientReferencePriceFragment" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "createdBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UserBasicFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "photos" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "CollectionFileFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "labelIngredients" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "parentId" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "percentage" } },
                { kind: "Field", name: { kind: "Name", value: "sortOrder" } },
                { kind: "Field", name: { kind: "Name", value: "allergens" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "usedInRecipes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "isOutdated" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "recipe" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetIngredientByVersionQuery, GetIngredientByVersionQueryVariables>;
export const UpdateIngredientDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateIngredient" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Long" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UpdateIngredientInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateIngredient" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "refreshedIngredient" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "IngredientFragment" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "NutritionProfileFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "NutritionProfile" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "energyKj" } },
          { kind: "Field", name: { kind: "Name", value: "energyKcal" } },
          { kind: "Field", name: { kind: "Name", value: "fat" } },
          { kind: "Field", name: { kind: "Name", value: "saturatedFat" } },
          { kind: "Field", name: { kind: "Name", value: "carbohydrate" } },
          { kind: "Field", name: { kind: "Name", value: "sugars" } },
          { kind: "Field", name: { kind: "Name", value: "fibre" } },
          { kind: "Field", name: { kind: "Name", value: "protein" } },
          { kind: "Field", name: { kind: "Name", value: "salt" } },
          { kind: "Field", name: { kind: "Name", value: "alcohol" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "GenericIngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GenericIngredient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
          { kind: "Field", name: { kind: "Name", value: "sourceId" } },
          { kind: "Field", name: { kind: "Name", value: "nameEn" } },
          { kind: "Field", name: { kind: "Name", value: "nameBg" } },
          { kind: "Field", name: { kind: "Name", value: "nameFr" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "density" } },
          { kind: "Field", name: { kind: "Name", value: "allergens" } },
          { kind: "Field", name: { kind: "Name", value: "baseNameEn" } },
          { kind: "Field", name: { kind: "Name", value: "baseNameBg" } },
          { kind: "Field", name: { kind: "Name", value: "baseNameFr" } },
          { kind: "Field", name: { kind: "Name", value: "propertiesEn" } },
          { kind: "Field", name: { kind: "Name", value: "propertiesBg" } },
          { kind: "Field", name: { kind: "Name", value: "propertiesFr" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "foodCategory" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "nameEn" } },
                { kind: "Field", name: { kind: "Name", value: "nameBg" } },
                { kind: "Field", name: { kind: "Name", value: "nameFr" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IngredientReferencePriceFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "IngredientReferencePrice" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "quantity" } },
          { kind: "Field", name: { kind: "Name", value: "unitId" } },
          { kind: "Field", name: { kind: "Name", value: "price" } },
          { kind: "Field", name: { kind: "Name", value: "includesVat" } },
          { kind: "Field", name: { kind: "Name", value: "vatRate" } },
          { kind: "Field", name: { kind: "Name", value: "netPerGram" } },
          { kind: "Field", name: { kind: "Name", value: "grossPerGram" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserBasicFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "User" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FileVariantFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "FileVariantInfo" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "kind" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "contentType" } },
          { kind: "Field", name: { kind: "Name", value: "sizeBytes" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CollectionFileFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CollectionFile" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "originalFilename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "variants" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "FileVariantFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Ingredient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "versionId" } },
          { kind: "Field", name: { kind: "Name", value: "versionNumber" } },
          { kind: "Field", name: { kind: "Name", value: "versionStatus" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "nameForLabel" } },
          { kind: "Field", name: { kind: "Name", value: "brand" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "density" } },
          { kind: "Field", name: { kind: "Name", value: "allergens" } },
          { kind: "Field", name: { kind: "Name", value: "nutritionReferenceQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "nutritionReferenceUnitId" } },
          { kind: "Field", name: { kind: "Name", value: "nutritionReferenceGrams" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "referenceNutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "genericIngredientId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "genericIngredient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GenericIngredientFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "photoCollectionId" } },
          { kind: "Field", name: { kind: "Name", value: "hasDraft" } },
          { kind: "Field", name: { kind: "Name", value: "hasPublishedVersion" } },
          { kind: "Field", name: { kind: "Name", value: "deleted" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "referencePrice" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "IngredientReferencePriceFragment" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "createdBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UserBasicFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "photos" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "CollectionFileFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "labelIngredients" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "parentId" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "percentage" } },
                { kind: "Field", name: { kind: "Name", value: "sortOrder" } },
                { kind: "Field", name: { kind: "Name", value: "allergens" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "usedInRecipes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "isOutdated" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "recipe" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateIngredientMutation, UpdateIngredientMutationVariables>;
export const SetIngredientReferencePriceDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SetIngredientReferencePrice" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "ingredientId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Long" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SetIngredientReferencePriceInput" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "setIngredientReferencePrice" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "ingredientId" },
                value: { kind: "Variable", name: { kind: "Name", value: "ingredientId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "refreshedIngredient" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "IngredientFragment" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "NutritionProfileFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "NutritionProfile" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "energyKj" } },
          { kind: "Field", name: { kind: "Name", value: "energyKcal" } },
          { kind: "Field", name: { kind: "Name", value: "fat" } },
          { kind: "Field", name: { kind: "Name", value: "saturatedFat" } },
          { kind: "Field", name: { kind: "Name", value: "carbohydrate" } },
          { kind: "Field", name: { kind: "Name", value: "sugars" } },
          { kind: "Field", name: { kind: "Name", value: "fibre" } },
          { kind: "Field", name: { kind: "Name", value: "protein" } },
          { kind: "Field", name: { kind: "Name", value: "salt" } },
          { kind: "Field", name: { kind: "Name", value: "alcohol" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "GenericIngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GenericIngredient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
          { kind: "Field", name: { kind: "Name", value: "sourceId" } },
          { kind: "Field", name: { kind: "Name", value: "nameEn" } },
          { kind: "Field", name: { kind: "Name", value: "nameBg" } },
          { kind: "Field", name: { kind: "Name", value: "nameFr" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "density" } },
          { kind: "Field", name: { kind: "Name", value: "allergens" } },
          { kind: "Field", name: { kind: "Name", value: "baseNameEn" } },
          { kind: "Field", name: { kind: "Name", value: "baseNameBg" } },
          { kind: "Field", name: { kind: "Name", value: "baseNameFr" } },
          { kind: "Field", name: { kind: "Name", value: "propertiesEn" } },
          { kind: "Field", name: { kind: "Name", value: "propertiesBg" } },
          { kind: "Field", name: { kind: "Name", value: "propertiesFr" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "foodCategory" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "nameEn" } },
                { kind: "Field", name: { kind: "Name", value: "nameBg" } },
                { kind: "Field", name: { kind: "Name", value: "nameFr" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IngredientReferencePriceFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "IngredientReferencePrice" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "quantity" } },
          { kind: "Field", name: { kind: "Name", value: "unitId" } },
          { kind: "Field", name: { kind: "Name", value: "price" } },
          { kind: "Field", name: { kind: "Name", value: "includesVat" } },
          { kind: "Field", name: { kind: "Name", value: "vatRate" } },
          { kind: "Field", name: { kind: "Name", value: "netPerGram" } },
          { kind: "Field", name: { kind: "Name", value: "grossPerGram" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserBasicFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "User" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FileVariantFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "FileVariantInfo" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "kind" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "contentType" } },
          { kind: "Field", name: { kind: "Name", value: "sizeBytes" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CollectionFileFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CollectionFile" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "originalFilename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "variants" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "FileVariantFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Ingredient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "versionId" } },
          { kind: "Field", name: { kind: "Name", value: "versionNumber" } },
          { kind: "Field", name: { kind: "Name", value: "versionStatus" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "nameForLabel" } },
          { kind: "Field", name: { kind: "Name", value: "brand" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "density" } },
          { kind: "Field", name: { kind: "Name", value: "allergens" } },
          { kind: "Field", name: { kind: "Name", value: "nutritionReferenceQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "nutritionReferenceUnitId" } },
          { kind: "Field", name: { kind: "Name", value: "nutritionReferenceGrams" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "referenceNutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "genericIngredientId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "genericIngredient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GenericIngredientFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "photoCollectionId" } },
          { kind: "Field", name: { kind: "Name", value: "hasDraft" } },
          { kind: "Field", name: { kind: "Name", value: "hasPublishedVersion" } },
          { kind: "Field", name: { kind: "Name", value: "deleted" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "referencePrice" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "IngredientReferencePriceFragment" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "createdBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UserBasicFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "photos" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "CollectionFileFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "labelIngredients" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "parentId" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "percentage" } },
                { kind: "Field", name: { kind: "Name", value: "sortOrder" } },
                { kind: "Field", name: { kind: "Name", value: "allergens" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "usedInRecipes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "isOutdated" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "recipe" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SetIngredientReferencePriceMutation, SetIngredientReferencePriceMutationVariables>;
export const PublishIngredientDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "PublishIngredient" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Long" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "notes" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "publishIngredient" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "notes" },
                value: { kind: "Variable", name: { kind: "Name", value: "notes" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "refreshedIngredient" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "IngredientFragment" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "NutritionProfileFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "NutritionProfile" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "energyKj" } },
          { kind: "Field", name: { kind: "Name", value: "energyKcal" } },
          { kind: "Field", name: { kind: "Name", value: "fat" } },
          { kind: "Field", name: { kind: "Name", value: "saturatedFat" } },
          { kind: "Field", name: { kind: "Name", value: "carbohydrate" } },
          { kind: "Field", name: { kind: "Name", value: "sugars" } },
          { kind: "Field", name: { kind: "Name", value: "fibre" } },
          { kind: "Field", name: { kind: "Name", value: "protein" } },
          { kind: "Field", name: { kind: "Name", value: "salt" } },
          { kind: "Field", name: { kind: "Name", value: "alcohol" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "GenericIngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GenericIngredient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
          { kind: "Field", name: { kind: "Name", value: "sourceId" } },
          { kind: "Field", name: { kind: "Name", value: "nameEn" } },
          { kind: "Field", name: { kind: "Name", value: "nameBg" } },
          { kind: "Field", name: { kind: "Name", value: "nameFr" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "density" } },
          { kind: "Field", name: { kind: "Name", value: "allergens" } },
          { kind: "Field", name: { kind: "Name", value: "baseNameEn" } },
          { kind: "Field", name: { kind: "Name", value: "baseNameBg" } },
          { kind: "Field", name: { kind: "Name", value: "baseNameFr" } },
          { kind: "Field", name: { kind: "Name", value: "propertiesEn" } },
          { kind: "Field", name: { kind: "Name", value: "propertiesBg" } },
          { kind: "Field", name: { kind: "Name", value: "propertiesFr" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "foodCategory" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "nameEn" } },
                { kind: "Field", name: { kind: "Name", value: "nameBg" } },
                { kind: "Field", name: { kind: "Name", value: "nameFr" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IngredientReferencePriceFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "IngredientReferencePrice" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "quantity" } },
          { kind: "Field", name: { kind: "Name", value: "unitId" } },
          { kind: "Field", name: { kind: "Name", value: "price" } },
          { kind: "Field", name: { kind: "Name", value: "includesVat" } },
          { kind: "Field", name: { kind: "Name", value: "vatRate" } },
          { kind: "Field", name: { kind: "Name", value: "netPerGram" } },
          { kind: "Field", name: { kind: "Name", value: "grossPerGram" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserBasicFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "User" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FileVariantFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "FileVariantInfo" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "kind" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "contentType" } },
          { kind: "Field", name: { kind: "Name", value: "sizeBytes" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CollectionFileFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CollectionFile" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "originalFilename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "variants" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "FileVariantFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Ingredient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "versionId" } },
          { kind: "Field", name: { kind: "Name", value: "versionNumber" } },
          { kind: "Field", name: { kind: "Name", value: "versionStatus" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "nameForLabel" } },
          { kind: "Field", name: { kind: "Name", value: "brand" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "density" } },
          { kind: "Field", name: { kind: "Name", value: "allergens" } },
          { kind: "Field", name: { kind: "Name", value: "nutritionReferenceQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "nutritionReferenceUnitId" } },
          { kind: "Field", name: { kind: "Name", value: "nutritionReferenceGrams" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "referenceNutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "genericIngredientId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "genericIngredient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GenericIngredientFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "photoCollectionId" } },
          { kind: "Field", name: { kind: "Name", value: "hasDraft" } },
          { kind: "Field", name: { kind: "Name", value: "hasPublishedVersion" } },
          { kind: "Field", name: { kind: "Name", value: "deleted" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "referencePrice" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "IngredientReferencePriceFragment" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "createdBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UserBasicFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "photos" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "CollectionFileFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "labelIngredients" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "parentId" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "percentage" } },
                { kind: "Field", name: { kind: "Name", value: "sortOrder" } },
                { kind: "Field", name: { kind: "Name", value: "allergens" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "usedInRecipes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "isOutdated" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "recipe" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PublishIngredientMutation, PublishIngredientMutationVariables>;
export const CreateIngredientDraftDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateIngredientDraft" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Long" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createIngredientDraft" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "refreshedIngredient" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "IngredientFragment" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "NutritionProfileFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "NutritionProfile" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "energyKj" } },
          { kind: "Field", name: { kind: "Name", value: "energyKcal" } },
          { kind: "Field", name: { kind: "Name", value: "fat" } },
          { kind: "Field", name: { kind: "Name", value: "saturatedFat" } },
          { kind: "Field", name: { kind: "Name", value: "carbohydrate" } },
          { kind: "Field", name: { kind: "Name", value: "sugars" } },
          { kind: "Field", name: { kind: "Name", value: "fibre" } },
          { kind: "Field", name: { kind: "Name", value: "protein" } },
          { kind: "Field", name: { kind: "Name", value: "salt" } },
          { kind: "Field", name: { kind: "Name", value: "alcohol" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "GenericIngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GenericIngredient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
          { kind: "Field", name: { kind: "Name", value: "sourceId" } },
          { kind: "Field", name: { kind: "Name", value: "nameEn" } },
          { kind: "Field", name: { kind: "Name", value: "nameBg" } },
          { kind: "Field", name: { kind: "Name", value: "nameFr" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "density" } },
          { kind: "Field", name: { kind: "Name", value: "allergens" } },
          { kind: "Field", name: { kind: "Name", value: "baseNameEn" } },
          { kind: "Field", name: { kind: "Name", value: "baseNameBg" } },
          { kind: "Field", name: { kind: "Name", value: "baseNameFr" } },
          { kind: "Field", name: { kind: "Name", value: "propertiesEn" } },
          { kind: "Field", name: { kind: "Name", value: "propertiesBg" } },
          { kind: "Field", name: { kind: "Name", value: "propertiesFr" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "foodCategory" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "nameEn" } },
                { kind: "Field", name: { kind: "Name", value: "nameBg" } },
                { kind: "Field", name: { kind: "Name", value: "nameFr" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IngredientReferencePriceFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "IngredientReferencePrice" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "quantity" } },
          { kind: "Field", name: { kind: "Name", value: "unitId" } },
          { kind: "Field", name: { kind: "Name", value: "price" } },
          { kind: "Field", name: { kind: "Name", value: "includesVat" } },
          { kind: "Field", name: { kind: "Name", value: "vatRate" } },
          { kind: "Field", name: { kind: "Name", value: "netPerGram" } },
          { kind: "Field", name: { kind: "Name", value: "grossPerGram" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserBasicFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "User" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FileVariantFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "FileVariantInfo" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "kind" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "contentType" } },
          { kind: "Field", name: { kind: "Name", value: "sizeBytes" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CollectionFileFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CollectionFile" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "originalFilename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "variants" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "FileVariantFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Ingredient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "versionId" } },
          { kind: "Field", name: { kind: "Name", value: "versionNumber" } },
          { kind: "Field", name: { kind: "Name", value: "versionStatus" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "nameForLabel" } },
          { kind: "Field", name: { kind: "Name", value: "brand" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "density" } },
          { kind: "Field", name: { kind: "Name", value: "allergens" } },
          { kind: "Field", name: { kind: "Name", value: "nutritionReferenceQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "nutritionReferenceUnitId" } },
          { kind: "Field", name: { kind: "Name", value: "nutritionReferenceGrams" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "referenceNutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "genericIngredientId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "genericIngredient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GenericIngredientFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "photoCollectionId" } },
          { kind: "Field", name: { kind: "Name", value: "hasDraft" } },
          { kind: "Field", name: { kind: "Name", value: "hasPublishedVersion" } },
          { kind: "Field", name: { kind: "Name", value: "deleted" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "referencePrice" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "IngredientReferencePriceFragment" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "createdBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UserBasicFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "photos" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "CollectionFileFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "labelIngredients" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "parentId" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "percentage" } },
                { kind: "Field", name: { kind: "Name", value: "sortOrder" } },
                { kind: "Field", name: { kind: "Name", value: "allergens" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "usedInRecipes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "isOutdated" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "recipe" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateIngredientDraftMutation, CreateIngredientDraftMutationVariables>;
export const DiscardIngredientDraftDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DiscardIngredientDraft" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Long" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "discardIngredientDraft" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DiscardIngredientDraftMutation, DiscardIngredientDraftMutationVariables>;
export const AddFileToCollectionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AddFileToCollection" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "collectionId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Long" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "stagingFileId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Long" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "addFileToCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "collectionId" },
                value: { kind: "Variable", name: { kind: "Name", value: "collectionId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "stagingFileId" },
                value: { kind: "Variable", name: { kind: "Name", value: "stagingFileId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "CollectionFileFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FileVariantFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "FileVariantInfo" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "kind" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "contentType" } },
          { kind: "Field", name: { kind: "Name", value: "sizeBytes" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CollectionFileFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CollectionFile" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "originalFilename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "variants" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "FileVariantFragment" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AddFileToCollectionMutation, AddFileToCollectionMutationVariables>;
export const RemoveFileFromCollectionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "RemoveFileFromCollection" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "collectionId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Long" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "fileId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Long" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "removeFileFromCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "collectionId" },
                value: { kind: "Variable", name: { kind: "Name", value: "collectionId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "fileId" },
                value: { kind: "Variable", name: { kind: "Name", value: "fileId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "CollectionFileFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FileVariantFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "FileVariantInfo" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "kind" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "contentType" } },
          { kind: "Field", name: { kind: "Name", value: "sizeBytes" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CollectionFileFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CollectionFile" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "originalFilename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "variants" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "FileVariantFragment" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RemoveFileFromCollectionMutation, RemoveFileFromCollectionMutationVariables>;
export const AddLabelIngredientDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AddLabelIngredient" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "ingredientId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Long" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "AddLabelIngredientInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "addLabelIngredient" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "ingredientId" },
                value: { kind: "Variable", name: { kind: "Name", value: "ingredientId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "refreshedIngredient" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "IngredientFragment" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "NutritionProfileFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "NutritionProfile" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "energyKj" } },
          { kind: "Field", name: { kind: "Name", value: "energyKcal" } },
          { kind: "Field", name: { kind: "Name", value: "fat" } },
          { kind: "Field", name: { kind: "Name", value: "saturatedFat" } },
          { kind: "Field", name: { kind: "Name", value: "carbohydrate" } },
          { kind: "Field", name: { kind: "Name", value: "sugars" } },
          { kind: "Field", name: { kind: "Name", value: "fibre" } },
          { kind: "Field", name: { kind: "Name", value: "protein" } },
          { kind: "Field", name: { kind: "Name", value: "salt" } },
          { kind: "Field", name: { kind: "Name", value: "alcohol" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "GenericIngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GenericIngredient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
          { kind: "Field", name: { kind: "Name", value: "sourceId" } },
          { kind: "Field", name: { kind: "Name", value: "nameEn" } },
          { kind: "Field", name: { kind: "Name", value: "nameBg" } },
          { kind: "Field", name: { kind: "Name", value: "nameFr" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "density" } },
          { kind: "Field", name: { kind: "Name", value: "allergens" } },
          { kind: "Field", name: { kind: "Name", value: "baseNameEn" } },
          { kind: "Field", name: { kind: "Name", value: "baseNameBg" } },
          { kind: "Field", name: { kind: "Name", value: "baseNameFr" } },
          { kind: "Field", name: { kind: "Name", value: "propertiesEn" } },
          { kind: "Field", name: { kind: "Name", value: "propertiesBg" } },
          { kind: "Field", name: { kind: "Name", value: "propertiesFr" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "foodCategory" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "nameEn" } },
                { kind: "Field", name: { kind: "Name", value: "nameBg" } },
                { kind: "Field", name: { kind: "Name", value: "nameFr" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IngredientReferencePriceFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "IngredientReferencePrice" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "quantity" } },
          { kind: "Field", name: { kind: "Name", value: "unitId" } },
          { kind: "Field", name: { kind: "Name", value: "price" } },
          { kind: "Field", name: { kind: "Name", value: "includesVat" } },
          { kind: "Field", name: { kind: "Name", value: "vatRate" } },
          { kind: "Field", name: { kind: "Name", value: "netPerGram" } },
          { kind: "Field", name: { kind: "Name", value: "grossPerGram" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserBasicFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "User" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FileVariantFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "FileVariantInfo" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "kind" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "contentType" } },
          { kind: "Field", name: { kind: "Name", value: "sizeBytes" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CollectionFileFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CollectionFile" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "originalFilename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "variants" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "FileVariantFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Ingredient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "versionId" } },
          { kind: "Field", name: { kind: "Name", value: "versionNumber" } },
          { kind: "Field", name: { kind: "Name", value: "versionStatus" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "nameForLabel" } },
          { kind: "Field", name: { kind: "Name", value: "brand" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "density" } },
          { kind: "Field", name: { kind: "Name", value: "allergens" } },
          { kind: "Field", name: { kind: "Name", value: "nutritionReferenceQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "nutritionReferenceUnitId" } },
          { kind: "Field", name: { kind: "Name", value: "nutritionReferenceGrams" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "referenceNutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "genericIngredientId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "genericIngredient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GenericIngredientFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "photoCollectionId" } },
          { kind: "Field", name: { kind: "Name", value: "hasDraft" } },
          { kind: "Field", name: { kind: "Name", value: "hasPublishedVersion" } },
          { kind: "Field", name: { kind: "Name", value: "deleted" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "referencePrice" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "IngredientReferencePriceFragment" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "createdBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UserBasicFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "photos" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "CollectionFileFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "labelIngredients" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "parentId" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "percentage" } },
                { kind: "Field", name: { kind: "Name", value: "sortOrder" } },
                { kind: "Field", name: { kind: "Name", value: "allergens" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "usedInRecipes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "isOutdated" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "recipe" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AddLabelIngredientMutation, AddLabelIngredientMutationVariables>;
export const UpdateLabelIngredientDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateLabelIngredient" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "ingredientId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Long" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "labelIngredientId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Long" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UpdateLabelIngredientInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateLabelIngredient" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "ingredientId" },
                value: { kind: "Variable", name: { kind: "Name", value: "ingredientId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "labelIngredientId" },
                value: { kind: "Variable", name: { kind: "Name", value: "labelIngredientId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "refreshedIngredient" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "IngredientFragment" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "NutritionProfileFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "NutritionProfile" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "energyKj" } },
          { kind: "Field", name: { kind: "Name", value: "energyKcal" } },
          { kind: "Field", name: { kind: "Name", value: "fat" } },
          { kind: "Field", name: { kind: "Name", value: "saturatedFat" } },
          { kind: "Field", name: { kind: "Name", value: "carbohydrate" } },
          { kind: "Field", name: { kind: "Name", value: "sugars" } },
          { kind: "Field", name: { kind: "Name", value: "fibre" } },
          { kind: "Field", name: { kind: "Name", value: "protein" } },
          { kind: "Field", name: { kind: "Name", value: "salt" } },
          { kind: "Field", name: { kind: "Name", value: "alcohol" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "GenericIngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GenericIngredient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
          { kind: "Field", name: { kind: "Name", value: "sourceId" } },
          { kind: "Field", name: { kind: "Name", value: "nameEn" } },
          { kind: "Field", name: { kind: "Name", value: "nameBg" } },
          { kind: "Field", name: { kind: "Name", value: "nameFr" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "density" } },
          { kind: "Field", name: { kind: "Name", value: "allergens" } },
          { kind: "Field", name: { kind: "Name", value: "baseNameEn" } },
          { kind: "Field", name: { kind: "Name", value: "baseNameBg" } },
          { kind: "Field", name: { kind: "Name", value: "baseNameFr" } },
          { kind: "Field", name: { kind: "Name", value: "propertiesEn" } },
          { kind: "Field", name: { kind: "Name", value: "propertiesBg" } },
          { kind: "Field", name: { kind: "Name", value: "propertiesFr" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "foodCategory" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "nameEn" } },
                { kind: "Field", name: { kind: "Name", value: "nameBg" } },
                { kind: "Field", name: { kind: "Name", value: "nameFr" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IngredientReferencePriceFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "IngredientReferencePrice" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "quantity" } },
          { kind: "Field", name: { kind: "Name", value: "unitId" } },
          { kind: "Field", name: { kind: "Name", value: "price" } },
          { kind: "Field", name: { kind: "Name", value: "includesVat" } },
          { kind: "Field", name: { kind: "Name", value: "vatRate" } },
          { kind: "Field", name: { kind: "Name", value: "netPerGram" } },
          { kind: "Field", name: { kind: "Name", value: "grossPerGram" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserBasicFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "User" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FileVariantFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "FileVariantInfo" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "kind" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "contentType" } },
          { kind: "Field", name: { kind: "Name", value: "sizeBytes" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CollectionFileFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CollectionFile" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "originalFilename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "variants" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "FileVariantFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Ingredient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "versionId" } },
          { kind: "Field", name: { kind: "Name", value: "versionNumber" } },
          { kind: "Field", name: { kind: "Name", value: "versionStatus" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "nameForLabel" } },
          { kind: "Field", name: { kind: "Name", value: "brand" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "density" } },
          { kind: "Field", name: { kind: "Name", value: "allergens" } },
          { kind: "Field", name: { kind: "Name", value: "nutritionReferenceQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "nutritionReferenceUnitId" } },
          { kind: "Field", name: { kind: "Name", value: "nutritionReferenceGrams" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "referenceNutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "genericIngredientId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "genericIngredient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GenericIngredientFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "photoCollectionId" } },
          { kind: "Field", name: { kind: "Name", value: "hasDraft" } },
          { kind: "Field", name: { kind: "Name", value: "hasPublishedVersion" } },
          { kind: "Field", name: { kind: "Name", value: "deleted" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "referencePrice" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "IngredientReferencePriceFragment" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "createdBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UserBasicFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "photos" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "CollectionFileFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "labelIngredients" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "parentId" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "percentage" } },
                { kind: "Field", name: { kind: "Name", value: "sortOrder" } },
                { kind: "Field", name: { kind: "Name", value: "allergens" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "usedInRecipes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "isOutdated" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "recipe" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateLabelIngredientMutation, UpdateLabelIngredientMutationVariables>;
export const RemoveLabelIngredientDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "RemoveLabelIngredient" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "ingredientId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Long" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "labelIngredientId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Long" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "removeLabelIngredient" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "ingredientId" },
                value: { kind: "Variable", name: { kind: "Name", value: "ingredientId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "labelIngredientId" },
                value: { kind: "Variable", name: { kind: "Name", value: "labelIngredientId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "refreshedIngredient" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "IngredientFragment" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "NutritionProfileFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "NutritionProfile" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "energyKj" } },
          { kind: "Field", name: { kind: "Name", value: "energyKcal" } },
          { kind: "Field", name: { kind: "Name", value: "fat" } },
          { kind: "Field", name: { kind: "Name", value: "saturatedFat" } },
          { kind: "Field", name: { kind: "Name", value: "carbohydrate" } },
          { kind: "Field", name: { kind: "Name", value: "sugars" } },
          { kind: "Field", name: { kind: "Name", value: "fibre" } },
          { kind: "Field", name: { kind: "Name", value: "protein" } },
          { kind: "Field", name: { kind: "Name", value: "salt" } },
          { kind: "Field", name: { kind: "Name", value: "alcohol" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "GenericIngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GenericIngredient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
          { kind: "Field", name: { kind: "Name", value: "sourceId" } },
          { kind: "Field", name: { kind: "Name", value: "nameEn" } },
          { kind: "Field", name: { kind: "Name", value: "nameBg" } },
          { kind: "Field", name: { kind: "Name", value: "nameFr" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "density" } },
          { kind: "Field", name: { kind: "Name", value: "allergens" } },
          { kind: "Field", name: { kind: "Name", value: "baseNameEn" } },
          { kind: "Field", name: { kind: "Name", value: "baseNameBg" } },
          { kind: "Field", name: { kind: "Name", value: "baseNameFr" } },
          { kind: "Field", name: { kind: "Name", value: "propertiesEn" } },
          { kind: "Field", name: { kind: "Name", value: "propertiesBg" } },
          { kind: "Field", name: { kind: "Name", value: "propertiesFr" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "foodCategory" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "nameEn" } },
                { kind: "Field", name: { kind: "Name", value: "nameBg" } },
                { kind: "Field", name: { kind: "Name", value: "nameFr" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IngredientReferencePriceFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "IngredientReferencePrice" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "quantity" } },
          { kind: "Field", name: { kind: "Name", value: "unitId" } },
          { kind: "Field", name: { kind: "Name", value: "price" } },
          { kind: "Field", name: { kind: "Name", value: "includesVat" } },
          { kind: "Field", name: { kind: "Name", value: "vatRate" } },
          { kind: "Field", name: { kind: "Name", value: "netPerGram" } },
          { kind: "Field", name: { kind: "Name", value: "grossPerGram" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserBasicFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "User" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FileVariantFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "FileVariantInfo" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "kind" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "contentType" } },
          { kind: "Field", name: { kind: "Name", value: "sizeBytes" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CollectionFileFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CollectionFile" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "originalFilename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "variants" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "FileVariantFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Ingredient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "versionId" } },
          { kind: "Field", name: { kind: "Name", value: "versionNumber" } },
          { kind: "Field", name: { kind: "Name", value: "versionStatus" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "nameForLabel" } },
          { kind: "Field", name: { kind: "Name", value: "brand" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "density" } },
          { kind: "Field", name: { kind: "Name", value: "allergens" } },
          { kind: "Field", name: { kind: "Name", value: "nutritionReferenceQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "nutritionReferenceUnitId" } },
          { kind: "Field", name: { kind: "Name", value: "nutritionReferenceGrams" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "referenceNutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "genericIngredientId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "genericIngredient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GenericIngredientFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "photoCollectionId" } },
          { kind: "Field", name: { kind: "Name", value: "hasDraft" } },
          { kind: "Field", name: { kind: "Name", value: "hasPublishedVersion" } },
          { kind: "Field", name: { kind: "Name", value: "deleted" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "referencePrice" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "IngredientReferencePriceFragment" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "createdBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UserBasicFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "photos" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "CollectionFileFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "labelIngredients" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "parentId" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "percentage" } },
                { kind: "Field", name: { kind: "Name", value: "sortOrder" } },
                { kind: "Field", name: { kind: "Name", value: "allergens" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "usedInRecipes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "isOutdated" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "recipe" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RemoveLabelIngredientMutation, RemoveLabelIngredientMutationVariables>;
export const MoveLabelIngredientDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "MoveLabelIngredient" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "ingredientId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Long" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "labelIngredientId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Long" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "MoveLabelIngredientInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "moveLabelIngredient" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "ingredientId" },
                value: { kind: "Variable", name: { kind: "Name", value: "ingredientId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "labelIngredientId" },
                value: { kind: "Variable", name: { kind: "Name", value: "labelIngredientId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "refreshedIngredient" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "IngredientFragment" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "NutritionProfileFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "NutritionProfile" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "energyKj" } },
          { kind: "Field", name: { kind: "Name", value: "energyKcal" } },
          { kind: "Field", name: { kind: "Name", value: "fat" } },
          { kind: "Field", name: { kind: "Name", value: "saturatedFat" } },
          { kind: "Field", name: { kind: "Name", value: "carbohydrate" } },
          { kind: "Field", name: { kind: "Name", value: "sugars" } },
          { kind: "Field", name: { kind: "Name", value: "fibre" } },
          { kind: "Field", name: { kind: "Name", value: "protein" } },
          { kind: "Field", name: { kind: "Name", value: "salt" } },
          { kind: "Field", name: { kind: "Name", value: "alcohol" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "GenericIngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GenericIngredient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
          { kind: "Field", name: { kind: "Name", value: "sourceId" } },
          { kind: "Field", name: { kind: "Name", value: "nameEn" } },
          { kind: "Field", name: { kind: "Name", value: "nameBg" } },
          { kind: "Field", name: { kind: "Name", value: "nameFr" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "density" } },
          { kind: "Field", name: { kind: "Name", value: "allergens" } },
          { kind: "Field", name: { kind: "Name", value: "baseNameEn" } },
          { kind: "Field", name: { kind: "Name", value: "baseNameBg" } },
          { kind: "Field", name: { kind: "Name", value: "baseNameFr" } },
          { kind: "Field", name: { kind: "Name", value: "propertiesEn" } },
          { kind: "Field", name: { kind: "Name", value: "propertiesBg" } },
          { kind: "Field", name: { kind: "Name", value: "propertiesFr" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "foodCategory" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "nameEn" } },
                { kind: "Field", name: { kind: "Name", value: "nameBg" } },
                { kind: "Field", name: { kind: "Name", value: "nameFr" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IngredientReferencePriceFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "IngredientReferencePrice" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "quantity" } },
          { kind: "Field", name: { kind: "Name", value: "unitId" } },
          { kind: "Field", name: { kind: "Name", value: "price" } },
          { kind: "Field", name: { kind: "Name", value: "includesVat" } },
          { kind: "Field", name: { kind: "Name", value: "vatRate" } },
          { kind: "Field", name: { kind: "Name", value: "netPerGram" } },
          { kind: "Field", name: { kind: "Name", value: "grossPerGram" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserBasicFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "User" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FileVariantFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "FileVariantInfo" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "kind" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "contentType" } },
          { kind: "Field", name: { kind: "Name", value: "sizeBytes" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CollectionFileFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CollectionFile" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "originalFilename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "variants" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "FileVariantFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Ingredient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "versionId" } },
          { kind: "Field", name: { kind: "Name", value: "versionNumber" } },
          { kind: "Field", name: { kind: "Name", value: "versionStatus" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "nameForLabel" } },
          { kind: "Field", name: { kind: "Name", value: "brand" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "density" } },
          { kind: "Field", name: { kind: "Name", value: "allergens" } },
          { kind: "Field", name: { kind: "Name", value: "nutritionReferenceQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "nutritionReferenceUnitId" } },
          { kind: "Field", name: { kind: "Name", value: "nutritionReferenceGrams" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "referenceNutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "genericIngredientId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "genericIngredient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GenericIngredientFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "photoCollectionId" } },
          { kind: "Field", name: { kind: "Name", value: "hasDraft" } },
          { kind: "Field", name: { kind: "Name", value: "hasPublishedVersion" } },
          { kind: "Field", name: { kind: "Name", value: "deleted" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "referencePrice" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "IngredientReferencePriceFragment" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "createdBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UserBasicFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "photos" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "CollectionFileFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "labelIngredients" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "parentId" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "percentage" } },
                { kind: "Field", name: { kind: "Name", value: "sortOrder" } },
                { kind: "Field", name: { kind: "Name", value: "allergens" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "usedInRecipes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "isOutdated" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "recipe" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MoveLabelIngredientMutation, MoveLabelIngredientMutationVariables>;
export const RecognizeLabelDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "RecognizeLabel" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "ingredientId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Long" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "language" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "recognizeLabel" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "ingredientId" },
                value: { kind: "Variable", name: { kind: "Name", value: "ingredientId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "language" },
                value: { kind: "Variable", name: { kind: "Name", value: "language" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "refreshedIngredient" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "IngredientFragment" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "NutritionProfileFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "NutritionProfile" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "energyKj" } },
          { kind: "Field", name: { kind: "Name", value: "energyKcal" } },
          { kind: "Field", name: { kind: "Name", value: "fat" } },
          { kind: "Field", name: { kind: "Name", value: "saturatedFat" } },
          { kind: "Field", name: { kind: "Name", value: "carbohydrate" } },
          { kind: "Field", name: { kind: "Name", value: "sugars" } },
          { kind: "Field", name: { kind: "Name", value: "fibre" } },
          { kind: "Field", name: { kind: "Name", value: "protein" } },
          { kind: "Field", name: { kind: "Name", value: "salt" } },
          { kind: "Field", name: { kind: "Name", value: "alcohol" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "GenericIngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GenericIngredient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
          { kind: "Field", name: { kind: "Name", value: "sourceId" } },
          { kind: "Field", name: { kind: "Name", value: "nameEn" } },
          { kind: "Field", name: { kind: "Name", value: "nameBg" } },
          { kind: "Field", name: { kind: "Name", value: "nameFr" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "density" } },
          { kind: "Field", name: { kind: "Name", value: "allergens" } },
          { kind: "Field", name: { kind: "Name", value: "baseNameEn" } },
          { kind: "Field", name: { kind: "Name", value: "baseNameBg" } },
          { kind: "Field", name: { kind: "Name", value: "baseNameFr" } },
          { kind: "Field", name: { kind: "Name", value: "propertiesEn" } },
          { kind: "Field", name: { kind: "Name", value: "propertiesBg" } },
          { kind: "Field", name: { kind: "Name", value: "propertiesFr" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "foodCategory" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "nameEn" } },
                { kind: "Field", name: { kind: "Name", value: "nameBg" } },
                { kind: "Field", name: { kind: "Name", value: "nameFr" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IngredientReferencePriceFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "IngredientReferencePrice" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "quantity" } },
          { kind: "Field", name: { kind: "Name", value: "unitId" } },
          { kind: "Field", name: { kind: "Name", value: "price" } },
          { kind: "Field", name: { kind: "Name", value: "includesVat" } },
          { kind: "Field", name: { kind: "Name", value: "vatRate" } },
          { kind: "Field", name: { kind: "Name", value: "netPerGram" } },
          { kind: "Field", name: { kind: "Name", value: "grossPerGram" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserBasicFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "User" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FileVariantFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "FileVariantInfo" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "kind" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "contentType" } },
          { kind: "Field", name: { kind: "Name", value: "sizeBytes" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CollectionFileFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CollectionFile" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "originalFilename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "variants" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "FileVariantFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IngredientFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Ingredient" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "versionId" } },
          { kind: "Field", name: { kind: "Name", value: "versionNumber" } },
          { kind: "Field", name: { kind: "Name", value: "versionStatus" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "nameForLabel" } },
          { kind: "Field", name: { kind: "Name", value: "brand" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "density" } },
          { kind: "Field", name: { kind: "Name", value: "allergens" } },
          { kind: "Field", name: { kind: "Name", value: "nutritionReferenceQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "nutritionReferenceUnitId" } },
          { kind: "Field", name: { kind: "Name", value: "nutritionReferenceGrams" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "referenceNutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "genericIngredientId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "genericIngredient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GenericIngredientFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nutritionProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "NutritionProfileFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "photoCollectionId" } },
          { kind: "Field", name: { kind: "Name", value: "hasDraft" } },
          { kind: "Field", name: { kind: "Name", value: "hasPublishedVersion" } },
          { kind: "Field", name: { kind: "Name", value: "deleted" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "referencePrice" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "IngredientReferencePriceFragment" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "createdBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UserBasicFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "photos" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "CollectionFileFragment" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "labelIngredients" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "parentId" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "percentage" } },
                { kind: "Field", name: { kind: "Name", value: "sortOrder" } },
                { kind: "Field", name: { kind: "Name", value: "allergens" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "usedInRecipes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "isOutdated" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "recipe" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RecognizeLabelMutation, RecognizeLabelMutationVariables>;
export const DeleteIngredientDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeleteIngredient" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Long" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteIngredient" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteIngredientMutation, DeleteIngredientMutationVariables>;
export const RestoreIngredientDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "RestoreIngredient" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Long" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "restoreIngredient" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RestoreIngredientMutation, RestoreIngredientMutationVariables>;
export const GetRecipeDeclarationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetRecipeDeclaration" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Long" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "versionNumber" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "recipeDeclaration" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "versionNumber" },
                value: { kind: "Variable", name: { kind: "Name", value: "versionNumber" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "DeclarationFields" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DeclarationFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Declaration" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "rootIndices" } },
          { kind: "Field", name: { kind: "Name", value: "derivedAllergens" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "entries" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "allergens" } },
                { kind: "Field", name: { kind: "Name", value: "percentage" } },
                { kind: "Field", name: { kind: "Name", value: "showQuantity" } },
                { kind: "Field", name: { kind: "Name", value: "childIndices" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetRecipeDeclarationQuery, GetRecipeDeclarationQueryVariables>;
export const GetIngredientDeclarationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetIngredientDeclaration" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Long" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "versionNumber" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "ingredientDeclaration" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "versionNumber" },
                value: { kind: "Variable", name: { kind: "Name", value: "versionNumber" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "DeclarationFields" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DeclarationFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Declaration" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "rootIndices" } },
          { kind: "Field", name: { kind: "Name", value: "derivedAllergens" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "entries" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "allergens" } },
                { kind: "Field", name: { kind: "Name", value: "percentage" } },
                { kind: "Field", name: { kind: "Name", value: "showQuantity" } },
                { kind: "Field", name: { kind: "Name", value: "childIndices" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetIngredientDeclarationQuery, GetIngredientDeclarationQueryVariables>;
export const GetStagingFilesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetStagingFiles" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "stagingFiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "StagingFileItemFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FileVariantFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "FileVariantInfo" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "kind" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "contentType" } },
          { kind: "Field", name: { kind: "Name", value: "sizeBytes" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StagingFileItemFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "StagingFileItem" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "fileId" } },
          { kind: "Field", name: { kind: "Name", value: "originalFilename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "variants" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "FileVariantFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetStagingFilesQuery, GetStagingFilesQueryVariables>;
export const GenerateCameraUrlDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "GenerateCameraUrl" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [{ kind: "Field", name: { kind: "Name", value: "generateCameraUrl" } }],
      },
    },
  ],
} as unknown as DocumentNode<GenerateCameraUrlMutation, GenerateCameraUrlMutationVariables>;
export const GetStagingFileDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetStagingFile" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Long" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "stagingFile" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "StagingFileItemFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FileVariantFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "FileVariantInfo" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "kind" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "contentType" } },
          { kind: "Field", name: { kind: "Name", value: "sizeBytes" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StagingFileItemFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "StagingFileItem" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "fileId" } },
          { kind: "Field", name: { kind: "Name", value: "originalFilename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "variants" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "FileVariantFragment" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetStagingFileQuery, GetStagingFileQueryVariables>;
export const DeleteStagingFileDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeleteStagingFile" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Long" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteStagingFile" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteStagingFileMutation, DeleteStagingFileMutationVariables>;
export const GetPlanPricesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetPlanPrices" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "planPrices" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "PlanPriceFragment" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PlanPriceFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "PlanPrice" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "plan" } },
          { kind: "Field", name: { kind: "Name", value: "amount" } },
          { kind: "Field", name: { kind: "Name", value: "amountBgn" } },
          { kind: "Field", name: { kind: "Name", value: "currency" } },
          { kind: "Field", name: { kind: "Name", value: "interval" } },
          { kind: "Field", name: { kind: "Name", value: "annualSavings" } },
          { kind: "Field", name: { kind: "Name", value: "annualSavingsBgn" } },
          { kind: "Field", name: { kind: "Name", value: "monthlyEquivalent" } },
          { kind: "Field", name: { kind: "Name", value: "monthlyEquivalentBgn" } },
          { kind: "Field", name: { kind: "Name", value: "taxBehavior" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetPlanPricesQuery, GetPlanPricesQueryVariables>;
export const CreateCheckoutSessionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateCheckoutSession" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "plan" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "PlanType" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createCheckoutSession" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "plan" },
                value: { kind: "Variable", name: { kind: "Name", value: "plan" } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateCheckoutSessionMutation, CreateCheckoutSessionMutationVariables>;
export const CreateBillingPortalSessionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateBillingPortalSession" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [{ kind: "Field", name: { kind: "Name", value: "createBillingPortalSession" } }],
      },
    },
  ],
} as unknown as DocumentNode<CreateBillingPortalSessionMutation, CreateBillingPortalSessionMutationVariables>;
